// Copyright 2025-2026 Florian Gallon. All Rights reserved.
export const translations = {
  en: {
    // Header
    siteTitle: "Digi-Bakery",
    siteSubtitle: "Fresh bread baked with love",
    account: "Account",
    login: "Login",
    signup: "Sign Up",
    logout: "Logout",
    
    // Navigation
    home: "Home",
    shop: "Shop",
    myShop: "My Shop",
    myBakery: "My Bakery",
    myProduction: "My Production",
    products: "Products",
    recipes: "Recipes",
    equipment: "Equipment",
    productionDays: "Shop Schedule",
    templates: "Templates",
    productionPlanning: "Production Planning",
    productionOrder: "Production Order",
    productionOrderAndScaling: "Production Order & Scaling",
    shoppingList: "Shopping List",
    orders: "Orders",
    myOrders: "My Orders",
    reports: "Reports",
    salesReports: "Sales Reports",
    wasteReport: "Waste Report",
    shopAnalytics: "Shop Visitors",
    shopAnalyticsTitle: "Shop Visitor Analytics",
    totalVisits: "Total Visits",
    uniqueSessions: "Unique Sessions",
    mobileShare: "Mobile Share",
    topProduct: "Top Added to Cart",
    visitTrend: "Visit Trend",
    referrerBreakdown: "Traffic Sources",
    deviceBreakdown: "Device Types",
    peakHours: "Peak Hours (local time)",
    languageDistribution: "Visitor Languages",
    topProductViews: "Most Added to Cart",
    referrerDirect: "Direct",
    referrerSearch: "Search",
    referrerSocial: "Social",
    referrerOther: "Other",
    deviceMobile: "Mobile",
    deviceDesktop: "Desktop",
    deviceTablet: "Tablet",
    analyticsDisclosure: "Visitor data is anonymized aggregate statistics. No personal data is stored.",
    noDemographicsNote: "Age and gender are not inferred from browser signals. Registered customer demographic data (if collected via optional profile fields) could be shown here as a future feature.",
    wasteRecords: "Waste Records",
    settings: "Settings",
    adminTools: "Admin Tools",
    profile: "Profile",

    // Admin Dashboard
    adminDashboard: "Admin Dashboard",
    systemOverview: "System Overview",
    totalBakeries: "Total Bakeries",
    activeBakeries: "Active Bakeries",
    archivedBakeries: "Archived Bakeries",
    totalUsers: "Total Users",
    totalOrders: "Total Orders",
    recentActivity: "Recent Activity",
    viewAllBakeries: "View All Bakeries",
    viewAllUsers: "View All Users",
    bakeryManagement: "Bakery Management",
    userManagement: "User Management",
    analytics: "Analytics",
    auditLog: "Audit Log",

    // Admin Bakeries View
    allBakeries: "All Bakeries",
    searchBakeries: "Search bakeries...",
    filterByStatus: "Filter by Status",
    allStatuses: "All Statuses",
    active: "Active",
    archived: "Archived",
    bakeryOwner: "Owner",
    subdomain: "Subdomain",
    createdDate: "Created",
    lastConnection: "Last connection",
    never: "Never",
    daysAgo: "{count} d ago",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortNameAZ: "Name (A→Z)",
    sortLastConnection: "Last connection",
    lastActivity: "Last Activity",
    status: "Status",
    actions: "Actions",
    viewDetails: "View Details",
    hideDetails: "Hide Details",
    archiveBakery: "Archive Bakery",
    restoreBakery: "Restore Bakery",
    noBakeriesFound: "No bakeries found",

    // Admin Bakery Detail
    bakeryDetails: "Bakery Details",
    bakeryInformation: "Bakery Information",
    bakeryId: "Bakery ID",
    ownerId: "Owner ID",
    ownerEmail: "Owner Email",
    ownerName: "Owner Name",
    country: "Country",
    createdAt: "Created At",
    archivedAt: "Archived At",
    bakeryProducts: "Bakery Products",
    bakeryOrders: "Bakery Orders",
    bakeryStats: "Statistics",
    totalProducts: "Total Products",
    totalRevenue: "Total Revenue",
    orderCount: "Order Count",
    archiveConfirmTitle: "Archive Bakery?",
    archiveConfirmMessage: "Are you sure you want to archive this bakery? The baker will not be able to access their account, but all data will be preserved.",
    restoreConfirmTitle: "Restore Bakery?",
    restoreConfirmMessage: "Are you sure you want to restore this bakery? The baker will be able to access their account again.",
    archiveSuccess: "Bakery archived successfully",
    restoreSuccess: "Bakery restored successfully",
    archiveError: "Failed to archive bakery",
    restoreError: "Failed to restore bakery",
    hasActiveOrders: "Cannot archive bakery with active orders",
    // Grandfathering admin
    grandfatheringStatus: "Grandfathering Status",
    lifetimeAccess: "Lifetime Access",
    grandfatheredBadge: "Grandfathered",
    notGrandfathered: "Not Grandfathered",
    grantGrandfathering: "Grant Lifetime Access",
    revokeGrandfathering: "Revoke Lifetime Access",
    grantGrandfatheringConfirmTitle: "Grant Lifetime Access?",
    grantGrandfatheringConfirmMessage: "This will give the bakery permanent free access to Digi-Bakery. They will never need to pay for a subscription.",
    revokeGrandfatheringConfirmTitle: "Revoke Lifetime Access?",
    revokeGrandfatheringConfirmMessage: "This will remove the bakery's lifetime free access. They will need to subscribe to continue using Digi-Bakery.",
    grantGrandfatheringSuccess: "Lifetime access granted successfully",
    revokeGrandfatheringSuccess: "Lifetime access revoked successfully",
    grantGrandfatheringError: "Failed to grant lifetime access",
    revokeGrandfatheringError: "Failed to revoke lifetime access",
    grandfatheringDescription: "Grandfathered bakeries have permanent free access to Digi-Bakery and never need to subscribe.",
    backToBakeries: "Back to Bakeries",

    // Admin Audit Log
    actionType: "Action",
    actionTarget: "Target",
    actionTimestamp: "Timestamp",
    performedBy: "Performed By",
    viewBakery: "Viewed Bakery",
    archiveBakeryAction: "Archived Bakery",
    restoreBakeryAction: "Restored Bakery",

    // Admin Orders View
    orderManagement: "Order Management",
    orderManagementDescription: "View and manage all orders across all bakeries",
    searchOrders: "Search orders...",
    adminOrderId: "Order ID",
    bakery: "Bakery",
    adminCustomer: "Customer",
    adminPickupDate: "Pickup Date",
    adminTotal: "Total",
    filters: "Filters",
    adminStartDate: "Start Date",
    adminEndDate: "End Date",
    adminExportCSV: "Export to CSV",
    showingResults: "Showing",
    clearFilters: "Clear Filters",
    noOrdersFound: "No orders found",
    tryAdjustingFilters: "Try adjusting your filters or search criteria",

    // Home Page
    welcomeTitle: "Welcome to",
    welcomeSubtitle: "Fresh, handcrafted bread made with passion and tradition.",
    ourStory: "Our Story",
    storyContent: "After years perfecting my craft, I decided to open this micro-bakery to share the joy of true, slow-fermented sourdough. Every loaf is baked fresh, using only natural leaven and locally sourced grains.",
    commitmentText: "My commitment is simple: quality over quantity. This ensures that every baguette, croissant, and specialty bread meets the highest standard of flavour and texture.",
    seeAvailability: "See Today's Availability",
    goToShop: "Go to the Shop",
    loginToGetStarted: "Login to get Started",
    businessSubtitle:"Slogan of your bakery",
    bakerySubtitlePlaceholder: "e.g., Fresh Baked Daily",

    // Home Page Editor
    homePageEditor: "Home Page Editor",
    editHomePageContent: "Edit Home Page Content",
    uploadImage: "Upload Image",
    enterYourStory: "Enter your bakery story and bio here...",
    homePageEditorNote: "This content will replace the default story section on your home page. You can include text, images, and basic formatting.",
    homePageCustomization: "Home Page Customization",
    customizeHomePageDescription: "Customize your bakery's story and bio section on the home page with rich text and images.",
    editHomePage: "Edit Home Page",
    imageUploaded: "Image uploaded successfully! The image URL has been added to your content.",
    
    // Auth Screen
    welcomeBack: "Welcome back!",
    createAccount: "Create your account",
    cartSaved: "Your cart is saved!",
    cartSavedMsg: "Login or create an account to complete your order.",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    iAmA: "I am a:",
    customer: "Customer",
    baker: "Baker",
    countryRegion: "Country / Region",
    minCharacters: "Minimum 6 characters",
    loginButton: "Login",
    signUpButton: "Sign Up",
    dontHaveAccount: "Don't have an account? Sign up",
    alreadyHaveAccount: "Already have an account? ",
    currency: "Currency",
    pleaseWait: "Please wait...",
    chooseAccountType: "Choose Account Type",
    customerAccount: "Customer Account",
    customerAccountDesc: "Order from local bakeries",
    bakeryAccount: "Bakery Account",
    bakeryAccountDesc: "Create and manage your bakery",
    createBakeryAccount: "Create Bakery Account",
    yourName: "Your Name",
    bakeryName: "Bakery Name",
    bakeryNamePlaceholder: "Your Bakery Name",
    bakeryNameHelp: "This will be your bakery's public name",
    justWantToOrder: "Just want to order?",
    registerAsCustomer: "Register as Customer",
    registerAsBaker: "Register as Baker",
    wantToCreateBakery: "Want to create a bakery?",
    createBakery: "Create Bakery",
    resetPassword: "Reset Password",
    sendResetEmail: "Send Reset Email",
    backToLogin: "Back to Login",
    fullName: "Full Name",
    privacyPolicyRequired: "Privacy Policy Required",
    acceptPrivacyPolicy: "I agree to the",
    privacyPolicy: "Privacy Policy",
    privacyPolicyAgreement: "By creating an account, you agree to our Privacy Policy which explains how we collect, use, and protect your personal information.",
    tosRequired: "Terms of Service acceptance required",
    termsOfService: "Terms of Service",
    tosAgreement: "I accept the",
    loginSuccess: "Login successful!",

    // Shop View
    welcomeToOurBakery: "Welcome to our bakery!",
    ourFreshBreads: "Our Fresh Breads",
    cart: "Cart",
    selectPickupDate: "Select Pickup Date to See Availability:",
    selectPickupDateDesc: "Choose when you'd like to pick up your order",
    choosePickupDate: "Choose a pickup date...",
    selectDatePrompt: "Please select a pickup date to see what's available and start ordering",
    selectDateToSee: "Select a pickup date above to see available products",
    differentProducts: "Different products may be available on different days",
    noProductsForDate: "No products available for this date",
    tryDifferentDate: "Please try selecting a different pickup date",
    soldOut: "SOLD OUT",
    onlyLeft: "Only",
    available: "available",
    addToCart: "Add to Cart",
    allCategories: "All Products",
    showMore: "Show More",
    showLess: "Show Less",
    newProduct: "New",

    // Ingredients & Allergens
    ingredients: "Ingredients",
    viewIngredients: "View ingredients",
    potentialAllergen: "Potential allergen",
    manageAllergens: "Manage allergens",
    showIngredientsInShop: "Show ingredients in shop",
    ingredientsPreview: "Ingredients preview",
    ingredientsDisplayList: "Ingredients shown in shop",
    ingredientsDisplayListHelp: "Optional: edit the list shown to customers (comma-separated). Add * after an item to mark it as an allergen.",
    allergenNameOptional: "Allergen name (optional)",
    allergenLegend: "Bold = potential allergen",
    allergenDisclaimer: "Allergen information is provided for convenience and may not include cross-contamination.",
    editIngredient: "Edit Ingredient",
    ingredientNameEn: "Name (English)",
    ingredientNameFr: "Name (French)",
    manageIngredients: "Manage Ingredients",
    ingredientManager: "Ingredient Manager",
    systemIngredient: "System",
    customIngredientBadge: "Custom",
    usedInRecipes: "Used in recipes",
    ingredientNotUsed: "Not used",
    hasStockRecords: "Has stock records",
    confirmDeleteIngredients: "Delete {n} ingredient(s)? This cannot be undone.",
    ingredientDeletedSuccess: "Ingredient deleted",
    ingredientsDeletedSuccess: "{n} ingredients deleted",
    cannotDeleteInRecipe: "Cannot delete: used in recipe(s)",
    cannotDeleteHasStock: "Cannot delete: has stock purchase records",
    searchIngredients: "Search ingredients…",
    ingredientSaved: "Ingredient saved",
    deletedIngredient: "Deleted ingredient",
    ingredientsDisplayMode: "Ingredients Display Mode",
    ingredientsModeAutomatic: "Automatic (Recommended)",
    ingredientsModeAutomaticDesc: "Ingredients list is automatically generated from recipe and variations. Updates automatically when you change variations.",
    ingredientsModeCustom: "Custom",
    ingredientsModeCustomDesc: "You manage the ingredients list manually. You are responsible for keeping it accurate when variations change.",
    autoGeneratedListPreview: "Auto-generated List (Preview)",
    autoGeneratedUpdatesNote: "This list updates automatically when you change the recipe or variations.",
    customIngredientsList: "Custom Ingredients List",
    copyFromAutoGenerated: "Copy from Auto-generated",
    customIngredientsPlaceholder: "Enter ingredients (comma-separated). Add * for allergens (e.g., Milk*)",
    customIngredientsFormat: "Format: Flour, Milk*, Eggs* (use * for allergens)",
    currentAutoGeneratedList: "Current auto-generated list (for reference):",

    // UX Redesign - Customer-Centric Keys
    ingredientsShownToCustomers: "Ingredients shown to your customers",
    ingredientsShownDesc: "Help customers understand what's inside your products and identify allergens.",
    howManageIngredients: "How do you want to manage your ingredients list?",
    howManageIngredientsDesc: "Choose the best approach for your bakery",
    recommendedBadge: "Recommended",
    smartAutoMode: "Smart Auto",
    smartAutoModeDesc: "Digi-Bakery generates the ingredients automatically from your recipe and variations. Always up-to-date. No maintenance needed.",
    fullControlMode: "I want full control",
    fullControlModeDesc: "Manually edit what customers will see. Best if you want simplified wording or regulatory formatting.",
    customModeWarning: "Your ingredient list will NOT update automatically if the recipe or variations change.",
    ingredientsVisibleToCustomers: "Ingredients visible to customers",
    copyAutoList: "Copy auto-generated list",
    ingredientsPlaceholder: "Water, Wheat Flour*, Rye Flour, Fresh Yeast, Salt",
    allergenFormatHelp: "Use * to mark allergens (example: Wheat Flour*). The preview below shows exactly what customers will see.",
    customerPreview: "What your customers will see",
    customerPreviewDesc: "This is how ingredients will appear on your product pages",
    allergenHighlightNote: "Allergens are highlighted in bold",
    allergenDisclaimerShort: "This information is provided for guidance and does not cover cross-contamination risks.",
    noIngredientsToShow: "No ingredients to display",
    noIngredientsYet: "Select a recipe to see ingredients",
    switchToAutoTitle: "Switch to Smart Auto?",
    switchToAutoMessage: "Switching to Smart Auto will replace your custom ingredient list with an automatically generated one. You can always switch back to manual control later.",

    yourCart: "Your Cart",
    cartEmpty: "Your cart is empty",
    emptyCart: "Empty Cart",
    addItems: "Add Items",
    pickupDate: "Pickup Date",
    selectDateShop: "Select a date",
    selectedDateShop: "Selected Date",
    bassinage: "Bassinage",
    bassinageHint: "Water held back and added at the end of mixing",
    sectionSubtotal: "Subtotal",
    batchTotal: "Batch total",
    total: "Total",
    placeOrder: "Place Order",
    loginToCheckout: "Login to Checkout",
    registerOrder: "Register Order",
    selectProductsForCustomer: "Select products and assign to a customer",
    selectCustomer: "Select Customer",
    searchCustomers: "Search customers...",
    addNewCustomer: "Add New Customer",
    selectedCustomer: "Selected Customer",
    selectCustomerFirst: "Select Customer First",
    orderNotes: "Order Notes",
    specialRequests: "Special Requests",
    specialInstructions: "Special instructions...",
    name: "Name",
    phone: "Phone",
    create: "Create",
    adjustQuantities: "⚠️ Please adjust quantities to match availability",
    noPickupDateSelected: "No pickup date selected",
    
    // Shop - Recipe Based Availability
    basedOnBaseRecipe: "Based on base recipe availability",
    sharedRecipeLimit: "Shares dough limit with other products",

    // Order Confirmation
    orderConfirmed: "Order Confirmed",
    thankYouForOrder: "Thank you for your order!",
    confirmationEmailSent: "Confirmation email sent",
    checkEmailForDetails: "Check your email for order details and tracking information.",
    orderSummary: "Order Summary",
    orderedItems: "Ordered Items",
    continueShopping: "Continue Shopping",
    backToHome: "Back to Home",

    // Orders View
    orderSuccess: "✓ Order placed successfully!",
    orderPlacedSuccessfully: 'Order Registered Successfully',
    sendingEmail: "Sending confirmation email...",
    checkEmail: "Check your email for order confirmation and track it in",
    noOrdersYet: "No orders yet",
    noOrdersForDate: "No orders for this date",
    noOrdersYetDash: "No orders yet - when customers place orders, they'll appear here",
    ordersWillAppearHere: "Orders from customers will appear here. Share your shop link to start receiving orders!",
    startShopping: "Start shopping to place your first order!",
    orderNumber: "Order #",
    placed: "Placed",
    pickup: "Pickup",
    items: "Items",
    orderReceived: "Order Received",
    beingPrepared: "Being Prepared",
    readyForPickup: "Ready for Pickup",
    completed: "Completed",
    orderReady: "✓ Your order is ready for pickup!",
    loadingOrders: "Loading orders...",

    // Order Cancellation
    cancelOrder: "Cancel Order",
    cancelOrderTitle: "Cancel Order",
    cancelOrderConfirmation: "Are you sure you want to cancel this order? This action cannot be undone.",
    cancelOrderRefundInfo: "This order was paid online and will be refunded to your original payment method.",
    cancelOrderProcessing: "Processing cancellation...",
    cancellationReason: "Reason for cancellation",
    cancellationReasonPlaceholder: "Optional: Let us know why you're cancelling...",
    confirmCancellation: "Confirm Cancellation",
    orderCancelledSuccess: "Order cancelled successfully",
    refundProcessed: "Refund Processed",
    orderCancelled: "Order Cancelled",
    cancelledOn: "Cancelled on",
    customerRequest: "Customer request",
    bakerCancelledOrder: "Cancelled by baker",
    optional: "Optional",
    goBack: "Go Back",
    showCancelledOrders: "Show cancelled orders",
    cancelled: "Cancelled",
    last2Months: "Last 2 months",
    last6Months: "Last 6 months",
    allOrders: "All orders",

    // Profile View
    myProfile: "My Profile",
    profileUpdated: "Profile updated successfully!",
    emailCannotChange: "Email cannot be changed",
    phoneNumber: "Phone Number",
    deliveryAddress: "Delivery/Pickup Address",
    formatExample: "Format example:",
    requiredInfo: "Phone number and country are required to place orders. This information will be shared with the baker for order fulfillment.",
    saveProfile: "Save Profile",
    includeAddress: "Include street address, city, and postal/ZIP code",
    
    // Product Management
    productManagement: "Product Management",
    dragToReorder: "Drag products to reorder them",
    addNewProduct: "Add New Product",
    noProductsYet: "No products yet",
    startBuildingCatalog: "Start building your catalog by adding your first product",
    addYourFirstProduct: "Add Your First Product",
    editProduct: "Edit Product",
    productImage: "Product Image",
    clickToUpload: "Click to upload image (max 5MB)",
    recommended: "Recommended: Square images, at least 400x400px",
    productName: "Product Name",
    emoji: "Emoji (fallback)",
    description: "Description",
    price: "Price",
    recipe: "Recipe",
    noRecipe: "No recipe (optional)",
    linkRecipe: "Link this product to a recipe for production planning",
    doughWeight: "Product Weight", // from 'finalProductWeightNote' in last definition
    weightPerUnit: "Weight of dough per unit (before baking)",
    productionNote: "Production quantities are set in the 'Production Days' page, not here. Set the recipe and dough weight here, then specify how many you'll make per production batch.",
    addProduct: "Add Product",
    updateProduct: "Update Product",
    uploading: "Uploading...",
    finalProductWeightNote: "Total weight of finished product (includes base dough + any mixed-in variations). Example: 650g nut bread = base dough + nuts",

    // Baker Orders View
    ordersDashboard: "Orders Dashboard",
    filterByProduction: "Filter by Production Date:",
    allDates: "All Dates",
    productionSummaryOrders: "Production Summary for",
    pickupDates: "Pickup dates",
    noOrdersForProduction: "No orders for this production",
    address: "Address:",
    bakerCountry: "Country:",
    ordered: "Ordered:",
    orderItems: "Order Items:",
    pending: "Pending",
    preparing: "Preparing",
    ready: "Ready",
    bakerStatus: "Status",
    
    // Smart Date Filter
    smartDateFilter: "Smart Date Filter",
    advancedFilters: "Advanced Filters",
    searchSpecificDate: "Search Specific Date",
    find: "Find",
    recentProductionDays: "Recent Production Days (Last 2 weeks)",
    olderProductionDays: "Older Production Days",
    days: "days",
    selectedDate: "Selected Date",
    today: "Today",
    tomorrow: "Tomorrow",
    
    // Production Days Management
    productionDaysManagement: "Shop Schedule",
    quickScheduleCalendar: "Quick Schedule with Calendar",
    quickTip: "💡 Quick Tip:",
    quickTipMsg: "Use the calendar button above to select multiple dates and apply a template to all of them at once!",
    orderCutoffDateTime: "Order Cutoff Date & Time",
    orderCutoff: "Order cutoff",
    orderCutoffTiming: "Order Cutoff Date & Time",
    twoDaysBefore: "2 days before production",
    dayBefore: "1 day before production",
    same: "Same day as production",
    cutoffTime: "Cutoff Time",
    scheduleMultipleDays: "Schedule Multiple Days",
    quickSelect: "Quick Select",
    allMondays: "All Mondays",
    allTuesdays: "All Tuesdays",
    allWednesdays: "All Wednesdays",
    allThursdays: "All Thursdays",
    allFridays: "All Fridays",
    allSaturdays: "All Saturdays",
    allSundays: "All Sundays",
    clearAll: "Clear All",
    datesSelected: "date(s) selected",
    selectTemplate: "Select Template to Apply:",
    chooseTemplate: "Choose a template...",
    customerPickupTiming: "Customer Pickup Day:",
    sameDayProduction: "Same day as production",
    dayAfterProduction: "Day after production",
    pickupTimingNote: "Choose when customers can pick up products from the selected production dates",
    applyTemplateToDates: "Apply Template to",
    createNewProduction: "Add New Production Day",
    editProduction: "Edit Production Day",
    quickStartTemplate: "Quick Start from Template",
    createFromScratch: "Create from scratch...",
    templateApplied: "✓ Template applied! You can adjust quantities below before saving.",
    productionDate: "Production Date",
    whenBake: "When you will bake these products",
    whenCustomersCollect: "when customers can collect",
    setPickupDate: "Set when this production batch will be available for customer pickup",
    productionQuantities: "Production Quantities",
    productionQuantitiesRequired: "(Required for customer ordering)",
    addProductButton: "Add Product",
    noProductsAdded: "⚠️ No products added yet.",
    noProductsAddedMsg: "Customers won't be able to order for this production until you specify quantities.",
    selectProduct: "Select product...",
    quantity: "Quantity",
    weight: "Weight",
    totalQuantityNote: "Total quantity available across ALL pickup dates for this production",
    howItWorks: "How it works:",
    howItWorksMsg: "Set the total quantity you'll produce on the production date. This quantity will be shared across all pickup dates you specify.",
    createProductionDay: "Create",
    updateProductionDay: "Update",
    productionDay: "Production Day",
    scheduledProductions: "Scheduled Productions",
    noProductionsScheduled: "No production days scheduled",
    production: "Production",
    copyToOtherDates: "Copy to other dates",
    saveAsTemplate: "Save as template",
    copyProduction: "Copy Production",
    copyingFrom: "Copying from:",
    productsWillBeCopied: "product(s) will be copied",
    selectDatesToCopy: "Select Dates to Copy To:",
    addDate: "Add Date",
    selected: "Selected",
    hasProduction: "Has production",
    todayProduction: "Today",
    template: "Template",
    templateName: "Template Name",
    filterByPeriod: "Filter by Period:",
    lastMonth: "Last Month",
    lastWeek: "Last Week",
    thisWeek: "This Week",
    nextWeek: "Next Week",
    thisMonth: "This Month",
    nextMonth: "Next Month",
    all: "All",
    recipeBasedProduction: "Recipe-Based Production",
    selectBaseRecipe: "Select Base Recipe",
    totalDoughLimit: "Total Dough Limit",
    totalDoughLimitNote: "Maximum base dough (in grams) you can produce for this recipe",
    enabledProducts: "Enable Products",
    selectProductsForRecipe: "Select which products to enable for this recipe",
    noProductsForRecipe: "No products use this recipe",
    recipeQuantities: "Recipe Quantities",
    addRecipeLimit: "Validate Recipe Limit",
    baseDoughLimit: "Base Dough Limit",
    productsEnabled: "Products Enabled",
    
    // Production Templates
    productionTemplates: "Production Templates",
    proTip: "💡 Pro Tip:",
    proTipMsg: "Create templates for your common production schedules (weekdays, weekends, holidays). Then apply them quickly when creating production days!",
    createNewTemplate: "Create New Template",
    editTemplate: "Edit Template",
    type: "Type",
    weekday: "Weekday",
    weekend: "Weekend",
    specialEvent: "Special Event",
    custom: "Custom",
    addToTemplate: "Add products to this template",
    createTemplate: "Create",
    updateTemplate: "Update",
    yourTemplates: "Your Templates",
    noTemplatesYet: "No templates created yet",
    createFirstTemplate: "Create your first template to get started!",
    howToUseTemplates: "How to Use Templates",
    step1Title: "Create Templates",
    step1Desc: "Set up your common production schedules with typical product quantities",
    step2Title: "Apply to Dates",
    step2Desc: "Go to Production Days and use 'Create from Template' to quickly schedule",
    step3Title: "Save Time",
    step3Desc: "No more manual entry! Adjust quantities if needed for specific days",
    
    // Shopping List
    shoppingListTitle: "Shopping List",
    stockNotConfigured: "Stock management is not set up. Showing total quantities needed. Add stock purchases to see what's missing.",
    ingredientsTotal: "ingredients",
    generateShoppingList: "Generate List",
    selectProductionDays: "Select production days",
    ingredientNeeded: "Total Needed",
    ingredientInStock: "Stock Available",
    ingredientToBuy: "Missing",
    everythingInStock: "Everything is in stock — nothing to buy!",
    selectAllDays: "Select all",
    deselectAllDays: "Deselect all",
    noFutureDays: "No upcoming production days",
    noDaysSelected: "Select one or more production days to generate your list.",
    noRecipeProducts: "No recipe-based products found for the selected days.",
    shoppingListFor: "Shopping list for",
    printShoppingList: "Print",
    exportCsv: "Export CSV",
    copyToClipboard: "Copy",
    ingredientsToBuy: "ingredients to buy",
    totalShortfall: "Total shortfall",
    generatedOn: "Generated on",

    // Production Planning
    productionPlanningTitle: "Production Planning",
    planningExportCSV: "Export CSV",
    selectProduction: "Select Production Day",
    selectProductionPlaceholder: "Choose a production day...",
    wasteFactor: "Waste Factor (%)",
    wasteFactorNote: "Add extra dough to account for waste/testing",
    selectToSeePlan: "Select a production to see the plan",
    productsToMake: "Products to Make:",
    customerOrders: "Customer Orders",
    customerOrdersOnline: "Online Customer Orders",
    units: "units",
    each: "each",
    totalDough: "total dough",
    ingredientsNeeded: "Ingredients Needed:",
    ingredient: "Ingredient",
    baseRecipe: "Base Recipe",
    bakersPercent: "Baker's %",
    scaledAmount: "Scaled Amount",
    batchPlanning: "Batch Planning:",
    mixer: "Mixer",
    totalBatches: "Total Batches:",
    batch: "Batch",
    flour: "flour",
    totalDoughNeeded: "Total Dough Needed:",
    withWaste: "With",
    waste: "waste",
    neededForOrders: "Needed for Orders",
    scaleFactor: "Scale Factor:",
    baseRecipeScale: "Base recipe ×",
    noMixerNote: "No mixer assigned to this recipe",
    loadingProductionData: "Loading production data...",
    recipeSections: "Recipe Sections",
    recipeNotes: "Recipe Notes",
    scaleRecipeProduction: 'Scale Recipe Production',
    scaleAllRecipes: 'Scale All Recipes',
    resetToOrderQuantity: 'Reset to Order Quantity',
    resetToRecipeLimit: 'Reset to Recipe Limit',
    noRecipeLimitsSet: 'No recipe limits are set for this production day. Please set limits in Production Days Management first.',
    totalBaseDoughNeeded: 'Total Base Dough Needed',
    totalVariationIngredients: 'Total Variation Ingredients',
    calculating: 'Calculating...',
    currentLimit: 'Current Limit',
    fromOrders: 'From Orders',
    baseDough: 'Base Dough',
    baseRecipeIngredients: 'Base Recipe Ingredients',
    totalDoughYield: 'Total Dough Yield',
    orderedQuantity: 'Ordered quantity',
    productionQuantity: 'Production',
    fromBaseLimit: 'compare to {weight}kg of recipe limit',
    adjustedUp: 'Adjusted Up',
    adjustedDown: 'Adjusted Down',
    baseDoughCalculation: "Base Dough Calculation",
variationIngredientsAddOns: "Variation Ingredients (Add-Ons)",
variationIngredientsMixedIn: "Variation Ingredients (Mixed In)",
addAfterShaping: "Add After Shaping",

    // Production Buffer
    productionBuffer: 'Production Buffer',
    productionBufferHelper: 'Adds a small extra quantity to compensate for shaping loss, baking loss, or unexpected production issues.',
    recipeProductionBuffer: 'Safety margin',
    totalToProduce: 'Total to produce',
    totalWithMargin: 'Total with margin',
    dough: 'dough',
    baseDoughWeight: 'Base dough weight',
    baseVariationWeight: 'Base Variation Ingredients',
    totalDoughWithBuffer: 'Total dough (with buffer)',
mixedIntoDough: "Mixed into Dough",
forProduct: "For",
finalWeight: "Final Weight",
exceedsLimit: "EXCEEDS LIMIT",
withinLimit: "Within Limit",
remainingCapacity: "Remaining Capacity",

    // Reports View
    salesReportsTitle: "Sales Reports & Analytics",
    dateRange: "Date Range",
    allTime: "All Time",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    customRange: "Custom Range",
    reportsStartDate: "Start date",
    reportsEndDate: "End date",
    reportsTotalRevenue: "Total Revenue",
    reportsTotalOrders: "Total Orders",
    averageOrderValue: "Avg Order Value",
    completedOrders: "Completed",
    revenueOverTime: "Revenue Over Time",
    orderStatusDistribution: "Order Status Distribution",
    revenue: "Revenue",
    noDataAvailable: "No data available",
    productSalesPerformance: "Product Sales Performance",
    quantitySold: "Quantity Sold",
    noProductSalesData: "No product sales data available",
    reportsOrderId: "Order ID",
    date: "Date",
    loadingReports: "Loading reports...",
    errorLoadingReports: "Error loading reports",
    costsIncludeRealFixed: "Costs include Real Fixed Costs",
    costsIncludeEstimatedFixed: "Costs include Estimated Fixed Costs",
    ingredientCostsOnly: "Ingredient Costs Only",
    revenuePartiallyEstimated: "Revenue partially estimated (some days not reconciled)",
    monthsClosed: "months closed",

    // Baker Settings
    bakerySettings: "Bakery Settings",
    settingsSaved: "Settings saved successfully!",
    homePageSaved: "Changes saved successfully!",
    businessInformation: "Business Information",
    localizationSettings: "Localization Settings",
    appearanceSettings: "Appearance Settings",
    theme: "Theme",
    themeDescription: "Choose the color theme for your bakery interface",
    themePreview: "Theme Preview",
    primaryButton: "Primary Button",
    secondaryButton: "Secondary Button",
    currencySymbol: "Currency Symbol",
    currencyNote: "Currency settings will apply to all product prices and customer orders. Existing prices will remain unchanged but will be displayed with the new currency symbol.",
    businessName: "Business Name",
    businessAddress: "Business Address",
    businessPhone: "Business Phone",
    businessEmail: "Business Email",
    addressPlaceholder: "Street and number, e.g. 123 Baker Street",
    saveSettings: "Save Settings",
    loadingSettings: "Loading settings...",
    errorSavingSettings: "Error saving settings",
    errorLoadingSettings: "Error loading settings",
    note: "Note",
    
    // Equipment Manager
    equipmentManagement: "Equipment Management",
    addNewEquipment: "Add New Equipment",
    editEquipment: "Edit Equipment",
    deleteEquipment: "Delete Equipment",
    equipmentName: "Equipment Name",
    equipmentType: "Type",
    maxFlourCapacity: "Max Flour Capacity (kg)",
    addEquipment: "Add Equipment",
    updateEquipment: "Update Equipment",
    equipmentList: "Equipment List",
    noEquipmentAdded: "No equipment added yet",
    maxFlour: "Max Flour (kg)",
    equipmentActions: "Actions",
    other: "Other",
    
    // Recipe Manager
    recipeManagement: "Recipe Management",
    createNewRecipe: "Create New Recipe",
    editRecipe: "Edit Recipe",
    recipeName: "Recipe Name",
    baseFlourAmount: "Base Flour Amount (g)",
    recipeScaleNote: "Recipe will be scaled based on this amount",
    notes: "Notes",
    recipeSummary: "Recipe Summary",
    hydration: "Hydration:",
    createRecipe: "Create Recipe",
    updateRecipe: "Update Recipe",
    recipeIngredientsTitle: "Ingredients",
    addIngredient: "Add Ingredient",
    selectIngredient: "Select ingredient",
    addCustomIngredient: "+ Add Custom Ingredient",
    enterCustomIngredient: "Enter custom ingredient name",
    recipeIngredients: "Recipe Ingredients",
    noIngredientsAdded: "No ingredients added yet",
    add: "Add",
    yourRecipes: "Your Recipes",
    duplicate: "Duplicate",
    duplicateRecipe: "Duplicate recipe",
    newRecipeName: "New recipe name",
    recipeNameExists: "A recipe with this name already exists",
    recipeDuplicated: "Recipe duplicated",
    noRecipesCreated: "No recipes created yet",
    baseFlour: "Base Flour:",
    totalYield: "Total Yield:",
    ingredientCount: "Ingredients:",
    mainDough: "Main Dough",
    addSection: "Add Section",
    sectionNotes: "Section notes...",
    confirmHideRecipe: "Do you want to hide this recipe?",
    
    // Base Recipe & Variations
    baseRecipeSettings: "Base Recipe Settings",
    variationIngredients: "Variation Ingredients",
    variationIngredientsOptional: "Variation Ingredients (Optional)",
    variationIngredientsNote: "Add ingredients that make this product different from the base recipe",
    addVariationIngredient: "+ Add Variation Ingredient",
    variationType: "Variation Type",
    mixedIn: "Mixed In",
    mixedInNote: "Mixed into the dough (reduces base dough needed)",
    addOn: "Add-On",
    addOnNote: "Added after shaping (doesn't affect base dough)",
    quantityPerUnit: "Quantity per unit",
    percentOfFlour: "of Flour",
    percentOfFlourNote: "Percentage relative to flour in base recipe",
    removeVariation: "Remove Variation",
    noVariations: "No variations added",
    
    // Database Cleaner
    databaseCleaner: "Database Cleaner",
    databaseCleanerInfo: "This tool permanently deletes your saved recipes, equipment, or ingredients. Use with caution!",
    deleteAllRecipes: "Delete All Recipes",
    deleteAllEquipment: "Delete All Equipment",
    deleteAllIngredients: "Delete All Ingredients",
    deleteAllData: "Delete All Data",
    recordsDeleted: "records deleted successfully",
    deleteConfirm: "Delete this equipment? This may affect recipes using it.",
    deleteConfirmRecipe: "Delete this recipe? This action cannot be undone.",
    confirmDelete: "Do you want to delete this production day?",
    deleteProductionDay: "Delete Production Day",
    confirmDeleteTemplate: "Do you want to delete this template? This will not affect the production days already planned with this template",
    templateDeletedSuccess: "Template deleted successfully. This did not affect production days already planned with this template.",
    selectAll: "All",
    deleting: "Deleting",
    linkedToThisProductionDay: "order(s) linked to this production day",
    order: "order",
    confirmDeleteProductionDay: "Are you sure you want to delete this production day?",
    confirmDeleteProductionDayWithOrders: "Are you sure you want to delete this production day? This will affect existing orders.",
    keepOrders: "Keep Orders",
    keepOrdersDescription: "Orders will remain in the system and will automatically reattach if you create a new production day on the same date.",
    deleteOrders: "Delete Orders",
    deleteOrdersDescription: "Permanently delete all orders linked to this production day.",
    deleteSelected: "Delete selected",
    bulkDeleteConfirm: "You are about to permanently delete {count} production day(s).",
    bulkDeleteLinkedOrders: "{count} linked order(s) will also be affected:",
    bulkDeleteAllDays: "Delete all {count} selected days",
    bulkDeleteCleanOnly: "Delete only the {count} days without orders",
    bulkDeleteSkipped: "{count} day(s) with orders will be skipped",
    deleteConfirmData: "Are you sure you want to permanently delete this data?",
    loadDemoData: "Load Demo Data",
    demoDataDescription: "Generate sample data from January 2025 to today with ~2 production days per week and 3-8 orders per production day",
    
    // Stock Management
    stockManagement: "Stock Management",
    printStockLevels: "Print",
    stockLevelsReportTitle: "Stock Levels",
    printPurchaseQty: "Purchase Qty",
    printConsumedQty: "Consumed Qty",
    printRemainingQty: "Remaining Qty",
    printActualQty: "Actual Qty",

    // Physical Inventory / Stock Adjustments
    physicalInventory: "Physical Inventory",
    inventoryAdjustments: "Stock Adjustments",
    actualQuantity: "Actual quantity",
    systemQuantity: "System quantity",
    startCount: "Start Count",
    reviewCount: "Review Count",
    postCount: "Post Count",
    expectedQty: "Expected",
    countedQty: "Counted",
    varianceValue: "Variance Value",
    adjustmentReason: "Reason for adjustment",
    adjustmentReasonShrinkage: "Shrinkage / Suspected Theft",
    adjustmentReasonMeasurementError: "Measurement Error",
    adjustmentReasonReceivingError: "Receiving Error",
    adjustmentReasonSpoilageNotLogged: "Spoilage Not Logged",
    adjustmentReasonOther: "Other",
    noVarianceLines: "No changes to post",
    driftDetected: "Stock changed since you started counting. Please refresh and recount.",
    refreshCount: "Refresh Count",
    noteRequiredAboveThreshold: "A note is required for a variance this large",
    reasonRequired: "A reason is required",
    countPosted: "Inventory count posted successfully",
    adjustedLines: "Adjusted Lines",
    totalIncrease: "Total Increase",
    totalDecrease: "Total Decrease",
    netVariance: "Net Variance",
    countedBy: "Counted By",
    countSession: "Count Session",
    reverseAdjustment: "Reverse Adjustment",
    reversalOf: "Reversal of",
    confirmReversal: "This will exactly cancel the original adjustment. Continue?",
    reversed: "Reversed",
    inventoryAdjustmentsTitle: "Stock Adjustments Report",
    printInventoryAdjustments: "Print",
    noAdjustmentData: "No adjustment data available",
    adjustmentRecords: "Adjustment Records",
    ingredientPurchaseHistory: "All purchases of this ingredient",
    avgPurchasePrice: "Average price",
    avgPurchasePriceHint: "Weighted by quantity, all purchases",
    lowestPrice: "Lowest price",
    highestPrice: "Highest price",
    lowestShort: "MIN",
    highestShort: "MAX",
    totalPurchased: "Total purchased",
    pricePerKg: "Price",
    statusInStock: "In stock",
    statusUsedUp: "Used up",
    last12Months: "Last 12 months",
    noPurchasesInPeriod: "No purchases of this ingredient in this period",
    adjustmentType: "Type",
    adjustmentTypeAll: "All types",
    adjustmentTypeQuantity: "Quantity count",
    adjustmentTypePrice: "Price correction",
    adjustmentBefore: "Before",
    adjustmentAfter: "After",
    priceCorrections: "Price corrections",
    unlistedLotBadge: "Unlisted Lot",

    addPurchase: "Add Purchase",
    editPurchase: "Edit Purchase",
    purchaseHistory: "Purchase History",
    currentStock: "Current Stock",
    noStock: "No stock recorded",
    noPurchases: "No purchases recorded",
    purchaseItems: "Purchase List",
    addRow: "Add Row",
    totalCost: "Total Cost",
    lotBatchNumber: "Lot/Batch Number",
    avgRevenuePerDay: "Avg Revenue/Prod Day",
    avgCostPerDay: "Avg Cost/Prod Day",
    avgMarginPerDay: "Avg Margin/Prod Day",
    unitCost: "Unit Cost",
    remaining: "Remaining",
    consumed: "consumed",
    value: "Value",
    avgCost: "Avg Cost",
    purchases: "Purchases",
    lowStock: "Low stock",
    purchaseDate: "Purchase Date",
    supplier: "Supplier",
    expiryDate: "Expiry Date",
    manualCost: "Manual Cost",
    manualCostNote: "For products without recipes",
    cost: "Cost",
    estimatedCost: "Estimated Cost",
    estimatedRevenue: "Estimated Revenue",
    estimatedMargin: "Estimated Margin",
    costPerKg: "Cost per kg",
    insufficientStock: "Insufficient stock for the following ingredients:",
    stockNotConsumed: "Stock has not been consumed.",
    need: "need",
    have: "have",
    shortfall: "shortfall",
    productionCannotBeMarkedAsDone: "Production cannot be marked as done",
    customIngredients: "Custom Ingredients",
    noCustomIngredients: "No custom ingredients added yet",
    ingredientExists: "Ingredient already exists",
    increaseFactor: "Increase Factor (%)",
    withIncrease: "With Increase",
    saveProductionAdjustments: "Save Production Quantity",
    productionAdjustmentsSaved: "Production quantities saved successfully.",
    savedAdjustmentsLoaded: "Saved production quantities loaded",
    markProductionDone: "Mark Production Done",
    productionCompleted: "Production Completed",
    productionCompletedOn: "This production day has been marked as completed on {date}.",
    productionLocked: "Production quantities and recipe scaling are locked and cannot be modified.",
    confirmMarkProductionDone: "Are you sure you want to mark this production as completed? This will consume ingredients from stock.",
    confirmMarkProductionDoneNoStock: "Are you sure you want to mark this production as completed?",
    confirmMarkProductionDoneZero: "No production quantities are set. Are you sure you want to mark this as completed?",
    productionCompletedSuccessfully: "Production marked as completed and stock updated!",
    productionCompletedSuccessfullyNoStock: "Production marked as completed!",
    confirm: "Confirm",
    cancel: "Cancel",

    // Production Trace Confirmation
    productionTraceConfirmation: "Production Trace Confirmation",
    productionTraceConfirmationDesc: "Review ingredient usage and traceability data before marking production as completed",
    productionTraceWarning: "This information will be permanently recorded for traceability purposes. Once confirmed, stock levels will be permanently updated.",
    ingredientTraceabilitySummary: "Ingredient Traceability Summary",
    ingredientTraceabilityDesc: "Detailed breakdown of ingredients used, including batch numbers, purchase dates, and expiry dates for complete traceability",
    recipeTraceabilitySummary: "Recipe Traceability Summary",
    recipeTraceabilityDesc: "Detailed breakdown of ingredients used per recipe, including batch numbers, purchase dates, and expiry dates for complete traceability",
    nonTraceable: "Non-traceable (no batch)",
    traceBatchNumber: "Batch",
    tracePurchaseDate: "Purchase Date",
    traceExpiryDate: "Expiry Date",
    traceSupplier: "Supplier",
    traceQuantity: "Quantity",
    traceBatch: "batch",
    traceBatches: "batches",
    traceExpired: "Expired",
    traceExpiredAtProductionApproved: "Expired at production — used with baker's approval",
    traceExpiringSoon: "Expiring Soon",
    traceImportant: "Important",
    confirmAndMarkDone: "Confirm & Mark as Done",
    traceProductionDate: "Production Date",
    traceTotalCost: "Total Cost",
    traceCompletedAt: "Completed At",
    traceType: "Type",
    traceBatchDetails: "Batch Details",
    traceProductionRecipes: "Production Recipes",
    traceDoughNeeded: "Dough Needed",
    traceScaleFactor: "Scale Factor",
    traceCost: "Cost",
    noIngredientData: "No ingredient traceability data available",
    noTraceDataAvailable: "No traceability data available for this production",
    viewTrace: "View Trace",
    
    // Recipe Type Labels
    traceBaseRecipe: "Base Recipe",
    traceAddon: "Add-on",
    traceMixedin: "Mixed-in",
    productionDayCreated: "Production day created successfully!",
    productionDayAlreadyExists: "A production day already exists for this date. Please choose a different date.",
    productionDateAlreadyScheduled: "A production day already exists on this date",
    productionDatesSkipped: "Skipped (already scheduled)",
    noFreeDatesToCreate: "All selected dates already have a production day",
    stockConsumptionFailed: "Some ingredients could not be consumed from stock. Please check your inventory.",
    selectSupplier: "Select Supplier",
    addNewSupplier: "+ Add New Supplier",
    enterSupplierName: "Enter supplier name",
    supplierExists: "Supplier already exists",
    dateFormat: "Date Format",
    dateFormatMMDDYYYY: "MM/DD/YYYY (US)",
    dateFormatDDMMYYYY: "DD/MM/YYYY (European)",
    dateFormatYYYYMMDD: "YYYY-MM-DD (ISO)",
    manageStock: "Manage Stock",
    manageStockDescription: "When disabled, stock is considered infinite and production completion won't check ingredient availability",
    showOnlyInStock: "Show only in stock",
    stockShortfallWarning: "Stock Shortfall Warning",
    insufficientStockForProduction: "Insufficient Stock for Production",
    purchaseMoreIngredients: "Please purchase more ingredients or adjust production quantities before marking production as done.",
    savePurchases: "Save Purchases",

    // Invoice Scanning
    scanInvoice: "Scan Invoice",
    uploadInvoice: "Upload Invoice",
    processingInvoice: "Processing invoice...",
    reviewInvoice: "Review Invoice Items",
    matchedIngredient: "Matched Ingredient",
    confirmStockEntry: "Confirm & Add to Stock",
    noMatchFound: "No match found",
    scanInvoiceSuccess: "Invoice items added to stock successfully!",
    gramsPerUnit: "g per unit",
    gramsPerUnitRequired: "Required for pcs/unit",
    qtyPerUnit: "Qty per unit",
    packSize: "Pack size",
    packSizeContains: "contains",
    packSizePerPiece: "per piece",
    packSizeGramsPerPcs: "g per piece",
    conversionRequired: "Required for pack purchases (bag/case/tray...)",
    lowConfidenceMatch: "Low-confidence match — please verify",

    // Stock Discard/Waste
    discardStock: "Discard Stock",
    deleteStock: "Delete Stock",
    discard: "Discard",
    discardAll: "Discard All",
    discardPartial: "Discard Partial Amount",
    discardQuantity: "Discard Quantity (kg)",
    discardReason: "Reason for Discard",
    discardReasonExpired: "Expired",
    discardReasonDamaged: "Damaged",
    discardReasonError: "Error",
    discardReasonOther: "Other",
    discardReasonPlaceholder: "Enter reason...",
    selectReason: "Select reason",
    wasteCost: "Waste Cost",
    correctPrice: "Correct price",
    correctPriceTitle: "Correct purchase price",
    correctPriceExplanation: "This lot has already been used, so its quantities, lot number, dates and supplier stay locked for traceability. Only the price can be corrected. The new price applies to the remaining stock and future productions. Past productions and waste keep the cost recorded at the time. The correction is kept in the audit log.",
    correctPriceNewTotal: "Correct total price",
    correctPriceReason: "Reason for correction",
    correctPriceReasonInvoiceError: "Invoice entry error",
    correctPriceRemainingValue: "Change in remaining stock value",
    priceCorrected: "Price corrected",
    priceCorrectedSuccess: "Price corrected successfully",
    priceCorrectionConflict: "The price of this lot was changed in the meantime. Please reopen the correction and try again.",
    totalWasteCost: "Total Waste Cost",
    wasteRecorded: "Waste recorded successfully!",
    wasteRecordedFr: "Déchets enregistrés avec succès !",
    confirmDiscard: "Confirm Discard",
    confirmDiscardMsg: "Are you sure you want to discard this stock? This action cannot be undone.",
    discardSuccess: "Stock discarded successfully!",
    discardSuccessFr: "Stock jeté avec succès !",
    wasteReports: "Waste Reports",
    wasteReportsTitle: "Stock Waste & Discard Reports",
    wasteByIngredient: "Waste by Ingredient",
    wasteByReason: "Waste by Reason",
    wasteOverTime: "Waste Over Time",
    noWasteData: "No waste data available",
    wasteDate: "Waste Date",
    wasteReason: "Reason",
    wasteAmount: "Waste Amount (kg)",
    wasteValue: "Waste Value",

    // Fixed Costs
    fixedCosts: "Fixed Costs",
    fixedCostsManagement: "Fixed Costs Management",
    addFixedCost: "Add Fixed Cost",
    editFixedCost: "Edit Fixed Cost",
    fixedCostName: "Cost Name",
    monthlyAmount: "Monthly Amount",
    costCategory: "Category",
    rent: "Rent",
    utilities: "Utilities",
    insurance: "Insurance",
    labor: "Labor",
    subscriptions: "Subscriptions",
    energy: "Energy (Electricity, Gas, Wood)",
    marketing: "Marketing & Advertising",
    maintenance: "Equipment Maintenance",
    transportation: "Transportation & Delivery",
    customCategory: "Custom...",
    enterCustomCategory: "Enter custom category",
    totalMonthlyFixedCosts: "Total Monthly Fixed Costs",
    planningMethod: "Planning Method",
    calendarBased: "Calendar-Based (Monthly Production)",
    templateBased: "Template-Based (Weekly Pattern)",
    selectMonth: "Select Month",
    selectTemplateShort: "Select Template",
    productionDaysPerWeek: "Production Days per Week",
    fixedCostPerGram: "Fixed Cost per kg",
    plannedDoughProduction: "Planned Dough Production",
    exampleLoafCost: "Example: 700g loaf fixed cost",
    configureFixedCosts: "configure fixed costs",
    setFixedCosts: "Set Fixed Costs",
    ingredientCost: "Ingredient Cost",
    fixedCost: "Fixed Cost",
    noFixedCostsConfigured: "No fixed costs configured",
    fixedCostSavedSuccess: "Fixed cost saved successfully",
    fixedCostDeletedSuccess: "Fixed cost deleted successfully",
    fixedCostDeleteConfirm: "Delete this fixed cost item?",
    activeItems: "Active Items",
    inactiveItems: "Inactive Items",

    // Month Close
    monthClose: "Month Close",
    closeMonth: "Close Month",
    closeProduction: "Close Production",
    closeSales: "Close Sales",
    productionClosed: "Production Closed",
    salesClosed: "Sales Closed",
    actualFixedCosts: "Actual Fixed Costs",
    actualDoughGrams: "Actual Dough Grams",
    fixedCostPerGramReal: "Real Fixed Cost/kg",
    fixedCostPerGramPlanned: "Planned Fixed Cost/kg",
    reconciliationStatus: "Reconciliation Status",
    reconciliationPercent: "Reconciliation %",
    plannedVsReal: "Planned vs Real",
    variance: "Variance",
    marginReal: "Real Margin",
    marginEstimated: "Estimated Margin",
    partiallyEstimated: "Partially Estimated",
    closeProductionFirst: "Close production first",
    reconciliationWarning: "Reconciliation below 90%",
    productionClosedOn: "Production closed on",
    salesClosedOn: "Sales closed on",
    totalDoughProduced: "Total Dough Produced",
    closeProductionConfirm: "Close production for this month? This will freeze the fixed cost rate.",
    closeSalesConfirm: "Close sales for this month? This will calculate real margins.",
    closeProductionTitle: "Close Production",
    closeSalesTitle: "Close Sales",
    deleteFixedCostTitle: "Delete Fixed Cost",
    daysReconciled: "days reconciled",
    monthCloseSuccess: "Month closed successfully",

    // Month Close Summary
    monthSummary: "Month Summary",
    productionEfficiency: "Production",
    fixedCostAllocation: "Fixed Cost/g",
    costImpactPerLoaf: "Cost per Loaf",
    monthResults: "Results",
    planned: "Planned",
    actual: "Actual",
    differenceVsPlan: "vs Plan",
    impact: "Impact",
    efficient: "Savings",
    overCost: "Over budget",
    totalCosts: "Total Costs",
    realMargin: "Margin",
    basedOnReconciledSales: "Based on reconciled sales",
    fixedCostExplanation: "Fixed costs stay the same even when you bake less. Baking fewer kilos increases the cost per loaf.",

    // Common
    loading: "Loading...",
    save: "Save",
    close: "Close",
    edit: "Edit",
    delete: "Delete",
    yes: "Yes",
    no: "No",
    ok: "OK",
    required: "Required",
    fillAllFields: "Please fill in all fields",
    errorOccurred: "An error occurred. Please try again.",
    success: "Success!",
    pleaseLogin: "Please login to access this page",
    onlyForBakers: "This page is only accessible to bakers",
    cannotDeleteCompleted: "Cannot delete completed production days",
    created: "Created",
    copied: "Copied",
    to: "to",
    filter: "Filter",
    filterOrders: "Filter Orders",
    selectDate: "Select Date (defaults to today)",
    filterByReason: "Filter by Reason",
    
    // Collection Points
    collectionPoints: "Collection Points",
    addCollectionPoint: "Add Collection Point",
    selectCollectionPoint: "Select Collection Point",
    selectCollectionPointFirst: "Please select a collection point first",
    selectCollectionPointRequired: "Please select a collection point to continue",
    collectionPointLocation: "Location",
    collectionPointTime: "Time",
    collectionPointStartTime: "Start Time",
    collectionPointEndTime: "End Time",
    noCollectionPoints: "No collection points available",
    collectionPointRequired: "Collection point selection required",
    editCollectionPoint: "Edit Collection Point",
    removeCollectionPoint: "Remove Collection Point",
    collectionPoint: "Collection Point",
    print: "Print",
    printRecipe: "Print Recipe",
    printRecipeTitle: "Recipes for",
    printOrdersReport: "Orders Report",
    printTraceabilityReport: "Production Traceability Report",
    printGeneratedOn: "Generated on",
    // Production phase short codes (language-aware, based on CAP standards)
    phaseCodeKneading: "K",
    phaseCodeBulkProofing: "BP",
    phaseCodeDividing: "D",
    phaseCodeShaping: "S",
    phaseCodeFinalProofing: "FP",
    phaseCodeBaking: "B",
    phaseCodeAutolyse: "A",
    phaseCodeStretchFold1: "SF1",
    phaseCodeStretchFold2: "SF2",
    phaseCodeStretchFold3: "SF3",
    phaseCodeStretchFold4: "SF4",
    phaseCodeColdRetard: "CR",
    phaseCodeButterIncorporation: "BI",
    phaseCodeDoughMixing: "DM",
    phaseCodeRest1: "R1",
    phaseCodeRest2: "R2",
    phaseCodeRest3: "R3",
    phaseCodeTourDouble: "Td",
    phaseCodeTourSimple1: "Ts1",
    phaseCodeTourSimple2: "Ts2",
    phaseCodeDetaillage: "D",
    // Production phase names (used by templates)
    phaseNameKneading: "Kneading",
    phaseNameBulkProofing: "Bulk proofing",
    phaseNameDividing: "Dividing",
    phaseNameShaping: "Shaping",
    phaseNameFinalProofing: "Final proofing",
    phaseNameBaking: "Baking",
    phaseNameAutolyse: "Autolyse",
    phaseNameStretchFold1: "Stretch & fold #1",
    phaseNameStretchFold2: "Stretch & fold #2",
    phaseNameStretchFold3: "Stretch & fold #3",
    phaseNameStretchFold4: "Stretch & fold #4",
    phaseNameColdRetard: "Cold retard",
    phaseNameButterIncorporation: "Butter incorporation",
    phaseNameDoughMixing: "Dough mixing",
    phaseNameRest: "Rest",
    phaseNameTourDouble: "Tour double",
    phaseNameTourSimple1: "Tour simple #1",
    phaseNameTourSimple2: "Tour simple #2",
    phaseNameDetaillage: "Détaillage",
    // Production Organigramme
    productionPhases: "Production Phases",
    addPhase: "Add Phase",
    phaseTemplates: "Phase Templates",
    useTemplate: "Use Template",
    phaseName: "Phase name",
    phaseShortCode: "Short code",
    phaseDurationMin: "Duration (min)",
    phaseTypeLabel: "Phase type",
    phaseResourceLabel: "Resource",
    noProductionPhasesDefined: "No production phases defined",
    productionPhasesDescription: "Define the steps required to produce this recipe.",
    productionPhasesDescriptionSub: "Digi-Bakery will use these phases to generate a printable production timeline.",
    phaseTypeActiveWork: "Active work",
    phaseTypeWaiting: "Waiting / Proofing",
    phaseTypeOven: "Baking (Oven)",
    phaseTypeFridge: "Fridge",
    phaseTypeFreezer: "Freezer",
    phaseTypeProofer: "Proofer",
    phaseTypeMixer: "Mixer",
    phaseTypeCooling: "Cooling",
    phaseTypePackaging: "Packaging",
    phaseTypeCustom: "Custom",
    resourceTypeNone: "None",
    resourceTypeOven: "Oven",
    resourceTypeMixer: "Mixer",
    resourceTypeFridge: "Fridge",
    resourceTypeFreezer: "Freezer",
    resourceTypeProofer: "Proofer",
    resourceTypeBench: "Bench",
    resourceTypeRack: "Rack",
    resourceTypeCustom: "Custom",
    productionOrganigramme: "Production Organigramme",
    productionOrganigrammeDescription: "Enter the target out-of-oven time per recipe to generate a printable production timeline.",
    targetOutOfOvenTime: "Target out-of-oven",
    resourceName: "Resource name",
    resourceNameHint: "e.g. Oven 1, Oven 2",
    resourceNameOverride: "Or type a custom name",
    customResource: "Custom / unnamed",
    phaseColor: "Colour",
    phaseColorHint: "optional — overrides the default colour for this phase",
    clearColor: "Default",
    finalTargetOutOfOvenTime: "Final target out-of-oven",
    generateTimeline: "Generate Timeline",
    printOrganigramme: "Print Organigramme",
    ovenConflictWarning: "Oven conflict",
    ovenConflictBoth: "both use the same oven between",
    timelineNotGenerated: "Enter target times above and click \"Generate Timeline\" to preview the production schedule.",
    targetTimeRequired: "Target out-of-oven time required",
    phaseTemplateBread: "Basic bread",
    phaseTemplateSourdough: "Sourdough",
    phaseTemplateBrioche: "Brioche",
    phaseTemplateCroissant: "Croissant / PLF",
    confirmReplacePhases: "Replace existing phases with this template?",
    myTemplates: "My Templates",
    builtInTemplates: "Built-in",
    enterTemplateName: "Template name…",
    deleteTemplate: "Delete template",
    deleteBatch: "Delete batch",
    delayBetweenBatches: "Delay between batches",
    calculateTiming: "Calculate timing",
    calculateTimingHint: "Auto-fill batch times from the first entered time, spaced by baking duration + delay",
    recipeModified: "Recipe modified",
    recipeModifiedHint: "One or more recipes have been updated. Click \"Generate Timeline\" to refresh the organigramme.",
    batchCount: "Number of batches",
    batchLabel: "Batch",
    defaultOven: "Default oven",
    defaultOvenOption: "Default oven",
    autoSuggestTimes: "Auto-suggest times",
    autoSuggestHint: "Space batch times backward by baking phase duration",
    noPhasesOrganigrammeHint: "Define production phases in the Recipe editor to include this recipe in the organigramme.",
    phases: "phases",
    baking: "Baking",
    cell: "cell",
    timesAreApproximate: "Times rounded up to nearest 15 min for display",
    and: "and",
    oven: "Oven",
    selectEquipment: "Equipment",
    compressionNote: "Shaded columns: 1 cell = 1 h (passive phases compressed). Other columns: 1 cell = 15 min.",
    printGenerated: "Print dialog opened",
    // Product Labels
    printLabel: "Print Label",
    labelPrintModal: "Print Product Labels",
    labelSize: "Label Size",
    labelSizeSmall: "Small (62×38mm) — Jar / Price label",
    labelSizeMedium: "Medium (100×50mm) — Standard food label",
    labelSizeLarge: "Large (100×150mm) — Full product label",
    labelSizeA4: "A4 Sheet (6 labels per page)",
    labelSizeMarket: "Market label (full page, A4 / Letter)",
    labelPaper: "Paper",
    labelPaperA4: "A4",
    labelPaperLetter: "US Letter",
    labelMarketOnePerProduct: "1 page per product",
    labelSizeThermal3x2: "Thermal (3×2 in) — Roll label (bread default)",
    labelSizeThermal4x2: "Thermal (4×2 in) — Roll label (large)",
    labelCopies: "Copies",
    labelOptions: "Label Options",
    labelShowWeight: "Show weight",
    labelShowPrice: "Show price",
    labelShowBestBefore: "Show best-before date field",
    labelShowStorage: "Show storage conditions",
    labelShowDisclaimer: "Show allergen disclaimer",
    labelStoragePlaceholder: "e.g., Keep refrigerated below 4°C",
    labelWeight: "Weight",
    labelNetWeight: "Net weight",
    labelBestBefore: "Best before",
    labelPreview: "Label Preview",
    labelNoIngredients: "No ingredients configured",
    labelNoIngredientsHint: "Link a recipe or set a custom ingredient list to show ingredients on labels",
    labelPopupBlocked: "If the print window didn't open, allow popups for this site.",
    labelPrint: "Print",
    labelClose: "Close",
    labelDisclaimerText: "Allergen information provided for guidance; may not cover cross-contamination.",
    labelDisclaimerPlaceholder: "Enter allergen disclaimer text…",
    // Production Labels
    labelProductionTitle: "Print Production Labels",
    labelProductionTotal: "total labels",
    labelProductionProducts: "Products & Quantities",
    labelProductionSkipped: "Unchecked products will be skipped",
    printPickupDate: "Pickup Date:",
    printTotalOrders: "Total Orders:",
    printTotalValue: "Total Value:",
    printOrderNumber: "Order #",
    printCustomer: "Customer:",
    printPhone: "Phone:",
    printTotal: "Total:",
    printProduct: "Product",
    printQuantity: "Quantity",
    printPrice: "Price",
    printAmount: "Amount",
    printOrderTotal: "Order Total",
    sortOrders: "Sort Orders",
    sortByCollectionPoint: "Sort by Collection Point",
    sortByTime: "Sort by Time",
    sortByCustomer: "Sort by Customer",
    sortByTotal: "Sort by Total",
    sortByNewest: "Newest First",
    sortByCustomerName: "Customer Name",
    collectionPointSummary: "Collection Point Summary",
    productionPerCollectionPoint: "Production per Collection Point",
    totalQuantity: "Total Quantity",
    collectionPointProduction: "Collection Point Production",
    smartDefault: "Smart Default",
    sortDefaultDescription: "Smart: Collection point first, then customer name",
    smartSortActive: "Smart sorting active",
    smartSortDescription: "Collection point first, then customer name",
    summaryProducts: "Products",
    summaryOrders: "Orders",
    unifiedProductionSummary: "Production Summary by Collection Point",
    productionTotal: "Total",
    productionSummary: "Production Summary",
    productionSummarySimple: "Production Summary",
    totalValue: "Total Value",
    grandTotal: "GRAND TOTAL",
    productBreakdown: "Product Breakdown by Collection Point",

    // Standalone Products (no recipe)
    standaloneProducts: "Standalone Products",
    standaloneProductsDescription: "Products without recipes (jam, bread bags, etc.) that can be sold directly",
    noStandaloneProducts: "No standalone products available. Create products without a recipe in Product Management.",
    quantityLimit: "Limit",
    unlimited: "Unlimited",
    standaloneProductsSection: "Standalone Products",

    // Errors & Warnings
    selectBaseRecipeFirst: "Please select a base recipe first",
    noRecipeSelected: "No recipe selected",
    invalidVariationQuantity: "Please enter a valid quantity for variation ingredients",
    insufficientBaseDough: "Insufficient base dough for this recipe",
    selectRecipe: "Select recipe...",
addRecipeButton: "Add Recipe",

// Subscription & Billing
subscriptionRequired: "Subscription Required",
subscriptionRequiredDescription: "Start your bakery journey with a 30-day free trial",
freeTrialBadge: "🎉 30-Day Free Trial",
month: "month",
afterTrialEnds: "After trial ends",
unlimitedProducts: "Unlimited products",
unlimitedOrders: "Unlimited orders",
customerManagement: "Customer management",
customBranding: "Custom branding",
emailSupport: "Email support",
startFreeTrial: "Start Free Trial",
redirectingToCheckout: "Redirecting to checkout...",
securePaymentByStripe: "Secure payment processing by Stripe",
howTrialWorks: "How the free trial works",
trialDetail1: "Full access to all features for 30 days",
trialDetail2: "No credit card required to start",
trialDetail3: "Cancel anytime during the trial",
notReadyYet: "Not ready yet? I'll decide later",
grandfatheredTitle: "Lifetime Access",
grandfatheredMessage: "You have lifetime free access to Digi-Bakery!",
grandfatheredThankYou: "Thank you for being an early supporter.",
subscriptionStatus: "Subscription Status",
statusActive: "Active",
statusCanceled: "Canceled",
statusTrialing: "Trial",
statusPastDue: "Past Due",
statusIncomplete: "Incomplete",
statusNone: "No Subscription",
trialActive: "Free Trial Active",
daysRemaining: "days remaining",
trialEndsToday: "Trial ends today",
gracePeriodActive: "Enjoy your free access",
daysRemainingToSubscribe: "days left",
gracePeriodEndsToday: "Last day of free access",
gracePeriodMessage: "You can keep using Digi-Bakery for free. Add your payment method anytime to start your 30-day free trial.",
gracePeriodBullet1: "No charge today",
gracePeriodBullet2: "Cancel anytime",
subscribeNow: "Start free trial",
gracePeriodExpired: "Grace Period Expired",
gracePeriodExpiredMessage: "Your 7-day grace period has expired. Please subscribe to continue using Digi-Bakery.",
plan: "Plan",
monthlySubscription: "Monthly Subscription",
nextBillingDate: "Next Billing Date",
paymentMethod: "Payment Method",
subscriptionCanceled: "Subscription Canceled",
subscriptionCanceledMessage: "Your subscription was canceled.",
canceledOn: "Canceled on",
resubscribe: "Subscribe Again",
chargedImmediately: "Charged immediately",
subscribe: "Subscribe",
resubscriptionDescription: "Continue your bakery journey",
accessUntil: "You will have access until",
manageBilling: "Manage Billing",
cancelSubscription: "Cancel Subscription",
confirmCancelSubscription: "Are you sure you want to cancel your subscription? You will maintain access until the end of your current billing period.",
subscriptionCancelSuccess: "Subscription canceled successfully. You will have access until the end of your billing period.",
paymentHistory: "Payment History",
paymentDate: "Date",
succeeded: "Succeeded",
failed: "Failed",
refunded: "Refunded",
subscription: "Subscription",
billing: "Billing",
subscriptionAndBilling: "Subscription & Billing",
subscriptionInactive: "Subscription Inactive",
subscriptionInactiveMessage: "Your subscription is currently inactive. Please update your payment method or subscribe to continue using Digi-Bakery.",
gracePeriodWarning: "Payment Failed - Grace Period",
paymentGracePeriodMessage: "Your payment failed. You have {days} days remaining to update your payment method before your access is restricted.",
updatePaymentMethod: "Update Payment Method",
reactivateSubscription: "Reactivate Subscription",

// Order Payment (Customer Payments to Baker)
completePayment: "Complete Payment",
securePaymentPoweredByStripe: "Secure payment powered by Stripe",
stripeLegalDisclaimer: "Payment processed securely by Stripe. digi-bakery.com does not handle or store payment information.",
stripePaymentIssuesInfo: "For payment issues, refunds, or chargebacks, contact Stripe directly.",
stripeSupportLink: "Stripe Support",
paymentSecurityTitle: "Payment Security & Dispute Resolution",
stripeProcessesPayments: "Stripe processes all customer payments securely. digi-bakery.com never stores or has access to payment card information.",
contactStripeForIssues: "For payment issues, refunds, or chargebacks, contact Stripe Support directly.",
cardInformation: "Card Information",
paymentOptions: "Payment Options",
configurePaymentMethods: "Configure how customers can pay for orders",
onlinePayments: "Online Payments",
acceptCreditCardsOnline: "Accept credit cards and digital wallets online",
stripeAccountRequired: "Stripe account required to receive payments",
connectStripeAccount: "Connect Stripe Account",
connectWithStripe: "Connect with Stripe",
receivePaymentsDirectly: "Receive payments directly to your bank account",
automaticPayouts: "Automatic payouts every 2 days",
noPlatformFees: "No platform fees - keep 100% (minus Stripe fees)",
secureConnectionByStripe: "Secure connection powered by Stripe",
understandOnlinePayments: "Understand online payments",
cashAtPickup: "Cash at Pickup",
acceptCashPayment: "Accept cash when customers collect orders",
cardAtPickup: "Card at Pickup",
acceptCardAtLocation: "Accept card payments at your location",
selectPaymentMethod: "Select Payment Method",
payOnline: "Pay Online",
payAtPickup: "Pay at Pickup",
payNow: "Pay Now",
proceedToPayment: "Proceed to Payment",
paymentRequired: "Payment Required",
paymentSuccessful: "Payment Successful!",
paymentFailed: "Payment Failed",
refundOrder: "Refund Order",
refundSuccessful: "Refund Successful",
paymentStatus: "Payment Status",
paidOnline: "Paid Online",
unpaid: "Unpaid",
paymentPending: "Pending",
paid: "Paid",
paymentRefunded: "Refunded",
// Payment status display labels
paymentStatusUnpaid: "Unpaid",
paymentStatusPending: "Processing",
paymentStatusPendingPaymentMethod: "Awaiting Card",
paymentStatusPaymentMethodSaved: "Card Saved",
paymentStatusPendingAuthorization: "Authorizing",
paymentStatusAuthorized: "Authorized",
paymentStatusRequiresCustomerAction: "Action Required",
paymentStatusAuthorizationFailed: "Auth Failed",
paymentStatusAuthorizationExpired: "Auth Expired",
paymentStatusVoided: "Voided",
paymentStatusPaid: "Paid",
paymentStatusFailed: "Failed",
paymentStatusRefunded: "Refunded",
orderPaymentSettings: "Order Payment Settings",
enableOnlinePayments: "Enable Online Payments",
requireOnlinePayment: "Require Online Payment",
requireOnlinePaymentDescription: "Customers must pay online before placing order",
acceptedPaymentMethods: "Accepted Payment Methods",
onlinePaymentEnabled: "Online payment enabled",
onlinePaymentDisabled: "Online payment disabled",
cashOnly: "Cash Only",
selectHowToPay: "Select how you want to pay",
securePayment: "Secure payment powered by Stripe",
processingPayment: "Processing payment...",
paymentProcessing: "Payment Processing",
redirectingToStripe: "Redirecting to Stripe checkout...",
paymentProceedToPayment: "Proceed to Payment",
paymentCanceled: "Payment Canceled",
paymentCanceledMessage: "Your payment was canceled. No charges were made to your card.",
orderNotPlaced: "Your order has not been placed. You can try again or pay at pickup.",
orderConfirmedPaid: "Order Confirmed & Paid",
viewMyOrders: "View My Orders",
autoRedirectIn: "Auto-redirect in",
needHelp: "Need help?",
contactSupport: "Contact support",
paymentNotCompleted: "Payment was not completed",
returnToShop: "Return to Shop",
viewReceipt: "View Receipt",
viewBatchImage: "View batch image",
attachBatchImage: "Attach batch photo",
replaceBatchImage: "Replace batch photo",
batchImage: "Batch Image",
downloadReceipt: "Download Receipt",
refundReason: "Refund Reason",
refundAmount: "Refund Amount",
processRefund: "Process Refund",
refundConfirmation: "Are you sure you want to refund this order?",
stripeAccountConnectedSuccess: "Stripe account connected successfully!",
missingInformation: "Missing information",
refreshingStatus: "Refreshing account status...",
paymentCountry: "Country",
openDashboard: "Open Dashboard",
stripeConnected: "Stripe Connected",
readyToAcceptPayments: "Ready to Accept Payments",

// Authorization/Capture Payment Statuses
authorizedOrders: "Authorized Orders",
paymentAuthorized: "Payment Authorized",
authorizationVoided: "Authorization Voided",
capturePayment: "Capture Payment",
captureAll: "Capture All",
declineOrder: "Decline Order",
paymentCaptured: "Payment Captured Successfully",
captureFailed: "Failed to Capture Payment",
declineFailed: "Failed to Decline Order",
authorizationExpired: "Authorization Expired",
willAutoCaptureAt: "Will auto-capture at",
authExpiresIn: "Authorization expires in",
cardSaved: "Payment Scheduled",
awaitingAuthorization: "Awaiting Authorization",
actionRequired: "Action Required",
authFailed: "Authorization Failed",
voidAuthorization: "Void Authorization",
voidConfirmation: "Are you sure you want to void this authorization? This will cancel the order.",
voidReason: "Void Reason",
voidSuccessful: "Authorization Voided Successfully",
batchCaptureConfirmation: "Are you sure you want to capture {count} payments?",
batchCaptureSuccess: "{successful} payments captured successfully, {failed} failed",
authorizationDetails: "Authorization Details",
authorizedAmount: "Authorized Amount",
captureScheduledFor: "Capture Scheduled For",
daysUntilExpiry: "{days} days until expiry",
hoursUntilCapture: "{hours} hours until capture",

// Product Deletion Warnings
cannotDeleteProduct: "Cannot delete product - it's currently being used:",
productUsedInProduction: "Product is used in {count} production day(s)",
productUsedInOrders: "Product is referenced in {count} customer order(s)",
productUsedInTemplates: "Product is used in {count} production template(s)",
includingFuturePlans: "(Including {count} future/active production day(s))",
includingRecentOrders: "(Including {count} recent order(s))",
toDeleteProduct: "To delete this product:",
removeFromProduction: "1. Remove it from all production days and templates",
considerOrderHistory: "2. Consider if deleting will affect order history reporting",
tryAgain: "3. Try again once it's no longer referenced",
deleteProductConfirm: "Delete \"{productName}\"? This action cannot be undone.",
dangerDeleteProduct: "DANGER: You're about to delete a product that's actively used!",
willCauseErrors: "This will cause:",
productionPlanningErrors: "• Production planning errors",
orderDisplayIssues: "• Order display issues",
brokenReports: "• Broken reports",
typeForceDelete: "Type \"FORCE DELETE\" to confirm:",
forceDelete: "Force Delete",
deletionCancelled: "Deletion cancelled for safety.",
productDeletedWarning: "Product deleted, but this may cause issues in:",
checkForErrors: "Please check your production days and orders for any errors.",
productDeletedSuccess: "Product deleted successfully!",

// Order Deletion
cancelOrders: "Cancel Selected Orders",
cancelOrderConfirmTitle: "Confirm Order Cancellation",
cancelOrderConfirm: "Are you sure you want to cancel the selected order(s)? Orders will be marked as cancelled and remain in your records.",
ordersCancelled: "Order(s) cancelled successfully!",

// Announcements
announcements: "Announcements",
newAnnouncement: "New Announcement",
editAnnouncement: "Edit Announcement",
title: "Title",
message: "Message",
announcementActive: "Active",
inactive: "Inactive",
style: "Style",
info: "Info",
warning: "Warning",
error: "Error",
rotationInterval: "Rotation Interval (seconds)",
rotationIntervalDescription: "How long to show each announcement before rotating (3-60 seconds)",
announcementTitle: "Announcement Title",
announcementMessage: "Announcement message...",
noAnnouncements: "No announcements yet",
createFirstAnnouncement: "Create your first announcement",
confirmDeleteAnnouncement: "Are you sure you want to delete this announcement?",
errorSavingAnnouncement: "Error saving announcement",
errorDeletingAnnouncement: "Error deleting announcement",
titleAndMessageRequired: "Title and message are required",
dismiss: "Dismiss",
activate: "Activate",
deactivate: "Deactivate",
from: "From",
startDate: "Start Date",
endDate: "End Date",

// Sales Reconciliation
salesReconciliation: "Sales Reconciliation",
completedProductionDays: "Completed Production Days",
selectProductionDay: "Select a Production Day",
selectCompletedDayToReconcile: "Select a completed production day to reconcile sales",
noCompletedProductionDays: "No completed production days found",
reconciled: "Reconciled",
saveReconciliation: "Save Reconciliation",
salesReconciliationSaved: "Sales reconciliation saved successfully!",
// Weather of the sales day
weatherOfTheDay: "Weather of the day",
weatherLoading: "Fetching the weather…",
weatherPickCondition: "Pick the weather of the day",
weatherAutoWas: "auto:",
weatherRefresh: "Refresh",
weatherUnavailable: "Weather data unavailable right now — you can still pick the condition.",
weatherNoLocation: "Add your postcode and town in Settings to record the weather automatically.",
postalCodeCityRequired: "Please enter your postcode and town.",
locationReminderTitle: "Add your bakery's postcode and town",
locationReminderText: "Required to complete your bakery profile — it is used by location-based features such as weather tracking.",
locationReminderButton: "Add now",
weatherGoToSettings: "Go to Settings",
weatherSunny: "Sunny",
weatherPartlyCloudy: "Partly cloudy",
weatherCloudy: "Cloudy",
weatherFog: "Fog",
weatherDrizzle: "Drizzle",
weatherRain: "Rain",
weatherSnow: "Snow",
weatherStorm: "Storm",
seasonSpring: "Spring",
seasonSummer: "Summer",
seasonAutumn: "Autumn",
seasonWinter: "Winter",
postalCode: "Postcode",
countryAddressHint: "Also sets the currency used in the app (see Application settings).",
addressProvince: "Province",
addressState: "State",
addressRegionChoose: "Choose…",
city: "Town",
postalCodeWeatherHint: "Required. Used by location-based features such as weather tracking.",
postalCodeSuggestedHint: "Suggested from your address — please check and save to confirm.",
weatherLocationNotFound: "Location not found — check the postcode and town.",
weatherLocationNotFoundToast: "Settings saved, but the postcode/town could not be located. Please check them.",
weatherAnalysisMenu: "Sales & weather",
weatherAnalysisTitle: "Sales & weather",
weatherDaysWithWeather: "reconciled days have weather data",
weatherDaysReconciled: "completed production days are reconciled",
weatherDaysNotReconciled: "not reconciled yet (not included in the analysis)",
weatherGoReconcile: "Reconcile",
weatherBackfillButton: "Fetch weather for {count} past days",
weatherBackfilling: "Fetching weather…",
weatherBackfillDone: "Weather added to {count} days",
weatherMetric: "Show",
weatherMetricRevenue: "Average revenue per day",
weatherMetricSold: "Average units sold per day",
weatherMetricSellThrough: "Sell-through (% of production sold)",
weatherSellThroughHint: "Sell-through only counts days where produced quantities were recorded when production was marked done.",
weatherAllProducts: "All products",
weatherWeekday: "Day of week",
weatherAllDays: "All days",
weatherFrom: "From",
weatherTo: "To",
weatherNoData: "No reconciled days with weather yet for these filters.",
weatherByCondition: "By weather",
weatherByTemperature: "By max temperature",
weatherBySeason: "By season",
weatherProductIndexTitle: "Products vs weather",
weatherProductIndexHint: "Average units sold under each weather, compared with the product's average per sales day. Only days when the product was actually baked or sold count. Cells with fewer than {min} days are greyed out.",
weatherAvgPerDay: "Avg / sales day",
weatherDays: "days",
weatherNotEnoughData: "not enough data",
applicationSettings: "Application settings",
dateFormatDescription: "Choose how dates are displayed throughout the application",
weatherTracking: "Weather tracking",
weatherTrackingDescription: "Records the weather of each sales day at reconciliation, shows the forecast when planning production, and adds the \"Sales & weather\" report. Uses your postcode and town.",
weatherTrackingOffMessage: "Weather tracking is turned off. Turn it on in Settings → Application settings to record the weather of your sales days and see how it affects your sales. Weather already recorded is kept.",
forecastTitle: "Forecast for the sale day",
forecastObservedTitle: "Weather on the sale day",
forecastObserved: "observed (recorded at reconciliation)",
forecastObservedShort: "observed",
forecastTrendHint: "forecast in {days} days — trend, may change",
forecastIndicativeHint: "forecast in {days} days — indicative only",
weatherFamily_dry: "sunny",
weatherFamily_grey: "grey",
weatherFamily_wet: "rainy",
weatherFamily_snow: "snowy",
insightExpected: "Forecast: {condition} on {day}",
insightSameWeekday: "On your past {family} {weekday}s ({n} days), compared with your usual sales that weekday:",
insightAnyDay: "Not enough similar {weekday}s yet — on all your past {family} days ({n} days):",
insightNotEnough: "Not enough history yet for {family} {weekday}s ({n} days). Insights will improve as you reconcile your sales.",
insightProductTooltip: "{match} sold on average on these days vs {all} usually ({n} days)",
insightShowAll: "Show all ({n})",
insightShowLess: "Show less",
insightFootnote: "Based on your reconciled sales — for information only, quantities are not changed. Pre-orders are collected whatever the weather.",
productsSold: "Products Sold",
reconciliationTotalOrdered: "Pre-Orders",
reconciliationTotalSold: "Total Sold",
product: "Product",
reconciliationOrdered: "Ordered",
reconciliationSold: "Sold",
reconciliationProduced: "Qty produced",
reconciliationProducedTooltip: "Units produced, recorded when production was marked done",
reconciliationOversoldUnits: "More units sold than produced — check the sold quantities",
productionDoughSummary: "Production Dough vs Sales",
producedDough: "Produced Dough",
doughSold: "Dough Sold",
remainingDough: "Remaining Dough",
recipeBalance: "Remaining Dough After Sales",
actualProduction: "Actual production",
plannedProduction: "Planned production",
doughOversoldWarning: "⚠ Sales exceed produced dough for at least one recipe.",
doughWithinProduction: "✓ Sales are within produced dough.",
noProductionData: "No recipe production data available for this day.",
unknownRecipe: "Unknown recipe",
noRecipeGroup: "Other products",
reconciliationOtherRevenue: "Other Revenue",
reconciliationTipsAndOtherSales: "Tips and Other Sales",
reconciliationOtherRevenueDescription: "Include tips, additional sales, or any other revenue not captured in product sales",
preOrdersOnly: "Pre-orders only",
orderedPreOrdersTooltip: "Pre-orders only (informational)",
doughOversoldInline: "⚠️ Sold more than produced ({amount})",
recipeDoughEquation: "{produced} produced − {sold} sold = {remaining} remaining",
needsReconciliation: "Needs reconciliation",
clickOnHighlightedDay: "Click on a highlighted day to reconcile sales. Lighter green indicates already reconciled days.",
sold: "Sold",
totalOrdered: "Total Ordered",
totalSold: "Total Sold",
totalRevenueForDay: "Total Revenue for Day",
itemsSold: "items sold",
otherRevenue: "Other Revenue",
tipsAndOtherSales: "Tips and Other Sales",
otherRevenueDescription: "Include tips, additional sales, or any other revenue not captured in product sales",
reconciliationOverview: "Reconciliation Overview",
totalCompletedProductionDays: "Total completed production days",

// Admin Settings (Date/Time Preferences)
adminSettings: "Admin Settings",
personalInfo: "Personal Information",
dateTimePreferences: "Date & Time Preferences",
dateFormatPreference: "Date Format",
timeFormat: "Time Format",
timezonePreference: "Timezone",
showTimezones: "Always show timezones",
preview: "Preview",
adminSettingsDescription: "Manage your profile and date/time preferences",
exchangeRatesTitle: "Currency Exchange Rates",
exchangeRatesDescription: "Configure exchange rates for revenue conversion to USD",
baseCurrency: "Base Currency (USD)",
saveExchangeRates: "Save Exchange Rates",
exchangeRatesSaved: "Exchange rates saved successfully",
exchangeRatesSaveError: "Failed to save exchange rates",
formatUS: "US Format",
formatEuropean: "European Format",
formatISO: "ISO Format",
format12Hour: "12-hour",
format24Hour: "24-hour",

  // Help Center
  helpCenter: "Help Center",
helpCenterDescription: "Guides and tutorials for using Digi-Bakery",
searchTutorials: "Search tutorials...",
allChapters: "All Chapters",
allTutorials: "All Tutorials",
videosInChapter: "videos",
videoInChapter: "video",
gettingStarted: "Getting Started",
duration: "Duration",
watchVideo: "Watch Video",
previousVideo: "Previous",
nextVideo: "Next",
relatedVideos: "Related Videos",
noResults: "No tutorials found",
noResultsDescription: "Try adjusting your search or browse by chapter",
closeVideo: "Close",
otherVideosInChapter: "Other videos in this chapter",
chapter: "Chapter",
sortBy: "Sort by",
sortByChapter: "By Chapter",
sortByDuration: "By Duration",
searching: "Searching for",
noResultsFor: "No results for",
trySearching: "Try searching for",
popularSearches: "Popular searches",
searchTip: "Tip: You can search by topic, chapter, or video title",

    // Chapter Titles
    chapter1Title: "Configure",
    chapter2Title: "Create",
    chapter3Title: "Plan",
    chapter4Title: "Sell",
    chapter5Title: "Analyze",
    chapter6Title: "Tips & Advice",

    // Help Center Contact
    contactHelpCenter: "Need additional help?",
    contactHelpCenterDescription: "Send us a message and we'll get back to you quickly.",

    // Pickup Mode
    pickupModeNav: "Pickup",
    pickupMode: "Pickup Mode",
    filterOpen: "Open",
    filterPicked: "Picked Up",
    sortByName: "By Name",
    confirmPickup: "Confirm Pickup",
    cancelPickup: "Cancel",
    orderPickedUp: "Picked Up",
    pendingSync: "pending sync",
    syncNow: "Sync Now",
    syncSuccess: "All pickups synced",
    syncError: "Sync failed — tap to retry",
    offlineStatus: "Offline",
    onlineStatus: "Online",
    syncingStatus: "Syncing…",
    offlineBanner: "Offline mode — pickups will sync automatically.",
    pickupConfirmTitle: "Confirm Pickup",
    alreadyPickedUpConflict: "This order was already picked up on another device.",
    collectionPointAll: "All Points",

    // Market Mode
    marketModeNav: "Market",
    marketMode: "Market Mode",
    marketModeTitle: "Market / Pickup Mode",
    marketModeSubtitle: "Register sales at your market stall",
    noCompletedProduction: "No completed production day found. Complete your production plan first.",
    selectProductionDayForMarket: "Select a production day",
    marketAvailableStock: "Available",
    marketSoldCount: "Sold",
    marketOverPlan: "Over plan",
    marketSoldOut: "Sold out",
    marketTotalRevenue: "Session Revenue",
    marketPendingSales: "pending sync",
    marketSyncSuccess: "All sales synced",
    marketSyncError: "Sync failed — tap to retry",
    marketOfflineBanner: "Offline mode — sales will sync automatically when back online.",
    endMarketDay: "End Market Session",
    marketSessionSummary: "Session Summary",
    marketSoldThisSession: "Sold this session",
    marketGoToReconciliation: "Go to Sales Reconciliation",
    marketContinueSelling: "Continue Selling",
    marketNoProducts: "No products found for this production day.",
    marketStockFromProduction: "Stock from production plan",
    marketPreOrdersDeducted: "Pre-orders deducted",
    marketHybridNote: "Hybrid mode: pre-orders are tracked separately. Available stock = produced − pre-orders.",
    marketSellOne: "Sell 1",
    marketUndoLast: "Undo",
    marketQtyPicker: "Sell multiple",
    marketSales: "Market / Onsite Sales",
    onsiteSales: "Sales registered via Market Mode",

    // Professional Pricing
    customerManagementNav: "Customer Management",
    professionalCustomers: "Professional Customers",
    inviteProfessional: "Invite Professional Customer",
    professionalPrice: "Professional Price",
    professionalBadge: "PRO",
    inviteSent: "Invitation sent",
    pendingInvite: "Pending",
    activeCustomer: "Active",
    expiredInvite: "Expired",
    cancelledInvite: "Cancelled",
    cancelInvite: "Cancel invitation",
    resendInvite: "Resend",
    acceptInvite: "Activate professional access",
    inviteAccepted: "Access activated",
    inviteExpired: "This invitation has expired. Please contact the bakery.",
    inviteInvalid: "Invalid invitation link.",
    inviteAlreadyAccepted: "This invitation has already been used.",
    inviteEmailMismatch: "This invitation was sent to a different email address. Please log in with the correct account.",
    companyName: "Company name",
    professionalLabel: "Type",
    allCustomers: "All Customers",
    invitations: "Invitations",
    noCustomersYet: "No customers yet",
    noInvitationsYet: "No invitations yet",
    customerType: "Type",
    onlineCustomer: "Online",
    offlineCustomer: "Offline",
    editCustomerRelationship: "Edit",
    saveRelationship: "Save",
    deleteRelationship: "Remove",
    relationshipNotes: "Notes",
    professionalPriceLabel: "Pro price",
    activatingAccess: "Activating your professional access...",
    signInToAcceptInvite: "Sign in to activate your professional access",

    // Shop QR Code
    shopQRCodeTitle: "Shop QR Code",
    shopQRCodeDescription: "Print this QR code on your market stand, business cards, flyers, or product packaging so customers can instantly access your online shop.",
    shopQRCodePublishFirst: "Publish your online shop before generating a QR code.",
    shopQRCodeError: "We couldn't generate your shop QR code. Please refresh the page and try again.",
    downloadPNG: "Download PNG",
    downloadSVG: "Download SVG",

  },  // End of en (English translations)

// Help content for contextual help system
  help_productManagement: {
    en: {
      title: "Product Management Help",
      description: "Learn how to create and manage your bakery products.",
      sections: [
        {
          title: "Important Rules",
          content: "Key constraints and limitations when managing products.",
          warningList: [
            "You cannot delete : ",
            "- a product that is planned for production",
            "- a product that has been ordered by customers",
            "- a product that is used in production templates"
          ]
        },
        {
          title: "Creating Products",
          content: "Products are the items your customers can order from your shop.",
          steps: [
            "Click 'Add New Product' to create a product",
            "Fill in the product name, description, and price",
            "Link the product to a recipe for production planning",
            "Set the dough weight (final product weight)",
            "Add variation ingredients if needed (nuts, chocolate, etc.)",
            "Upload a product image (optional but recommended)"
          ],
          tips: [
            "Use clear, descriptive names that customers will understand",
            "Include preparation details in the description",
            "Square images work best for product displays",
            "Link products to recipes to enable automatic production planning"
          ]
        },
        {
          title: "Base Recipe Settings",
          content: "Connect your products to recipes for accurate production planning.",
          steps: [
            "Select a base recipe from your recipe library",
            "Set the final dough weight for this product",
            "Add variation ingredients (mixed-in or add-on)",
            "Mixed-in ingredients reduce base dough needed",
            "Add-on ingredients are added after shaping"
          ],
          warnings: [
            "Dough weight should include all ingredients (base + variations)",
            "Variations affect production costs and planning"
          ]
        },
        {
          title: "Cost Management",
          content: "Track costs and profitability for each product.",
          tips: [
            "Manual costs override recipe-based calculations",
            "System shows estimated costs based on your stock purchases",
            "Margin calculations help you price products profitably",
            "Insufficient stock warnings help prevent production issues"
          ]
        },
        {
          title: "Ingredients & Allergens Display",
          content: "Show ingredient lists and allergen information to customers in your online shop.",
          steps: [
            "Enable 'Show ingredients in shop' toggle when creating or editing a product",
            "The system automatically builds the ingredient list from the linked recipe",
            "Variation ingredients (mix-ins, add-ons) are included in the list",
            "Allergens are highlighted in bold with their allergen name in parentheses"
          ],
          tips: [
            "Mark ingredients as allergens in Stock Management first",
            "Allergen names (e.g., 'Gluten', 'Tree Nut') help customers identify specific allergens",
            "The ingredient list updates automatically when you change the recipe or variations",
            "Preview shows exactly how ingredients will appear to customers"
          ],
          warnings: [
            "A recipe must be linked to the product for the ingredient list to appear",
            "Ensure all allergens are properly marked in Stock Management before enabling this feature"
          ]
        },
        {
          title: "Professional Price (B2B)",
          content: "Offer a lower price to professional customers such as restaurants, cafés, or caterers.",
          steps: [
            "Set a 'Professional Price' on any product (optional field below the regular price)",
            "Go to Customer Management and mark a customer as PRO",
            "The PRO customer sees the professional price in the online shop with a PRO badge",
            "Regular customers always see the standard price — the professional price is never shown publicly"
          ],
          tips: [
            "Professional pricing applies only to advance online orders, never to Market Mode sales",
            "The professional status is per-bakery — a customer can be PRO at your bakery and retail elsewhere",
            "The Sales Reconciliation shows a separate PRO row for each product so you can track B2B revenue",
            "Leave the professional price empty if you don't want to offer a B2B price for that product"
          ],
          warnings: [
            "Professional pricing is NOT applied automatically — you must explicitly mark each customer as PRO in Customer Management",
            "Market Mode sales always use the standard catalog price regardless of professional status"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion des Produits",
      description: "Apprenez à créer et gérer vos produits de boulangerie.",
      sections: [
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la gestion des produits.",
          warningList: [
            "Vous ne pouvez pas supprimer : ",
            "- un produit qui est prévu pour la production",
            "- un produit qui a été commandé par les clients",
            "- un produit qui est utilisé dans les modèles de production"
          ]
        },
        {
          title: "Création de Produits",
          content: "Les produits sont les articles que vos clients peuvent commander dans votre boutique.",
          steps: [
            "Cliquez sur 'Ajouter un Nouveau Produit' pour créer un produit",
            "Remplissez le nom, la description et le prix du produit",
            "Liez le produit à une recette pour la planification de production",
            "Définissez le poids de pâte (poids final du produit)",
            "Ajoutez des ingrédients de variation si nécessaire (noix, chocolat, etc.)",
            "Téléchargez une image du produit (optionnel mais recommandé)"
          ],
          tips: [
            "Utilisez des noms clairs et descriptifs que les clients comprendront",
            "Incluez les détails de préparation dans la description",
            "Les images carrées fonctionnent mieux pour l'affichage des produits",
            "Liez les produits aux recettes pour activer la planification automatique de production"
          ]
        },
        {
          title: "Paramètres de Recette de Base",
          content: "Connectez vos produits aux recettes pour une planification de production précise.",
          steps: [
            "Sélectionnez une recette de base dans votre bibliothèque de recettes",
            "Définissez le poids final de pâte pour ce produit",
            "Ajoutez des ingrédients de variation (mélangés ou ajoutés)",
            "Les ingrédients mélangés réduisent la pâte de base nécessaire",
            "Les ingrédients ajoutés sont ajoutés après le façonnage"
          ],
          warnings: [
            "Le poids de pâte doit inclure tous les ingrédients (base + variations)",
            "Les variations affectent les coûts de production et la planification"
          ]
        },
        {
          title: "Gestion des Coûts",
          content: "Suivez les coûts et la rentabilité de chaque produit.",
          tips: [
            "Les coûts manuels remplacent les calculs basés sur les recettes",
            "Le système montre les coûts estimés basés sur vos achats de stock",
            "Les calculs de marge vous aident à prix les produits de manière rentable",
            "Les avertissements de stock insuffisant aident à prévenir les problèmes de production"
          ]
        },
        {
          title: "Affichage des Ingrédients & Allergènes",
          content: "Affichez la liste des ingrédients et les informations sur les allergènes aux clients dans votre boutique en ligne.",
          steps: [
            "Activez l'option 'Afficher les ingrédients en boutique' lors de la création ou modification d'un produit",
            "Le système construit automatiquement la liste des ingrédients à partir de la recette liée",
            "Les ingrédients de variation (incorporés, ajoutés) sont inclus dans la liste",
            "Les allergènes sont mis en évidence en gras avec leur nom d'allergène entre parenthèses"
          ],
          tips: [
            "Marquez d'abord les ingrédients comme allergènes dans la Gestion du Stock",
            "Les noms d'allergènes (ex: 'Gluten', 'Fruits à coque') aident les clients à identifier les allergènes spécifiques",
            "La liste des ingrédients se met à jour automatiquement lorsque vous modifiez la recette ou les variations",
            "L'aperçu montre exactement comment les ingrédients apparaîtront aux clients"
          ],
          warnings: [
            "Une recette doit être liée au produit pour que la liste des ingrédients apparaisse",
            "Assurez-vous que tous les allergènes sont correctement marqués dans la Gestion du Stock avant d'activer cette fonctionnalité"
          ]
        },
        {
          title: "Prix Professionnel (B2B)",
          content: "Offrez un tarif réduit aux clients professionnels tels que restaurants, cafés ou traiteurs.",
          steps: [
            "Définissez un 'Prix Professionnel' sur n'importe quel produit (champ optionnel sous le prix habituel)",
            "Allez dans Gestion Clients et marquez un client comme PRO",
            "Le client PRO voit le prix professionnel dans la boutique avec un badge PRO",
            "Les clients habituels voient toujours le prix standard — le prix professionnel n'est jamais affiché publiquement"
          ],
          tips: [
            "Le tarif professionnel s'applique uniquement aux précommandes en ligne, jamais aux ventes en Mode Marché",
            "Le statut professionnel est par boulangerie — un client peut être PRO chez vous et client habituel ailleurs",
            "Le Rapprochement des Ventes affiche une ligne PRO séparée pour chaque produit afin de suivre le chiffre d'affaires B2B",
            "Laissez le prix professionnel vide si vous ne souhaitez pas offrir de tarif B2B pour ce produit"
          ],
          warnings: [
            "Le tarif professionnel n'est PAS appliqué automatiquement — vous devez explicitement marquer chaque client comme PRO dans Gestion Clients",
            "Les ventes en Mode Marché utilisent toujours le prix catalogue standard, quel que soit le statut professionnel"
          ]
        }
      ]
    }
  },

  help_customerManagement: {
    en: {
      title: "Customer Management Help",
      description: "Manage your customer relationships and offer professional pricing to B2B clients.",
      sections: [
        {
          title: "Customer List",
          content: "Your customer list is built automatically from three sources: past orders, your offline customer records, and accepted professional invitations.",
          tips: [
            "Online customers (🌐) have a Digi-Bakery account and placed orders through the shop",
            "Offline customers (👤) were added manually by you via Register Order",
            "Customers appear automatically — no manual entry needed if they have already ordered"
          ]
        },
        {
          title: "Professional (PRO) Status",
          content: "Mark a customer as PRO to automatically apply professional pricing on their online orders.",
          steps: [
            "Toggle the PRO switch directly in the customer list to activate or deactivate professional pricing",
            "The change takes effect immediately on their next order",
            "PRO customers see a PRO badge and the reduced price on every eligible product in the shop"
          ],
          tips: [
            "Professional status is per-bakery — activating it here only affects orders placed at your shop",
            "For offline customers (Register Order), the baker sees a PRO badge when selecting the customer and the pro price is applied automatically",
            "You can toggle PRO status on or off at any time"
          ],
          warnings: [
            "Professional pricing only applies to advance online orders — Market Mode sales always use the standard price",
            "A product must have a Professional Price set in Product Management for the discount to apply"
          ]
        },
        {
          title: "Sending Invitations",
          content: "Invite a professional customer by email so they can create an account and receive automatic PRO pricing.",
          steps: [
            "Go to the Invitations tab and click 'Invite Professional Customer'",
            "Enter the customer's name, email, company name, and business type",
            "Click Send — an invitation email is sent with a secure activation link",
            "The customer clicks the link, signs in (or creates an account), and PRO pricing is activated automatically",
            "The invitation expires after 7 days"
          ],
          tips: [
            "You can resend an invitation if the customer did not receive it or if it expired",
            "Once accepted, the customer appears in the All Customers tab with PRO status active",
            "The invitation link is single-use and tied to the invited email address"
          ],
          warnings: [
            "The customer must sign in with the exact email address the invitation was sent to",
            "Pending invitations that have expired can be cancelled and re-sent"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion Clients",
      description: "Gérez vos relations clients et proposez des tarifs professionnels à vos clients B2B.",
      sections: [
        {
          title: "Liste des Clients",
          content: "Votre liste de clients est constituée automatiquement à partir de trois sources : commandes passées, fiches clients hors-ligne et invitations professionnelles acceptées.",
          tips: [
            "Les clients en ligne (🌐) ont un compte Digi-Bakery et ont commandé via la boutique",
            "Les clients hors-ligne (👤) ont été ajoutés manuellement via Enregistrer une Commande",
            "Les clients apparaissent automatiquement — aucune saisie manuelle nécessaire s'ils ont déjà commandé"
          ]
        },
        {
          title: "Statut Professionnel (PRO)",
          content: "Marquez un client comme PRO pour appliquer automatiquement le tarif professionnel sur ses commandes en ligne.",
          steps: [
            "Activez le bouton PRO directement dans la liste des clients pour activer ou désactiver le tarif professionnel",
            "Le changement prend effet immédiatement sur sa prochaine commande",
            "Les clients PRO voient un badge PRO et le tarif réduit sur chaque produit éligible dans la boutique"
          ],
          tips: [
            "Le statut professionnel est par boulangerie — l'activer ici n'affecte que les commandes passées dans votre boutique",
            "Pour les clients hors-ligne (Enregistrer une Commande), le boulanger voit un badge PRO lors de la sélection du client et le tarif pro est appliqué automatiquement",
            "Vous pouvez activer ou désactiver le statut PRO à tout moment"
          ],
          warnings: [
            "Le tarif professionnel s'applique uniquement aux précommandes en ligne — les ventes en Mode Marché utilisent toujours le prix standard",
            "Un produit doit avoir un Prix Professionnel défini dans Gestion des Produits pour que la réduction s'applique"
          ]
        },
        {
          title: "Envoi d'Invitations",
          content: "Invitez un client professionnel par e-mail pour qu'il crée un compte et bénéficie automatiquement du tarif PRO.",
          steps: [
            "Allez dans l'onglet Invitations et cliquez sur 'Inviter un Client Professionnel'",
            "Saisissez le nom, l'e-mail, le nom de l'entreprise et le type d'activité du client",
            "Cliquez sur Envoyer — un e-mail d'invitation est envoyé avec un lien d'activation sécurisé",
            "Le client clique sur le lien, se connecte (ou crée un compte) et le tarif PRO est activé automatiquement",
            "L'invitation expire après 7 jours"
          ],
          tips: [
            "Vous pouvez renvoyer une invitation si le client ne l'a pas reçue ou si elle a expiré",
            "Une fois acceptée, le client apparaît dans l'onglet Tous les Clients avec le statut PRO actif",
            "Le lien d'invitation est à usage unique et lié à l'adresse e-mail invitée"
          ],
          warnings: [
            "Le client doit se connecter avec l'adresse e-mail exacte à laquelle l'invitation a été envoyée",
            "Les invitations en attente expirées peuvent être annulées et renvoyées"
          ]
        }
      ]
    }
  },

  help_recipeManager: {
    en: {
      title: "Recipe Management Help",
      description: "Learn how to create and manage your bakery recipes.",
      sections: [
        {
          title: "Important Rules",
          content: "Key constraints and limitations when managing recipes.",
          warnings: [
            "To preserve Data integrity, recipe are hidden instead of deleted if they are linked to an active products",
          ]
        },
        {
          title: "Creating Recipes",
          content: "Recipes define the ingredients and process for your baked goods.",
          steps: [
            "Click 'Create New Recipe' to start",
            "Enter a recipe name and base flour amount",
            "Add ingredients to different sections (Main Dough, etc.)",
            "Set baker's percentages for each ingredient",
            "Add notes for special instructions",
            "Link to equipment for production planning"
          ],
          tips: [
            "Use sections to organize complex recipes",
            "Base flour amount determines scaling calculations",
            "Baker's percentages show ingredient ratios",
            "Equipment linking helps with production capacity planning"
          ]
        },
        {
          title: "Recipe Sections",
          content: "Organize your recipes into logical sections.",
          steps: [
            "Main Dough section for primary ingredients",
            "Add custom sections for different recipe parts",
            "Move sections up/down to change order",
            "Each section can have its own notes"
          ],
          tips: [
            "Use sections for pre-ferments, soakers, or different dough stages",
            "Section order affects mixing instructions",
            "Notes help bakers understand special techniques"
          ]
        },
        {
          title: "Cost Tracking",
          content: "Monitor ingredient costs and recipe profitability.",
          tips: [
            "System calculates costs based on your stock purchases",
            "Hydration percentage helps with dough consistency",
            "Total dough yield shows final product weight",
            "Cost per kg helps with pricing decisions"
          ]
        },
        {
          title: "Ingredient Management",
          content: "Manage your full ingredient list directly from the Recipe Manager.",
          steps: [
            "Click 'Manage Ingredients' (settings icon) next to the 'Your Recipes' header",
            "Browse and search your complete ingredient list",
            "Click the pen icon to rename an ingredient (English and French names) or change its allergen flag",
            "Click the trash icon to delete an unused ingredient",
            "Check boxes next to multiple ingredients and click 'Delete selected' for bulk deletion",
            "Click '+ Add Custom Ingredient' to add a new ingredient to your list"
          ],
          tips: [
            "Ingredients used in a recipe cannot be deleted — the Recipes column shows which ones",
            "Ingredients with stock purchase records cannot be deleted — check the In Stock column",
            "System ingredients (Flour, Butter, Eggs, etc.) can be deleted if they are not used in any recipe and have no stock records",
            "Renaming an ingredient updates it everywhere: recipes, stock, and the shop"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion des Recettes",
      description: "Apprenez à créer et gérer vos recettes de boulangerie.",
      sections: [
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la gestion des recettes.",
          warnings: [
            "Afin de conserver l'intégrité des données, les recettes sont masquées plutôt que supprimées si elles sont liées à des produits actifs.",
                      ]
        },
        {
          title: "Création de Recettes",
          content: "Les recettes définissent les ingrédients et le processus pour vos produits cuits.",
          steps: [
            "Cliquez sur 'Créer une Nouvelle Recette' pour commencer",
            "Entrez un nom de recette et la quantité de farine de base",
            "Ajoutez des ingrédients à différentes sections (Pâte Principale, etc.)",
            "Définissez les pourcentages boulanger pour chaque ingrédient",
            "Ajoutez des notes pour les instructions spéciales",
            "Liez à l'équipement pour la planification de production"
          ],
          tips: [
            "Utilisez des sections pour organiser les recettes complexes",
            "La quantité de farine de base détermine les calculs de mise à l'échelle",
            "Les pourcentages boulanger montrent les ratios d'ingrédients",
            "La liaison d'équipement aide à la planification de capacité de production"
          ]
        },
        {
          title: "Sections de Recette",
          content: "Organisez vos recettes en sections logiques.",
          steps: [
            "Section Pâte Principale pour les ingrédients primaires",
            "Ajoutez des sections personnalisées pour différentes parties de recette",
            "Déplacez les sections haut/bas pour changer l'ordre",
            "Chaque section peut avoir ses propres notes"
          ],
          tips: [
            "Utilisez des sections pour les pré-ferments, les trempages, ou différentes étapes de pâte",
            "L'ordre des sections affecte les instructions de mélange",
            "Les notes aident les boulangers à comprendre les techniques spéciales"
          ]
        },
        {
          title: "Suivi des Coûts",
          content: "Surveillez les coûts d'ingrédients et la rentabilité des recettes.",
          tips: [
            "Le système calcule les coûts basés sur vos achats de stock",
            "Le pourcentage d'hydratation aide avec la consistance de la pâte",
            "Le rendement total de pâte montre le poids final du produit",
            "Le coût par kg aide aux décisions de prix"
          ]
        },
        {
          title: "Gestion des Ingrédients",
          content: "Gérez votre liste complète d'ingrédients directement depuis le Gestionnaire de Recettes.",
          steps: [
            "Cliquez sur 'Gérer les Ingrédients' (icône paramètres) à côté de l'en-tête 'Vos Recettes'",
            "Parcourez et recherchez votre liste complète d'ingrédients",
            "Cliquez sur l'icône crayon pour renommer un ingrédient (noms anglais et français) ou modifier son statut d'allergène",
            "Cliquez sur l'icône corbeille pour supprimer un ingrédient non utilisé",
            "Cochez plusieurs ingrédients et cliquez sur 'Supprimer la sélection' pour une suppression groupée",
            "Cliquez sur '+ Ajouter Ingrédient Personnalisé' pour ajouter un nouvel ingrédient à votre liste"
          ],
          tips: [
            "Les ingrédients utilisés dans une recette ne peuvent pas être supprimés — la colonne Recettes indique lesquels",
            "Les ingrédients avec des achats en stock ne peuvent pas être supprimés — vérifiez la colonne En Stock",
            "Les ingrédients système (Farine, Beurre, Œufs, etc.) peuvent être supprimés s'ils ne sont pas utilisés dans une recette et sans achat en stock",
            "Renommer un ingrédient le met à jour partout : recettes, stock et boutique"
          ]
        }
      ]
    }
  },

  help_equipmentManager: {
    en: {
      title: "Equipment Management Help",
      description: "Learn how to manage your bakery equipment.",
      sections: [
        {
          title: "Important Rules",
          content: "Key constraints and limitations when managing equipment.",
          warnings: [
            "You cannot delete equipment that is linked to active recipes",
            "Equipment capacity affects production planning calculations"
          ]
        },
        {
          title: "Adding Equipment",
          content: "Track your mixing and baking equipment for production planning.",
          steps: [
            "Click 'Add New Equipment'",
            "Enter equipment name and type",
            "Set maximum flour capacity in kg",
            "Equipment is used for recipe scaling calculations"
          ],
          tips: [
            "Accurate capacity settings prevent over-planning",
            "Different equipment types help organize your bakery",
            "Capacity affects how many batches you can mix"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion de l'Équipement",
      description: "Apprenez à gérer votre équipement de boulangerie.",
      sections: [
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la gestion de l'équipement.",
          warnings: [
            "Vous ne pouvez pas supprimer l'équipement qui est lié à des recettes actives",
            "La capacité de l'équipement affecte les calculs de planification de production"
          ]
        },
        {
          title: "Ajout d'Équipement",
          content: "Suivez votre équipement de mélange et cuisson pour la planification de production.",
          steps: [
            "Cliquez sur 'Ajouter Nouvel Équipement'",
            "Entrez le nom et le type d'équipement",
            "Définissez la capacité maximale de farine en kg",
            "L'équipement est utilisé pour les calculs de mise à l'échelle des recettes"
          ],
          tips: [
            "Les paramètres de capacité précis empêchent la sur-planification",
            "Les différents types d'équipement aident à organiser votre boulangerie",
            "La capacité affecte le nombre de lots que vous pouvez mélanger"
          ]
        }
      ]
    }
  },

  help_shoppingList: {
    en: {
      title: "Shopping List Help",
      description: "Generate a consolidated ingredient list for one or more upcoming production days.",
      sections: [
        {
          title: "Selecting Production Days",
          content: "Use the calendar to pick which future production days to include. Days with production planned show an amber dot. Click to select or deselect. Use 'Select all' to include every upcoming day.",
          tips: [
            "Past days and days with no production are grayed out and cannot be selected.",
            "You can select non-consecutive days — the date range label will list all dates."
          ]
        },
        {
          title: "How Quantities Are Calculated",
          content: "For each recipe on a selected day, the tool scales ingredient quantities from the recipe to the planned dough weight.",
          steps: [
            "If the baker saved manual adjustments (slider) for that day → uses those saved quantities.",
            "Otherwise → uses the planned dough limit set when the production day was created.",
            "Scale factor = planned dough weight ÷ recipe total yield.",
            "Each ingredient quantity = recipe ingredient × scale factor.",
            "Quantities are accumulated across all selected days."
          ]
        },
        {
          title: "Stock Columns",
          content: "If you use stock management, the list shows Stock Available and Missing columns. If you have not entered any stock purchases, only the Total Needed column is shown with an info note.",
          tips: [
            "Add stock purchases in the Stock Management screen to unlock the missing quantity calculation.",
            "Stock is matched by ingredient key — make sure your purchases are linked to the same ingredients as your recipes."
          ]
        },
        {
          title: "Export Options",
          content: "Three ways to share your list:",
          steps: [
            "Print → opens a clean, professional print dialog in a new window.",
            "Export CSV → downloads a spreadsheet-ready file with UTF-8 encoding (accents preserved).",
            "Copy → copies a tab-separated version to your clipboard."
          ]
        }
      ]
    },
    fr: {
      title: "Aide — Liste de courses",
      description: "Générez une liste consolidée d'ingrédients pour un ou plusieurs jours de production à venir.",
      sections: [
        {
          title: "Sélectionner les jours de production",
          content: "Utilisez le calendrier pour choisir les jours de production à inclure. Les jours avec une production planifiée affichent un point ambré. Cliquez pour sélectionner ou désélectionner. Utilisez 'Tout sélectionner' pour inclure tous les jours à venir.",
          tips: [
            "Les jours passés et ceux sans production sont grisés et ne peuvent pas être sélectionnés.",
            "Vous pouvez sélectionner des jours non consécutifs — le libellé listera toutes les dates."
          ]
        },
        {
          title: "Comment les quantités sont calculées",
          content: "Pour chaque recette d'un jour sélectionné, l'outil met à l'échelle les ingrédients en fonction du poids de pâte prévu.",
          steps: [
            "Si le boulanger a enregistré des ajustements manuels (curseur) pour ce jour → utilise ces quantités sauvegardées.",
            "Sinon → utilise la limite de pâte planifiée définie à la création du jour de production.",
            "Facteur d'échelle = poids de pâte prévu ÷ rendement total de la recette.",
            "Quantité de chaque ingrédient = ingrédient recette × facteur d'échelle.",
            "Les quantités sont cumulées sur tous les jours sélectionnés."
          ]
        },
        {
          title: "Colonnes de stock",
          content: "Si vous utilisez la gestion du stock, la liste affiche les colonnes Stock disponible et Manquant. Si vous n'avez pas saisi d'achats, seule la colonne Total nécessaire est affichée avec une note d'information.",
          tips: [
            "Ajoutez des achats dans l'écran Gestion du stock pour activer le calcul des quantités manquantes.",
            "Le stock est associé par clé d'ingrédient — vérifiez que vos achats sont liés aux mêmes ingrédients que vos recettes."
          ]
        },
        {
          title: "Options d'export",
          content: "Trois façons de partager votre liste :",
          steps: [
            "Imprimer → ouvre un aperçu d'impression propre et professionnel dans une nouvelle fenêtre.",
            "Exporter CSV → télécharge un fichier tableur en UTF-8 (accents préservés).",
            "Copier → copie une version tabulée dans votre presse-papiers."
          ]
        }
      ]
    }
  },

  help_productionDays: {
    en: {
      title: "Production Days Management Help",
      description: "Learn how to plan and schedule your production days.",
      sections: [
        {
          title: "Important Rules",
          content: "Key constraints and limitations when managing production days.",
          warnings: [
            "You cannot delete completed production days",
            "The collection days is the day that will appear in the shop.",

          ]
        },
        {
          title: "Creating Production Days",
          content: "Schedule when you'll bake different products.",
          steps: [
            "Use calendar view to select production dates",
            "Choose pickup timing (same day or next day)",
            "Set order cutoff times",
            "Apply production templates for quick setup",
            "Add products and set quantities for each date"
          ],
          tips: [
            "Plan production 1-2 days before customer pickup",
            "Use templates to speed up recurring schedules",
            "Consider your baking schedule and customer preferences"
          ]
        },
        {
          title: "Recipe-Based Production",
          content: "Use recipes to automatically calculate production quantities.",
          steps: [
            "Select 'Recipe-Based Production' option",
            "Choose a base recipe",
            "Set total dough limit for the recipe",
            "Enable products that use this recipe",
            "System calculates optimal production quantities"
          ],
          tips: [
            "Recipe-based planning ensures ingredient efficiency",
            "Dough limits prevent over-production",
            "Multiple products can share the same recipe batch"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion des Jours de Production",
      description: "Apprenez à planifier et programmer vos jours de production.",
      sections: [
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la gestion des jours de production.",
          warnings: [
            "Vous ne pouvez pas supprimer les jours de production terminés",
            "Le jour se collecte est le jour qui apparaîtra dans la boutique.",
          ]
        },
        {
          title: "Création de Jours de Production",
          content: "Planifiez quand vous cuirez différents produits.",
          steps: [
            "Utilisez la vue calendrier pour sélectionner les dates de production",
            "Choisissez le calendrier de collecte (même jour ou lendemain)",
            "Définissez les heures limites de commande",
            "Appliquez des modèles de production pour une configuration rapide",
            "Ajoutez des produits et définissez les quantités pour chaque date"
          ],
          tips: [
            "Planifiez la production 1-2 jours avant la collecte client",
            "Utilisez des modèles pour accélérer les horaires récurrents",
            "Considérez votre horaire de cuisson et les préférences clients"
          ]
        },
        {
          title: "Production Basée sur Recettes",
          content: "Utilisez les recettes pour calculer automatiquement les quantités de production.",
          steps: [
            "Sélectionnez l'option 'Production Basée sur Recettes'",
            "Choisissez une recette de base",
            "Définissez la limite totale de pâte pour la recette",
            "Activez les produits qui utilisent cette recette",
            "Le système calcule les quantités de production optimales"
          ],
          tips: [
            "La planification basée sur recettes assure l'efficacité des ingrédients",
            "Les limites de pâte empêchent la sur-production",
            "Plusieurs produits peuvent partager le même lot de recette"
          ]
        }
      ]
    }
  },

  help_productionPlanning: {
    en: {
      title: "Production Planning Help",
      description: "Learn how to plan your production batches and ingredient needs.",
      sections: [
        {
          title: "Important Rules",
          content: "Key constraints and limitations when planning production.",
          warnings: [
            "Production cannot be marked as done with insufficient stock",
          ]
        },
        {
          title: "Planning Production",
          content: "Calculate ingredient requirements for your production days.",
          steps: [
            "Select a production day from the dropdown",
            "Review products to be made and quantities",
            "Sort the production order by dragging recipes up/down - this impacts traceability to ensure the right lot/batch numbers are linked to the order of production",
            "Check ingredient requirements and availability",
            "Adjust waste factor for testing and losses",
            "Review batch planning for mixing equipment"
          ],
          tips: [
            "Plan ahead to ensure ingredient availability",
            "The production order affects how ingredients are consumed from stock - sort recipes to match your preferred batch/lot sequence for traceability",
            "Waste factors account for testing and production losses",
            "Batch planning optimizes equipment usage"
          ]
        },
        {
          title: "Scaling Recipes",
          content: "Adjust production quantities based on orders and capacity.",
          steps: [
            "Use scale controls to adjust recipe production",
            "Scale all recipes or individual ones",
            "Reset to base limits when needed",
            "Monitor dough capacity and ingredient availability"
          ],
          tips: [
            "Scale up for high-demand periods",
            "Scale down to match actual orders",
            "Monitor capacity to avoid equipment overload"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Planification de Production",
      description: "Apprenez à planifier vos lots de production et besoins en ingrédients.",
      sections: [
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la planification de production.",
          warnings: [
            "La production ne peut pas être marquée comme terminée avec un stock insuffisant",
          ]
        },
        {
          title: "Planification de Production",
          content: "Calculez les besoins en ingrédients pour vos jours de production.",
          steps: [
            "Sélectionnez un jour de production dans la liste déroulante",
            "Vérifiez les produits à faire et les quantités",
            "Triez l'ordre de production en faisant glisser les recettes vers le haut/bas - cela impacte la traçabilité pour assurer que les bons numéros de lot/lot sont liés à l'ordre de production",
            "Contrôlez les besoins en ingrédients et la disponibilité",
            "Ajustez le facteur de perte pour les tests et pertes",
            "Vérifiez la planification des lots pour l'équipement de mélange"
          ],
          tips: [
            "Planifiez à l'avance pour assurer la disponibilité des ingrédients",
            "L'ordre de production affecte la façon dont les ingrédients sont consommés du stock - triez les recettes pour correspondre à votre séquence préférée de lot/lot pour la traçabilité",
            "Les facteurs de perte tiennent compte des tests et pertes de production",
            "La planification des lots optimise l'utilisation de l'équipement"
          ]
        },
        {
          title: "Mise à l'Échelle des Recettes",
          content: "Ajustez les quantités de production basées sur les commandes et la capacité.",
          steps: [
            "Utilisez les contrôles d'échelle pour ajuster la production de recettes",
            "Mettez à l'échelle toutes les recettes ou individuellement",
            "Réinitialisez aux limites de base si nécessaire",
            "Surveillez la capacité de pâte et la disponibilité des ingrédients"
          ],
          tips: [
            "Augmentez pour les périodes de forte demande",
            "Diminuez pour correspondre aux commandes réelles",
            "Surveillez la capacité pour éviter la surcharge d'équipement"
          ]
        }
      ]
    }
  },

  help_productionTemplates: {
    en: {
      title: "Production Templates Help",
      description: "Learn how to create and use production templates.",
      sections: [
        {
          title: "Important Rules",
          content: "Key constraints and limitations when managing production templates.",
          warnings: [
            "You cannot delete templates that are used in production days",
            "Template changes affect only future productions using them"
          ]
        },
        {
          title: "Creating Templates",
          content: "Save common production schedules as reusable templates.",
          steps: [
            "Click 'Create New Template'",
            "Choose template type (weekday, weekend, special event)",
            "Add products and set typical quantities",
            "Save the template for future use"
          ],
          tips: [
            "Create templates for regular schedules",
            "Use different templates for holidays or events",
            "Templates save time when planning production"
          ]
        },
        {
          title: "Using Templates",
          content: "Apply templates when creating production days.",
          steps: [
            "Go to Production Days Management",
            "Click 'Create from Template'",
            "Select your template",
            "Adjust quantities for specific dates",
            "Save the production day"
          ],
          tips: [
            "Templates provide starting points, not final plans",
            "Always adjust quantities based on actual orders",
            "Use calendar selection to apply templates to multiple dates"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Modèles de Production",
      description: "Apprenez à créer et utiliser des modèles de production.",
      sections: [
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la gestion des modèles de production.",
          warnings: [
            "Vous ne pouvez pas supprimer les modèles qui sont utilisés dans les jours de production",
            "Les changements de modèle affectent seulement les productions futures les utilisant"
          ]
        },
        {
          title: "Création de Modèles",
          content: "Sauvegardez les horaires de production courants comme modèles réutilisables.",
          steps: [
            "Cliquez sur 'Créer un Nouveau Modèle'",
            "Choisissez le type de modèle (jour de semaine, fin de semaine, événement spécial)",
            "Ajoutez des produits et définissez les quantités typiques",
            "Sauvegardez le modèle pour une utilisation future"
          ],
          tips: [
            "Créez des modèles pour les horaires réguliers",
            "Utilisez différents modèles pour les vacances ou événements",
            "Les modèles font gagner du temps lors de la planification de production"
          ]
        },
        {
          title: "Utilisation des Modèles",
          content: "Appliquez des modèles lors de la création de jours de production.",
          steps: [
            "Allez à Gestion des Jours de Production",
            "Cliquez sur 'Créer à partir du Modèle'",
            "Sélectionnez votre modèle",
            "Ajustez les quantités pour des dates spécifiques",
            "Sauvegardez le jour de production"
          ],
          tips: [
            "Les modèles fournissent des points de départ, pas des plans finals",
            "Ajustez toujours les quantités basées sur les commandes réelles",
            "Utilisez la sélection calendrier pour appliquer des modèles à plusieurs dates"
          ]
        }
      ]
    }
  },

  help_bakerOrders: {
    en: {
      title: "Orders Management Help",
      description: "Learn how to manage customer orders and fulfillment.",
      sections: [
        {
          title: "Important Rules",
          content: "Key constraints and limitations when managing orders.",
          warnings: [
            "You cannot delete completed orders",
            "Order status updates are permanent",
          ]
        },
        {
          title: "Viewing Orders",
          content: "Track and manage all customer orders.",
          steps: [
            "Use filters to view orders by production date",
            "Use pickup filters (All, Pending, Picked) to focus your list",
            "Green check icon next to the order number = order already picked up",
            "Cancelled orders are clearly marked with a red cancellation status",
            "Payment status is shown on each order (pay at pickup or online payment state)",
            "For online payment status meanings (Payment scheduled, Payment authorized, Paid, Refunded), go to Settings > Payment Options"
          ],
        },
        {
          title: "Order Registration",
          content: "Manually create orders for phone or in-person customers.",
          steps: [
            "Click 'Register Order' from the menu",
            "Search and select customer or add new customer",
            "Choose products and set quantities",
            "Set pickup date and add special instructions",
            "Process payment and confirm order"
          ],
          tips: [
            "Use customer search to avoid duplicates",
            "Set realistic pickup dates based on production schedule",

          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion des Commandes",
      description: "Apprenez à gérer les commandes clients et l'exécution.",
      sections: [
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la gestion des commandes.",
          warnings: [
            "Vous ne pouvez pas supprimer les commandes terminées",
            "Les mises à jour du statut de commande sont permanentes",
          ]
        },
        {
          title: "Visualisation des Commandes",
          content: "Suivez et gérez toutes les commandes clients.",
          steps: [
            "Utilisez les filtres pour voir les commandes par date de production",
            "Utilisez les filtres de retrait (Toutes, En attente, Récupéré) pour cibler votre liste",
            "L'icône verte avec coche à côté du numéro de commande = commande déjà récupérée",
            "Les commandes annulées sont clairement affichées avec un statut rouge d'annulation",
            "Le statut de paiement est affiché sur chaque commande (paiement au retrait ou état du paiement en ligne)",
            "Pour la signification des statuts de paiement en ligne (Paiement programmé, Paiement autorisé, Payé, Remboursé), allez dans Paramètres > Options de paiement"
          ],
        },
        {
          title: "Enregistrement de Commande",
          content: "Créez manuellement des commandes pour les clients par téléphone ou en personne.",
          steps: [
            "Cliquez sur 'Enregistrer Commande' dans le menu",
            "Recherchez et sélectionnez un client ou ajoutez un nouveau client",
            "Choisissez les produits et définissez les quantités",
            "Définissez la date de collecte et ajoutez des instructions spéciales",
            "Traitez le paiement et confirmez la commande"
          ],
          tips: [
            "Utilisez la recherche client pour éviter les doublons",
            "Définissez des dates de collecte réalistes basées sur le calendrier de production",
          ]
        }
      ]
    }
  },

  help_pickupMode: {
    en: {
      title: "Pickup Mode Help",
      description: "Quick guide to mark orders as picked up, including offline and sync behavior.",
      sections: [
        {
          title: "How To Use Pickup Mode",
          content: "Use this screen during handoff to customers.",
          steps: [
            "Choose the pickup date from the calendar",
            "Optionally select a collection point and search for a customer",
            "Tap Confirm Pickup on the correct order",
            "Review Open and Picked filters to track progress"
          ],
          tips: [
            "The order moves to Picked after confirmation",
            "Use sort by time to follow collection windows faster"
          ]
        },
        {
          title: "Online / Offline And Sync",
          content: "Pickup confirmations work online and offline.",
          steps: [
            "Online badge (green) means confirmations sync immediately",
            "Offline badge (red) means confirmations are stored on this device first",
            "When you see Pending sync, reconnect and tap the sync badge",
            "Always sync before ending service to push all pickup data"
          ],
          warnings: [
            "Do not leave with pending sync data after service",
            "If another device already confirmed the same order, you will see a conflict message"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Mode Retrait",
      description: "Guide rapide pour marquer les commandes récupérées, y compris le mode hors ligne et la synchronisation.",
      sections: [
        {
          title: "Comment Utiliser le Mode Retrait",
          content: "Utilisez cet écran pendant la remise des commandes aux clients.",
          steps: [
            "Choisissez la date de retrait dans le calendrier",
            "Sélectionnez si besoin un point de collecte et recherchez le client",
            "Appuyez sur Confirmer le retrait sur la bonne commande",
            "Utilisez les filtres En attente et Récupéré pour suivre l'avancement"
          ],
          tips: [
            "La commande passe dans Récupéré après confirmation",
            "Utilisez le tri par heure pour suivre plus vite les créneaux de collecte"
          ]
        },
        {
          title: "En Ligne / Hors Ligne Et Synchronisation",
          content: "Les confirmations de retrait fonctionnent en ligne et hors ligne.",
          steps: [
            "Badge En ligne (vert) : les confirmations sont synchronisées immédiatement",
            "Badge Hors ligne (rouge) : les confirmations sont d'abord stockées sur cet appareil",
            "Si vous voyez sync en attente, reconnectez-vous puis appuyez sur le badge de synchronisation",
            "Synchronisez toujours avant la fin du service pour envoyer toutes les données de retrait"
          ],
          warnings: [
            "Ne terminez pas le service avec des données en attente de synchronisation",
            "Si un autre appareil a déjà confirmé la même commande, un message de conflit s'affichera"
          ]
        }
      ]
    }
  },

  help_marketMode: {
    en: {
      title: "Market Mode Help",
      description: "Quick guide to recording walk-up sales at your market stall, including offline and sync behavior.",
      sections: [
        {
          title: "How To Use Market Mode",
          content: "Use this screen to sell products in real-time at a market or pop-up stall.",
          steps: [
            "Select the production day matching today's stock",
            "Tap the + button on a product card to record a sale",
            "Use the quantity picker for multi-unit sales",
            "Tap Undo on a card to reverse the last sale for that product",
            "Check the total revenue counter at the top to track your session"
          ],
          tips: [
            "Stock remaining updates instantly so you know what's left",
            "Sales recorded offline will sync when you reconnect"
          ]
        },
        {
          title: "Stock Limits & Warnings",
          content: "Market mode tracks stock against your planned production quantities.",
          steps: [
            "Green pill shows remaining planned stock",
            "Amber warning appears when you sell beyond planned quantity",
            "∞ symbol means no stock limit was set for that product"
          ],
          warnings: [
            "Selling over your planned quantity is allowed but flagged — review your production plan if this happens often"
          ]
        },
        {
          title: "Online / Offline And Sync",
          content: "Market sales work fully offline so you never miss a transaction.",
          steps: [
            "Online badge (green) means sales sync to the server immediately",
            "Offline badge (red) means sales are stored on this device first",
            "When you see Pending sync, reconnect and tap the sync badge",
            "Always sync before leaving your stall to push all sales data"
          ],
          warnings: [
            "Do not close the app with pending sync data after your session",
            "Syncing on a poor connection may take a moment — wait for the confirmation"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Mode Marché",
      description: "Guide rapide pour enregistrer les ventes au comptoir sur votre stand, y compris le mode hors ligne et la synchronisation.",
      sections: [
        {
          title: "Comment Utiliser le Mode Marché",
          content: "Utilisez cet écran pour vendre des produits en temps réel sur un marché ou un stand éphémère.",
          steps: [
            "Sélectionnez la journée de production correspondant au stock du jour",
            "Appuyez sur + sur une carte produit pour enregistrer une vente",
            "Utilisez le sélecteur de quantité pour les ventes multi-unités",
            "Appuyez sur Annuler sur une carte pour annuler la dernière vente de ce produit",
            "Suivez le compteur de revenu total en haut pour suivre votre session"
          ],
          tips: [
            "Le stock restant se met à jour instantanément pour savoir ce qu'il reste",
            "Les ventes enregistrées hors ligne se synchronisent à la reconnexion"
          ]
        },
        {
          title: "Limites de Stock et Avertissements",
          content: "Le mode marché suit le stock par rapport aux quantités de production prévues.",
          steps: [
            "La pastille verte indique le stock planifié restant",
            "Un avertissement amber apparaît si vous vendez au-delà de la quantité prévue",
            "Le symbole ∞ signifie qu'aucune limite de stock n'est définie pour ce produit"
          ],
          warnings: [
            "Vendre au-delà de votre quantité prévue est autorisé mais signalé — vérifiez votre plan de production si cela arrive souvent"
          ]
        },
        {
          title: "En Ligne / Hors Ligne Et Synchronisation",
          content: "Les ventes en mode marché fonctionnent entièrement hors ligne pour ne manquer aucune transaction.",
          steps: [
            "Badge En ligne (vert) : les ventes sont synchronisées immédiatement",
            "Badge Hors ligne (rouge) : les ventes sont d'abord stockées sur cet appareil",
            "Si vous voyez sync en attente, reconnectez-vous puis appuyez sur le badge de synchronisation",
            "Synchronisez toujours avant de quitter votre stand pour envoyer toutes les données de vente"
          ],
          warnings: [
            "Ne fermez pas l'application avec des données en attente de synchronisation après votre session",
            "La synchronisation sur une connexion faible peut prendre un moment — attendez la confirmation"
          ]
        }
      ]
    }
  },

  help_reports: {
    en: {
      title: "Reports & Analytics Help",
      description: "Learn how to use reports to track your bakery performance.",
      sections: [
        {
          title: "Sales Reports",
          content: "Analyze your sales performance and revenue trends.",
          steps: [
            "Select date range (last 7 days, 30 days, custom)",
            "Review total revenue and order counts",
            "Check average order value",
            "Analyze product sales performance",
            "Export data for external analysis"
          ],
          tips: [
            "Use custom date ranges for specific analysis periods",
            "Compare performance across different time periods",
            "Track seasonal trends in product popularity"
          ]
        },
        {
          title: "Understanding Metrics",
          content: "Key metrics to monitor your bakery's health.",
          tips: [
            "Revenue shows total sales before expenses",
            "Average order value indicates pricing effectiveness",
            "Product performance helps optimize your menu",
            "Order status distribution shows fulfillment efficiency"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Rapports et Analyses",
      description: "Apprenez à utiliser les rapports pour suivre les performances de votre boulangerie.",
      sections: [
        {
          title: "Rapports de Ventes",
          content: "Analysez les performances de ventes et les tendances de revenus.",
          steps: [
            "Sélectionnez la période (7 derniers jours, 30 jours, personnalisée)",
            "Vérifiez le revenu total et les nombres de commandes",
            "Contrôlez la valeur moyenne des commandes",
            "Analysez les performances de ventes par produit",
            "Exportez les données pour analyse externe"
          ],
          tips: [
            "Utilisez des périodes personnalisées pour des périodes d'analyse spécifiques",
            "Comparez les performances entre différentes périodes",
            "Suivez les tendances saisonnières dans la popularité des produits"
          ]
        },
        {
          title: "Compréhension des Métriques",
          content: "Métriques clés pour surveiller la santé de votre boulangerie.",
          tips: [
            "Le revenu montre les ventes totales avant dépenses",
            "La valeur moyenne des commandes indique l'efficacité des prix",
            "Les performances des produits aident à optimiser votre menu",
            "La distribution des statuts de commande montre l'efficacité d'exécution"
          ]
        }
      ]
    }
  },

  help_wasteReports: {
    en: {
      title: "Waste Reports Help",
      description: "Learn how to track and analyze ingredient waste.",
      sections: [

        {
          title: "Recording Waste",
          content: "Track when ingredients are discarded or wasted.",
          steps: [
            "Go to Stock Management",
            "Use 'Discard Stock' for expired or damaged items",
            "Select discard reason (expired, damaged, error, other)",
            "Enter quantity discarded",
            "Waste is automatically recorded for reporting"
          ],
          tips: [
            "Regular waste tracking improves inventory management",
            "Categorize waste reasons to identify patterns",
            "Monitor waste costs to optimize purchasing"
          ]
        },
        {
          title: "Waste Reports",
          content: "Analyze waste patterns and costs.",
          steps: [
            "View waste by ingredient type",
            "Check waste by reason categories",
            "Monitor waste over time trends",
            "Calculate total waste costs"
          ],
          tips: [
            "Use waste reports to reduce unnecessary losses",
            "Identify suppliers with quality issues",
            "Adjust purchasing based on waste patterns"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Rapports de Déchets",
      description: "Apprenez à suivre et analyser les déchets d'ingrédients.",
      sections: [
        {
          title: "Enregistrement des Déchets",
          content: "Suivez quand les ingrédients sont jetés ou gaspillés.",
          steps: [
            "Allez à Gestion du Stock",
            "Utilisez 'Jeter du Stock' pour les articles expirés ou endommagés",
            "Sélectionnez la raison de rejet (expiré, endommagé, erreur, autre)",
            "Entrez la quantité jetée",
            "Les déchets sont automatiquement enregistrés pour les rapports"
          ],
          tips: [
            "Le suivi régulier des déchets améliore la gestion des stocks",
            "Catégorisez les raisons de déchets pour identifier les patterns",
            "Surveillez les coûts de déchets pour optimiser les achats"
          ]
        },
        {
          title: "Rapports de Déchets",
          content: "Analysez les patterns de déchets et coûts.",
          steps: [
            "Visualisez les déchets par type d'ingrédient",
            "Vérifiez les déchets par catégories de raison",
            "Surveillez les tendances de déchets dans le temps",
            "Calculez les coûts totaux de déchets"
          ],
          tips: [
            "Utilisez les rapports de déchets pour réduire les pertes inutiles",
            "Identifiez les fournisseurs avec des problèmes de qualité",
            "Ajustez les achats basés sur les patterns de déchets"
          ]
        }
      ]
    }
  },

  help_announcementManager: {
    en: {
      title: "Announcement Manager Help",
      description: "Learn how to create and manage announcements for your bakery's homepage.",
      sections: [
        
        {
          title: "Creating Announcements",
          content: "Create announcements to communicate important information to your customers.",
          steps: [
            "Click 'New Announcement' to create an announcement",
            "Enter a clear, concise title and message",
            "Set start and end dates (optional) for time-sensitive announcements",
            "Choose a style (Info, Warning, Success) to match the message type",
            "Set the rotation interval for how long each announcement displays",
            "Mark as active to start showing the announcement"
          ],
          tips: [
            "Use clear, action-oriented language in your announcements",
            "Keep messages brief - customers scan quickly",
            "Use appropriate styles: Info for general updates, Warning for important notices",
            "Test rotation intervals to ensure smooth transitions"
          ]
        },
        {
          title: "Managing Announcements",
          content: "Control which announcements are displayed and their order.",
          steps: [
            "View all announcements in the list below",
            "Use the eye icon to activate/deactivate announcements",
            "Click edit to modify existing announcements",
            "Click delete to remove announcements permanently",
            "Announcements are ordered by creation date (newest first)"
          ],
          tips: [
            "Deactivate old announcements instead of deleting them",
            "Keep only 2-3 active announcements for best user experience",
            "Regularly review and update announcement content",
            "Use start/end dates for seasonal or temporary messages"
          ]
        },
        {
          title: "Rotation and Display",
          content: "How announcements appear on your homepage.",
          steps: [
            "Only active announcements are displayed",
            "Announcements rotate automatically based on interval setting",
            "Each announcement shows for the specified number of seconds",
          ],
          tips: [
            "Set rotation intervals between 3-10 seconds for good readability",
            "Longer intervals (15-30 seconds) for complex announcements",
            "Test on your homepage to ensure proper display",
            "Consider customer reading speed when setting intervals"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestionnaire d'Annonces",
      description: "Apprenez à créer et gérer les annonces pour la page d'accueil de votre boulangerie.",
      sections: [
        {
          title: "Création d'Annonces",
          content: "Créez des annonces pour communiquer des informations importantes à vos clients.",
          steps: [
            "Cliquez sur 'Nouvelle Annonce' pour créer une annonce",
            "Entrez un titre et un message clairs et concis",
            "Définissez les dates de début et de fin (optionnel) pour les annonces urgentes",
            "Choisissez un style (Info, Avertissement, Succès) selon le type de message",
            "Définissez l'intervalle de rotation pour la durée d'affichage de chaque annonce",
            "Marquez comme actif pour commencer à afficher l'annonce"
          ],
          tips: [
            "Utilisez un langage clair et orienté action dans vos annonces",
            "Gardez les messages brefs - les clients lisent rapidement",
            "Utilisez les styles appropriés : Info pour les mises à jour générales, Avertissement pour les avis importants",
            "Testez les intervalles de rotation pour assurer des transitions fluides"
          ]
        },
        {
          title: "Gestion des Annonces",
          content: "Contrôlez quelles annonces sont affichées et leur ordre.",
          steps: [
            "Visualisez toutes les annonces dans la liste ci-dessous",
            "Utilisez l'icône œil pour activer/désactiver les annonces",
            "Cliquez sur modifier pour changer les annonces existantes",
            "Cliquez sur supprimer pour retirer les annonces définitivement",
            "Les annonces sont ordonnées par date de création (plus récent d'abord)"
          ],
          tips: [
            "Désactivez les anciennes annonces au lieu de les supprimer",
            "Gardez seulement 2-3 annonces actives pour la meilleure expérience utilisateur",
            "Vérifiez et mettez à jour régulièrement le contenu des annonces",
            "Utilisez les dates de début/fin pour les messages saisonniers ou temporaires"
          ]
        },
        {
          title: "Rotation et Affichage",
          content: "Comment les annonces apparaissent sur votre page d'accueil.",
          steps: [
            "Seules les annonces actives sont affichées",
            "Les annonces tournent automatiquement selon le paramètre d'intervalle",
            "Chaque annonce s'affiche pendant le nombre de secondes spécifié",
          ],
          tips: [
            "Définissez les intervalles de rotation entre 3-10 secondes pour une bonne lisibilité",
            "Intervalles plus longs (15-30 secondes) pour les annonces complexes",
            "Testez sur votre page d'accueil pour assurer un affichage correct",
            "Considérez la vitesse de lecture des clients lors de la définition des intervalles"
          ]
        }
      ]
    }
  },

  help_salesReconciliation: {
    en: {
      title: "Sales Reconciliation Help",
      description: "Learn how to reconcile your sales data after completing production days.",
      sections: [
        {
          title: "What is Sales Reconciliation?",
          content: "Sales reconciliation compares what you planned to sell (ordered quantities) with what you actually sold. This helps track your bakery's performance and revenue accuracy.",
          tips: [
            "Reconciliation ensures your financial records match actual sales",
            "Track waste and unsold products for better planning",
            "Use this data to improve future production planning"
          ]
        },
        {
          title: "How to Reconcile Sales",
          content: "Reconcile sales for each completed production day to record actual sales data.",
          steps: [
            "Select a completed production day from the left panel",
            "Review the 'Ordered' vs 'Sold' quantities for each product",
            "Adjust the 'Sold' quantities to match what you actually sold",
            "Add any 'Other Revenue' like tips or additional sales",
            "Click 'Save Reconciliation' to record the data"
          ],
          tips: [
            "Sold quantities should never exceed ordered quantities",
            "If you sold less than ordered, adjust down to reflect reality",
            "Include all revenue sources in the 'Other Revenue' section",
            "Reconciliation data is permanent once saved"
          ]
        },
        {
          title: "Understanding the Data",
          content: "Key metrics shown during reconciliation.",
          tips: [
            "Total Ordered: Sum of all customer orders for this production",
            "Total Sold: What you actually sold (adjustable)",
            "Total Revenue: Calculated from sold quantities × prices + other revenue",
            "Reconciled status shows which days have been processed"
          ],
          warnings: [
            "Only reconcile completed production days",
            "Once saved, reconciliation data cannot be changed",
            "Accurate reconciliation is important for financial reporting"
          ]
        },
        {
          title: "Dough Production Tracking",
          content: "Track how much dough was produced vs. sold for each recipe to monitor efficiency and waste.",
          steps: [
            "View the 'Produced Dough' column showing total dough made for each recipe",
            "See 'Dough Sold' calculated from the quantities actually sold",
            "Check 'Remaining Dough' to see leftover dough after sales",
            "The equation shows: Produced - Sold = Remaining"
          ],
          tips: [
            "Positive remaining dough indicates leftover that may become waste",
            "Use this data to adjust future production quantities",
            "Large remainders suggest over-production for that recipe",
            "Consistent small remainders are normal and expected"
          ],
          warnings: [
            "If 'Dough Sold' exceeds 'Produced', you may have sold more than planned (check your order data)",
            "Dough weights are calculated from product dough weight × quantity sold"
          ]
        },
        {
          title: "Best Practices",
          content: "Tips for effective sales reconciliation.",
          tips: [
            "Reconcile sales as soon as production is complete",
            "Keep detailed records of any waste or unsold products",
            "Use reconciliation data to improve future production planning",
            "Regular reconciliation helps identify sales trends"
          ]
        },
        {
          title: "Weather of the day",
          content: "The weather of the sales day is fetched automatically from your postcode and town (Settings) and saved with the reconciliation.",
          tips: [
            "Click a weather chip to correct it if the day felt different (e.g. a storm in the morning)",
            "No postcode yet? You can still pick the weather by hand",
            "See the trends in Reports → Sales & weather"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Rapprochement des Ventes",
      description: "Apprenez à rapprocher vos données de ventes après avoir terminé les jours de production.",
      sections: [
        {
          title: "Qu'est-ce que le Rapprochement des Ventes ?",
          content: "Le rapprochement des ventes compare ce que vous avez prévu de vendre (quantités commandées) avec ce que vous avez réellement vendu. Cela aide à suivre les performances de votre boulangerie et l'exactitude des revenus.",
          tips: [
            "Le rapprochement assure que vos enregistrements financiers correspondent aux ventes réelles",
            "Suivez les pertes et produits invendus pour une meilleure planification",
            "Utilisez ces données pour améliorer la planification de production future"
          ]
        },
        {
          title: "Comment Rapprocher les Ventes",
          content: "Rapprochez les ventes pour chaque jour de production terminé pour enregistrer les données de ventes réelles.",
          steps: [
            "Sélectionnez un jour de production terminé dans le panneau gauche",
            "Vérifiez les quantités 'Commandées' vs 'Vendues' pour chaque produit",
            "Ajustez les quantités 'Vendues' pour correspondre à ce que vous avez réellement vendu",
            "Ajoutez tout 'Autre Revenu' comme pourboires ou ventes supplémentaires",
            "Cliquez sur 'Sauvegarder le Rapprochement' pour enregistrer les données"
          ],
          tips: [
            "Les quantités vendues ne devraient jamais dépasser les quantités commandées",
            "Si vous avez vendu moins que commandé, ajustez vers le bas pour refléter la réalité",
            "Incluez toutes les sources de revenus dans la section 'Autre Revenu'",
            "Les données de rapprochement sont permanentes une fois sauvegardées"
          ]
        },
        {
          title: "Comprendre les Données",
          content: "Métriques clés affichées pendant le rapprochement.",
          tips: [
            "Total Commandé : Somme de toutes les commandes clients pour cette production",
            "Total Vendu : Ce que vous avez réellement vendu (ajustable)",
            "Revenus Totaux : Calculés à partir des quantités vendues × prix + autres revenus",
            "Le statut rapproché montre quels jours ont été traités"
          ],
          warnings: [
            "Rapprochez seulement les jours de production terminés",
            "Une fois sauvegardé, les données de rapprochement ne peuvent pas être changées",
            "Un rapprochement précis est important pour les rapports financiers"
          ]
        },
        {
          title: "Suivi de la Production de Pâte",
          content: "Suivez la quantité de pâte produite vs vendue pour chaque recette afin de surveiller l'efficacité et les pertes.",
          steps: [
            "Consultez la colonne 'Pâte Produite' montrant le total de pâte fabriquée pour chaque recette",
            "Voyez 'Pâte Vendue' calculée à partir des quantités réellement vendues",
            "Vérifiez 'Pâte Restante' pour voir la pâte restante après les ventes",
            "L'équation montre : Produit - Vendu = Restant"
          ],
          tips: [
            "Une pâte restante positive indique un surplus qui peut devenir des pertes",
            "Utilisez ces données pour ajuster les quantités de production futures",
            "Des surplus importants suggèrent une surproduction pour cette recette",
            "De petits surplus constants sont normaux et attendus"
          ],
          warnings: [
            "Si 'Pâte Vendue' dépasse 'Produit', vous avez peut-être vendu plus que prévu (vérifiez vos données de commande)",
            "Les poids de pâte sont calculés à partir du poids de pâte du produit × quantité vendue"
          ]
        },
        {
          title: "Meilleures Pratiques",
          content: "Conseils pour un rapprochement des ventes efficace.",
          tips: [
            "Rapprochez les ventes dès que la production est terminée",
            "Gardez des enregistrements détaillés de toute perte ou produit invendu",
            "Utilisez les données de rapprochement pour améliorer la planification de production future",
            "Le rapprochement régulier aide à identifier les tendances de ventes"
          ]
        },
        {
          title: "Météo du jour",
          content: "La météo du jour de vente est récupérée automatiquement à partir de votre code postal et de votre ville (Paramètres) et enregistrée avec le rapprochement.",
          tips: [
            "Cliquez sur une pastille météo pour la corriger si la journée a été différente (ex. orage le matin)",
            "Pas encore de code postal ? Vous pouvez choisir la météo à la main",
            "Consultez les tendances dans Rapports → Ventes & météo"
          ]
        }
      ]
    }
  },

  help_weatherAnalysis: {
    en: {
      title: "Sales & Weather Help",
      description: "See how the weather and the seasons affect your sales.",
      sections: [
        {
          title: "Where the data comes from",
          content: "Each reconciled day stores the weather of that day. Weather is fetched from your postcode and town set in Settings.",
          tips: [
            "Use 'Fetch weather for past days' once to add the weather to days reconciled before this feature existed",
            "Weather data by Open-Meteo.com"
          ]
        },
        {
          title: "Reading the charts",
          content: "Compare average revenue, units sold or sell-through by weather, temperature and season.",
          tips: [
            "Filter by day of week so market days are not mixed with weekdays",
            "Sell-through (% of production sold) is the most reliable signal: on a good day you may simply sell out",
            "Greyed bars and cells have fewer than 3 days — wait for more data before drawing conclusions",
            "In the product table, +20% means that product sells 20% more than usual under that weather"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Ventes & Météo",
      description: "Voyez comment la météo et les saisons influencent vos ventes.",
      sections: [
        {
          title: "D'où viennent les données",
          content: "Chaque jour rapproché enregistre la météo du jour. La météo est récupérée à partir du code postal et de la ville indiqués dans les Paramètres.",
          tips: [
            "Utilisez une fois « Récupérer la météo des jours passés » pour ajouter la météo aux jours rapprochés avant cette fonctionnalité",
            "Données météo : Open-Meteo.com"
          ]
        },
        {
          title: "Lire les graphiques",
          content: "Comparez le chiffre d'affaires moyen, les unités vendues ou l'écoulement selon la météo, la température et la saison.",
          tips: [
            "Filtrez par jour de la semaine pour ne pas mélanger les jours de marché et la semaine",
            "L'écoulement (% de la production vendue) est le signal le plus fiable : un bon jour, vous pouvez simplement être en rupture",
            "Les barres et cases grisées ont moins de 3 jours — attendez plus de données avant de conclure",
            "Dans le tableau produits, +20 % signifie que le produit se vend 20 % de plus que d'habitude par ce temps"
          ]
        }
      ]
    }
  },

  help_fixedCosts: {
    en: {
      title: "Fixed Costs Management Help",
      description: "Learn how to manage fixed costs, calculate cost per gram of dough, and close monthly accounting periods.",
      sections: [
        {
          title: "What are Fixed Costs?",
          content: "Fixed costs are recurring business expenses that don't change with production volume, such as rent, utilities, and insurance.",
          tips: [
            "Fixed costs are distributed across your production to calculate true product costs",
            "The 'Fixed Cost per Gram' helps you price products accurately",
            "Regular tracking helps identify cost-saving opportunities"
          ]
        },
        {
          title: "Managing Fixed Cost Items",
          content: "Add and manage your recurring monthly expenses.",
          steps: [
            "Click 'Add Fixed Cost' to create a new expense item",
            "Enter a name and monthly amount",
            "Select a category (Rent, Utilities, Insurance, Labor, Subscriptions, Other)",
            "Toggle 'Active' to include/exclude from calculations"
          ],
          tips: [
            "Categories help organize and analyze your costs",
            "Inactive items are preserved but excluded from totals",
            "Update amounts when costs change (e.g., rent increases)"
          ]
        },
        {
          title: "Planning Method & Cost per Gram",
          content: "Configure how fixed costs are distributed across your production.",
          steps: [
            "Choose 'Calendar Month' to use a specific month's production data",
            "Or choose 'Production Template' to use a template's planned dough output",
            "Set 'Production Days per Week' for template-based calculations",
            "The system calculates: Monthly Fixed Costs ÷ Monthly Dough (grams) = Cost per Gram"
          ],
          tips: [
            "Calendar method uses actual production history",
            "Template method is useful for planning and projections",
            "Example: €1500 monthly costs ÷ 150kg dough = €0.01 per gram",
            "A 700g loaf at €0.01/g adds €7.00 in fixed costs"
          ]
        },
        {
          title: "Monthly Close",
          content: "Close accounting periods to lock in production and sales data.",
          steps: [
            "Select the month you want to close",
            "Review the reconciliation status (all production days should be reconciled)",
            "Click 'Close Production' to lock production data for the month",
            "Click 'Close Sales' to finalize sales reconciliation",
            "Enter actual fixed costs if different from planned"
          ],
          warnings: [
            "Ensure all production days are reconciled before closing sales",
            "Closed months cannot be modified",
            "Close months in chronological order"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion des Charges Fixes",
      description: "Apprenez à gérer les charges fixes, calculer le coût par gramme de pâte et clôturer les périodes comptables mensuelles.",
      sections: [
        {
          title: "Que sont les Charges Fixes ?",
          content: "Les charges fixes sont des dépenses récurrentes qui ne changent pas avec le volume de production, comme le loyer, les services publics et les assurances.",
          tips: [
            "Les charges fixes sont réparties sur votre production pour calculer les coûts réels des produits",
            "Le 'Coût Fixe par Gramme' vous aide à tarifer les produits avec précision",
            "Un suivi régulier aide à identifier les opportunités d'économies"
          ]
        },
        {
          title: "Gestion des Postes de Charges Fixes",
          content: "Ajoutez et gérez vos dépenses mensuelles récurrentes.",
          steps: [
            "Cliquez sur 'Ajouter une Charge Fixe' pour créer un nouveau poste de dépense",
            "Entrez un nom et un montant mensuel",
            "Sélectionnez une catégorie (Loyer, Services, Assurance, Main d'œuvre, Abonnements, Autre)",
            "Activez/désactivez 'Actif' pour inclure/exclure des calculs"
          ],
          tips: [
            "Les catégories aident à organiser et analyser vos coûts",
            "Les éléments inactifs sont conservés mais exclus des totaux",
            "Mettez à jour les montants lorsque les coûts changent (ex: augmentation de loyer)"
          ]
        },
        {
          title: "Méthode de Planification & Coût par Gramme",
          content: "Configurez comment les charges fixes sont réparties sur votre production.",
          steps: [
            "Choisissez 'Mois Calendaire' pour utiliser les données de production d'un mois spécifique",
            "Ou choisissez 'Modèle de Production' pour utiliser la production prévue d'un modèle",
            "Définissez 'Jours de Production par Semaine' pour les calculs basés sur modèle",
            "Le système calcule : Charges Fixes Mensuelles ÷ Pâte Mensuelle (grammes) = Coût par Gramme"
          ],
          tips: [
            "La méthode calendrier utilise l'historique de production réel",
            "La méthode modèle est utile pour la planification et les projections",
            "Exemple : 1500€ de charges mensuelles ÷ 150kg de pâte = 0,01€ par gramme",
            "Un pain de 700g à 0,01€/g ajoute 7,00€ en charges fixes"
          ]
        },
        {
          title: "Clôture Mensuelle",
          content: "Clôturez les périodes comptables pour verrouiller les données de production et de ventes.",
          steps: [
            "Sélectionnez le mois que vous souhaitez clôturer",
            "Vérifiez le statut de rapprochement (tous les jours de production doivent être rapprochés)",
            "Cliquez sur 'Clôturer Production' pour verrouiller les données de production du mois",
            "Cliquez sur 'Clôturer Ventes' pour finaliser le rapprochement des ventes",
            "Entrez les charges fixes réelles si différentes des prévisions"
          ],
          warnings: [
            "Assurez-vous que tous les jours de production sont rapprochés avant de clôturer les ventes",
            "Les mois clôturés ne peuvent pas être modifiés",
            "Clôturez les mois dans l'ordre chronologique"
          ]
        }
      ]
    }
  },

  help_bakerySettings: {
    en: {
      title: "Bakery Settings Help",
      description: "Settings are organized into two tabs: Business & App for internal configuration, and Online Presence for public-facing features.",
      sections: [
        {
          title: "Tab 1: Business & App",
          content: "Configure your business information, localization, and app appearance.",
          steps: [
            "Business Information: Enter name, subtitle, address, phone, and email",
            "Localization: Set country, currency, date format, and stock management",
            "Theme: Choose color scheme that matches your branding"
          ],
          tips: [
            "Keep business information current for customer communication",
            "Choose currency and date formats familiar to your customers",
            "Select a theme that complements your bakery's identity"
          ]
        },
        {
          title: "Tab 2: Online Presence",
          content: "Manage your shop URL, home page, and SEO settings for maximum visibility.",
          steps: [
            "Shop URL: Configure your custom subdomain (e.g., digi-bakery.com/yourbakery)",
            "Home Page: Customize your bakery story, bio, and images",
            "SEO Settings: Optimize for search engines and social media"
          ],
          tips: [
            "Use a memorable, brand-aligned subdomain",
            "Update home page content regularly to keep it fresh",
            "Complete all SEO fields for better search visibility"
          ]
        },
        {
          title: "Shop URL Configuration",
          content: "Set up your bakery's custom web address.",
          steps: [
            "Enter a subdomain name (letters and numbers only)",
            "Click 'Generate' to auto-create from your business name",
            "Use 'Copy URL' to share your shop link",
            "Click external link icon to preview your shop"
          ],
          tips: [
            "Choose a short, memorable subdomain",
            "Avoid numbers unless they're part of your brand",
            "Once customers know your URL, changing it can confuse them"
          ]
        },
        {
          title: "SEO Settings - Boost Your Visibility",
          content: "Optimize your bakery for search engines and social media to increase traffic by up to 100%.",
          steps: [
            "Basic SEO: Add description (150-160 chars) and 5-10 keywords",
            "Social Media: Upload an Open Graph image (1200x630px) for beautiful share previews",
            "Location: Add coordinates and business hours for local search",
            "Review status summary to see what's completed"
          ],
          tips: [
            "Include your city and specialties in the description",
            "Use high-quality product photos for the OG image",
            "Complete all fields for maximum SEO benefit",
            "Good SEO can increase local search visibility by 100%+"
          ]
        },
        {
          title: "Home Page Customization",
          content: "Personalize your bakery's online presence.",
          steps: [
            "Click 'Edit Home Page' in Online Presence tab",
            "Add your bakery story and commitment",
            "Upload images to showcase your work",
            "Use rich text formatting for better presentation"
          ],
          tips: [
            "Tell your authentic bakery story",
            "High-quality images improve customer engagement",
            "Keep content updated with seasonal offerings",
            "Mention your specialties and local ingredients"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Paramètres de la Boulangerie",
      description: "Les paramètres sont organisés en deux onglets : Entreprise & Application pour la configuration interne, et Présence en Ligne pour les fonctionnalités publiques.",
      sections: [
        {
          title: "Onglet 1 : Entreprise & Application",
          content: "Configurez vos informations d'entreprise, la localisation et l'apparence de l'application.",
          steps: [
            "Informations d'Entreprise : Nom, sous-titre, adresse, téléphone et email",
            "Localisation : Pays, devise, format de date et gestion du stock",
            "Thème : Choisissez les couleurs qui correspondent à votre marque"
          ],
          tips: [
            "Gardez les informations d'entreprise à jour pour la communication client",
            "Choisissez la devise et formats de date familiers à vos clients",
            "Sélectionnez un thème qui complète l'identité de votre boulangerie"
          ]
        },
        {
          title: "Onglet 2 : Présence en Ligne",
          content: "Gérez votre URL boutique, page d'accueil et paramètres SEO pour une visibilité maximale.",
          steps: [
            "URL Boutique : Configurez votre sous-domaine personnalisé (ex: digi-bakery.com/votreboulangerie)",
            "Page d'Accueil : Personnalisez votre histoire, bio et images",
            "Paramètres SEO : Optimisez pour les moteurs de recherche et réseaux sociaux"
          ],
          tips: [
            "Utilisez un sous-domaine mémorable aligné avec votre marque",
            "Mettez à jour le contenu régulièrement pour le garder frais",
            "Complétez tous les champs SEO pour une meilleure visibilité"
          ]
        },
        {
          title: "Configuration de l'URL Boutique",
          content: "Configurez l'adresse web personnalisée de votre boulangerie.",
          steps: [
            "Entrez un nom de sous-domaine (lettres et chiffres uniquement)",
            "Cliquez sur 'Générer' pour créer automatiquement depuis votre nom d'entreprise",
            "Utilisez 'Copier l'URL' pour partager le lien de votre boutique",
            "Cliquez sur l'icône de lien externe pour prévisualiser votre boutique"
          ],
          tips: [
            "Choisissez un sous-domaine court et mémorable",
            "Évitez les chiffres sauf s'ils font partie de votre marque",
            "Une fois que les clients connaissent votre URL, la changer peut les confondre"
          ]
        },
        {
          title: "Paramètres SEO - Boostez Votre Visibilité",
          content: "Optimisez votre boulangerie pour les moteurs de recherche et réseaux sociaux pour augmenter le traffic jusqu'à 100%.",
          steps: [
            "SEO Basique : Ajoutez description (150-160 caractères) et 5-10 mots-clés",
            "Réseaux Sociaux : Téléchargez une image Open Graph (1200x630px) pour de beaux aperçus",
            "Localisation : Ajoutez coordonnées et horaires pour la recherche locale",
            "Consultez le résumé de statut pour voir ce qui est complété"
          ],
          tips: [
            "Incluez votre ville et spécialités dans la description",
            "Utilisez des photos de produits de haute qualité pour l'image OG",
            "Complétez tous les champs pour un bénéfice SEO maximum",
            "Un bon SEO peut augmenter la visibilité de recherche locale de 100%+"
          ]
        },
        {
          title: "Personnalisation de la Page d'Accueil",
          content: "Personnalisez la présence en ligne de votre boulangerie.",
          steps: [
            "Cliquez sur 'Modifier Page d'Accueil' dans l'onglet Présence en Ligne",
            "Ajoutez votre histoire et engagement",
            "Téléchargez des images pour présenter votre travail",
            "Utilisez le formatage enrichi pour une meilleure présentation"
          ],
          tips: [
            "Racontez l'histoire authentique de votre boulangerie",
            "Les images de haute qualité améliorent l'engagement client",
            "Gardez le contenu à jour avec vos offres saisonnières",
            "Mentionnez vos spécialités et ingrédients locaux"
          ]
        }
      ]
    }
  },

  help_stockManagement: {
    en: {
      title: "Stock Management Help",
      description: "Learn how to manage your ingredient inventory and purchasing.",
      sections: [
        {
          title: "Invoice Scan",
          content: "Use the invoice scan feature to automatically extract purchase data from a supplier invoice photo or PDF — saving time on manual entry.",
          steps: [
            "Click the 'Scan Invoice' button at the top of the page",
            "Upload a photo or PDF of your supplier invoice",
            "The system extracts ingredients, quantities, units and prices automatically",
            "Review every line carefully before confirming — always verify the quantity, unit and price match your invoice exactly",
            "Correct any line directly in the review table if the scan made a mistake",
            "Click 'Confirm' to add all lines to your stock"
          ],
          warnings: [
            "Always verify quantities, units and prices before confirming — AI extraction is not perfect and errors can affect your stock and cost calculations",
            "Units in particular can be misread (e.g. kg vs g, L vs mL) — double-check each one",
            "If a line looks wrong, correct it in the review table before confirming"
          ],
          tips: [
            "A clear, well-lit photo of the invoice gives better scan results",
            "You can delete individual lines in the review table if they should not be added to stock",
            "The scan saves time but the final responsibility for accuracy is yours — treat it as a first draft"
          ]
        },
        {
          title: "Important Rules",
          content: "Key constraints and limitations when managing stock.",
          warnings: [
            "You can only edit or delete stock lines that have not started to be consumed",
            "Stock consumption is permanent when production is completed",
            "Water is track as an ingredient and need to be purchased and stocked like other ingredients",
          ]
        },
        {
          title: "Adding Purchases",
          content: "Record ingredient purchases to track inventory.",
          steps: [
            "Click 'Add Purchase'",
            "Select supplier and purchase date",
            "Add ingredients with quantities and costs",
            "Include lot/batch numbers for traceability",
            "Set expiry dates for perishable items"
          ],
          tips: [
            "Use detailed supplier information for quality tracking",
            "Record costs accurately for profitability analysis",
            "Batch numbers help with recall management",
            "If you use tap water, enter a large quantity (e.g., 10000 liters) periodically to cover water usage",
          ]
        },
         {
           title: "Modify Purchases",
           content: "Edit, Delte purchases, Waste managment",
           steps: [
             "To modify a line, Click on  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#2563eb\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><path d=\"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7\"/><path d=\"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z\"/></svg>",
             "To delete a line, Click on  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#dc2626\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\"/><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\"/></svg>",
             "* Only lines that have not started to be consumed can be modified or deleted",
             "To declare full or partial waste for a line, Click on  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#ea580c\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><path d=\"M3 6h18\"/><path d=\"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6\"/><path d=\"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2\"/></svg>",
           ],
          tips: [
            "Use detailed supplier information for quality tracking",
            "Record costs accurately for profitability analysis",
            "Batch numbers help with recall management",
            "If you use tap water, enter a large quantity (e.g., 10000 liters) periodically to cover water usage",
          ]
        },
        {
          title: "Batch Traceability Photos",
          content: "Attach a photo of the batch label or packaging for full traceability.",
          steps: [
            "Each stock line shows a camera icon <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><path d=\"M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z\"/><circle cx=\"12\" cy=\"13\" r=\"4\"/></svg> on the right",
            "Muted grey camera = no photo attached yet",
            "Coloured camera (accent) = a batch photo is already attached",
            "Click the camera to attach or replace the batch photo",
            "To view an attached photo, open the ••• menu on that line and choose 'View batch image'"
          ],
          tips: [
            "A coloured camera lets you instantly spot which lines have photos without opening anything",
            "Batch photos are useful for food safety audits and supplier traceability",
            "Photos are compressed automatically before upload to save storage space"
          ]
        },
        {
          title: "Cost Analysis",
          content: "Track ingredient costs and profitability.",
          steps: [
            "Review average costs per ingredient",
            "Monitor cost trends over time",
            "Calculate profit margins on products",
            "Identify cost-saving opportunities"
          ]
        },
        {
          title: "Allergen Management",
          content: "Mark ingredients as potential allergens to inform customers.",
          steps: [
            "Click 'Manage Allergens' button at the top of the page",
            "A modal shows all ingredients currently in your stock",
            "Check the box next to ingredients that are potential allergens",
            "Optionally enter a custom allergen name (e.g., 'Tree Nut' for almonds)",
            "Click 'Save' to apply changes"
          ],
          tips: [
            "Allergens are marked with a ⚠️ warning icon in the stock list",
            "Allergen information is used in Product Management to display on shop pages",
            "Common allergens: wheat/gluten, nuts, eggs, dairy, sesame, soy",
            "Custom allergen names help customers understand the specific allergen type"
          ]
        },
        {
          title: "Ingredient Management",
          content: "Manage your full ingredient list directly from Stock Management.",
          steps: [
            "Click 'Manage Ingredients' button next to 'Manage Allergens' at the top of the page",
            "Browse and search your complete ingredient list",
            "Click the pen icon to rename an ingredient (English and French names) or change its allergen flag",
            "Click the trash icon to delete an unused ingredient",
            "Check boxes next to multiple ingredients and click 'Delete selected' for bulk deletion",
            "Click '+ Add Custom Ingredient' to add a new ingredient to your list"
          ],
          tips: [
            "Ingredients used in a recipe cannot be deleted — the Recipes column shows which ones",
            "Ingredients with stock purchase records cannot be deleted — check the In Stock column",
            "System ingredients (Flour, Butter, Eggs, etc.) can be deleted if they are not used in any recipe and have no stock records",
            "Renaming an ingredient updates it everywhere: recipes, stock, and the shop"
          ]
        }
      ]
    },
    fr: {
      title: "Aide Gestion du Stock",
      description: "Apprenez à gérer votre inventaire d'ingrédients et achats.",
      sections: [
        {
          title: "Scan de Facture",
          content: "Utilisez la fonction de scan de facture pour extraire automatiquement les données d'achat depuis une photo ou un PDF de facture fournisseur — et gagner du temps sur la saisie manuelle.",
          steps: [
            "Cliquez sur le bouton 'Scanner une Facture' en haut de la page",
            "Téléversez une photo ou un PDF de votre facture fournisseur",
            "Le système extrait automatiquement les ingrédients, quantités, unités et prix",
            "Vérifiez chaque ligne attentivement avant de confirmer — contrôlez toujours que la quantité, l'unité et le prix correspondent exactement à votre facture",
            "Corrigez directement dans le tableau de révision si le scan a fait une erreur",
            "Cliquez sur 'Confirmer' pour ajouter toutes les lignes à votre stock"
          ],
          warnings: [
            "Vérifiez toujours les quantités, unités et prix avant de confirmer — l'extraction par IA n'est pas parfaite et les erreurs peuvent affecter votre stock et vos calculs de coûts",
            "Les unités en particulier peuvent être mal lues (ex : kg vs g, L vs mL) — vérifiez chacune",
            "Si une ligne semble incorrecte, corrigez-la dans le tableau de révision avant de confirmer"
          ],
          tips: [
            "Une photo claire et bien éclairée de la facture donne de meilleurs résultats",
            "Vous pouvez supprimer des lignes individuelles dans le tableau de révision si elles ne doivent pas être ajoutées au stock",
            "Le scan fait gagner du temps mais la responsabilité finale de l'exactitude vous appartient — traitez-le comme un premier brouillon"
          ]
        },
        {
          title: "Règles Importantes",
          content: "Contraintes et limitations clés lors de la gestion du stock.",
          warnings: [
            "Vous ne pouvez modifier ou supprimer que les lignes de stock qui n'ont pas commencé être consommées",
            "La consommation de stock est permanente lorsque la production est terminée",
          ]
        },
        {
          title: "Ajout d'Achats",
          content: "Enregistrez les achats d'ingrédients pour suivre l'inventaire.",
          steps: [
            "Cliquez sur 'Ajouter des Achats'",
            "Sélectionnez le fournisseur et la date d'achat",
            "Ajoutez les ingrédients avec quantités et coûts",
            "Incluez les numéros de lot pour la traçabilité",
            "Définissez les dates d'expiration pour les articles périssables"
          ],
          tips: [
            "Utilisez des informations détaillées sur les fournisseurs pour le suivi qualité",
            "Enregistrez les coûts avec précision pour l'analyse de rentabilité",
            "Les numéros de lot aident à la gestion des rappels"
          ]
        },
         {
          title: "Modifier les Achats",
          content: "Modifier, supprimer les achats, gestion des déchets",
          steps: [
            "Pour modifier une ligne, Cliquez sur <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#2563eb\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><path d=\"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7\"/><path d=\"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z\"/></svg>",
            "Pour supprimer une ligne, Cliquez sur <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#dc2626\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\"/><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\"/></svg>",
            "* Seules les lignes qui n'ont pas commencé à être consommées peuvent être modifiées ou supprimées",
            "Pour déclarer une perte totale ou partielle pour une ligne, Cliquez sur <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#ea580c\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><path d=\"M3 6h18\"/><path d=\"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6\"/><path d=\"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2\"/></svg>",
          ],
          tips: [
            "Utilisez des informations détaillées sur les fournisseurs pour le suivi qualité",
            "Enregistrez les coûts avec précision pour l'analyse de rentabilité",
            "Les numéros de lot aident à la gestion des rappels",
            "Si vous utilisez de l'eau du robinet, entrez une grande quantité (par exemple 10000 litres) périodiquement pour couvrir l'utilisation d'eau",
          ]
        },
        {
          title: "Photos de Traçabilité du Lot",
          content: "Attachez une photo de l'étiquette ou de l'emballage du lot pour une traçabilité complète.",
          steps: [
            "Chaque ligne de stock affiche une icône appareil photo <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display: inline; vertical-align: middle; margin: 0 4px;\"><path d=\"M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z\"/><circle cx=\"12\" cy=\"13\" r=\"4\"/></svg> à droite",
            "Appareil photo gris estompé = aucune photo attachée",
            "Appareil photo coloré (couleur accent) = une photo de lot est déjà attachée",
            "Cliquez sur l'appareil photo pour attacher ou remplacer la photo du lot",
            "Pour voir une photo attachée, ouvrez le menu ••• de la ligne et choisissez 'Voir la photo du lot'"
          ],
          tips: [
            "L'appareil photo coloré vous permet de repérer instantanément les lignes avec photo sans rien ouvrir",
            "Les photos de lot sont utiles pour les audits de sécurité alimentaire et la traçabilité fournisseur",
            "Les photos sont automatiquement compressées avant l'envoi pour économiser l'espace de stockage"
          ]
        },
        {
          title: "Analyse des Coûts",
          content: "Suivez les coûts d'ingrédients et la rentabilité.",
          steps: [
            "Vérifiez les coûts moyens par ingrédient",
            "Surveillez les tendances de coût dans le temps",
            "Calculez les marges de profit sur les produits",
            "Identifiez les opportunités d'économie de coût"
          ]
        },
        {
          title: "Gestion des Allergènes",
          content: "Marquez les ingrédients comme allergènes potentiels pour informer les clients.",
          steps: [
            "Cliquez sur le bouton 'Gérer les Allergènes' en haut de la page",
            "Une fenêtre affiche tous les ingrédients actuellement dans votre stock",
            "Cochez la case à côté des ingrédients qui sont des allergènes potentiels",
            "Entrez optionnellement un nom d'allergène personnalisé (ex: 'Fruits à coque' pour les amandes)",
            "Cliquez sur 'Enregistrer' pour appliquer les modifications"
          ],
          tips: [
            "Les allergènes sont marqués avec une icône d'avertissement ⚠️ dans la liste du stock",
            "Les informations sur les allergènes sont utilisées dans la Gestion des Produits pour l'affichage en boutique",
            "Allergènes courants : blé/gluten, noix, œufs, produits laitiers, sésame, soja",
            "Les noms d'allergènes personnalisés aident les clients à comprendre le type d'allergène spécifique"
          ]
        },
        {
          title: "Gestion des Ingrédients",
          content: "Gérez votre liste complète d'ingrédients directement depuis la Gestion du Stock.",
          steps: [
            "Cliquez sur le bouton 'Gérer les Ingrédients' à côté de 'Gérer les Allergènes' en haut de la page",
            "Parcourez et recherchez votre liste complète d'ingrédients",
            "Cliquez sur l'icône crayon pour renommer un ingrédient (noms anglais et français) ou modifier son statut d'allergène",
            "Cliquez sur l'icône corbeille pour supprimer un ingrédient non utilisé",
            "Cochez plusieurs ingrédients et cliquez sur 'Supprimer la sélection' pour une suppression groupée",
            "Cliquez sur '+ Ajouter Ingrédient Personnalisé' pour ajouter un nouvel ingrédient à votre liste"
          ],
          tips: [
            "Les ingrédients utilisés dans une recette ne peuvent pas être supprimés — la colonne Recettes indique lesquels",
            "Les ingrédients avec des achats en stock ne peuvent pas être supprimés — vérifiez la colonne En Stock",
            "Les ingrédients système (Farine, Beurre, Œufs, etc.) peuvent être supprimés s'ils ne sont pas utilisés dans une recette et sans achat en stock",
            "Renommer un ingrédient le met à jour partout : recettes, stock et boutique"
          ]
        }
      ]
    }
  },

  fr: {
    // Header
    siteTitle: "Digi-Bakery",
    siteSubtitle: "Pain frais cuit avec amour",
    account: "Compte",
    login: "Connexion",
    signup: "S'inscrire",
    logout: "Déconnexion",
    
    // Navigation
    home: "Accueil",
    shop: "Boutique",
    myShop: "Ma Boutique",
    myBakery: "Mon Fournil",
    myProduction: "Ma Production",
    products: "Produits",
    recipes: "Recettes",
    equipment: "Équipement",
    productionDays: "Planning Boutique",
    templates: "Modèles",
    productionPlanning: "Planification Production",
    productionOrder: "Ordre de Production",
    productionOrderAndScaling: "Ordre de Production & Ajustement des quantités",
    shoppingList: "Liste de courses",
    orders: "Commandes",
    myOrders: "Mes Commandes",
    reports: "Rapports",
    salesReports: "Rapport des Ventes",
    wasteReport: "Rapport Déchets",
    shopAnalytics: "Visiteurs boutique",
    shopAnalyticsTitle: "Analytiques Visiteurs de la Boutique",
    totalVisits: "Visites totales",
    uniqueSessions: "Sessions uniques",
    mobileShare: "Part mobile",
    topProduct: "Plus ajouté au panier",
    visitTrend: "Tendance des visites",
    referrerBreakdown: "Sources de traffic",
    deviceBreakdown: "Types d'appareils",
    peakHours: "Heures de pointe (heure locale)",
    languageDistribution: "Langues des visiteurs",
    topProductViews: "Produits les plus ajoutés",
    referrerDirect: "Direct",
    referrerSearch: "Recherche",
    referrerSocial: "Réseaux sociaux",
    referrerOther: "Autre",
    deviceMobile: "Mobile",
    deviceDesktop: "Ordinateur",
    deviceTablet: "Tablette",
    analyticsDisclosure: "Les données visiteurs sont des statistiques agrégées anonymisées. Aucune donnée personnelle n'est stockée.",
    noDemographicsNote: "L'âge et le sexe ne peuvent pas être déduits des signaux du navigateur. Les données démographiques des clients inscrits pourraient apparaître ici dans une future version.",
    settings: "Paramètres",
    adminTools: "Outils Admin",
    profile: "Profil",
    wasteRecords: "Enregistrements déchets",

    // Admin Dashboard
    adminDashboard: "Tableau de Bord Admin",
    systemOverview: "Aperçu du Système",
    totalBakeries: "Total Boulangeries",
    activeBakeries: "Boulangeries Actives",
    archivedBakeries: "Boulangeries Archivées",
    totalUsers: "Total Utilisateurs",
    totalOrders: "Total Commandes",
    recentActivity: "Activité Récente",
    viewAllBakeries: "Voir Toutes les Boulangeries",
    viewAllUsers: "Voir Tous les Utilisateurs",
    bakeryManagement: "Gestion des Boulangeries",
    userManagement: "Gestion des Utilisateurs",
    analytics: "Analytique",
    auditLog: "Journal d'Audit",

    // Admin Bakeries View
    allBakeries: "Toutes les Boulangeries",
    searchBakeries: "Rechercher des boulangeries...",
    filterByStatus: "Filtrer par Statut",
    allStatuses: "Tous les Statuts",
    active: "Active",
    archived: "Archivée",
    bakeryOwner: "Propriétaire",
    subdomain: "Sous-domaine",
    createdDate: "Créé",
    lastConnection: "Dernière connexion",
    never: "Jamais",
    daysAgo: "il y a {count} j",
    sortNewest: "Plus récentes",
    sortOldest: "Plus anciennes",
    sortNameAZ: "Nom (A→Z)",
    sortLastConnection: "Dernière connexion",
    lastActivity: "Dernière Activité",
    status: "Statut",
    actions: "Actions",
    viewDetails: "Voir les Détails",
    hideDetails: "Masquer les Détails",
    archiveBakery: "Archiver la Boulangerie",
    restoreBakery: "Restaurer la Boulangerie",
    noBakeriesFound: "Aucune boulangerie trouvée",

    // Admin Bakery Detail
    bakeryDetails: "Détails de la Boulangerie",
    bakeryInformation: "Informations de la Boulangerie",
    bakeryId: "ID Boulangerie",
    ownerId: "ID Propriétaire",
    ownerEmail: "Email Propriétaire",
    ownerName: "Nom Propriétaire",
    country: "Pays",
    createdAt: "Créé le",
    archivedAt: "Archivé le",
    bakeryProducts: "Produits de la Boulangerie",
    bakeryOrders: "Commandes de la Boulangerie",
    bakeryStats: "Statistiques",
    totalProducts: "Total Produits",
    totalRevenue: "Revenu Total",
    orderCount: "Nombre de Commandes",
    archiveConfirmTitle: "Archiver la Boulangerie ?",
    archiveConfirmMessage: "Êtes-vous sûr de vouloir archiver cette boulangerie ? Le boulanger ne pourra plus accéder à son compte, mais toutes les données seront préservées.",
    restoreConfirmTitle: "Restaurer la Boulangerie ?",
    restoreConfirmMessage: "Êtes-vous sûr de vouloir restaurer cette boulangerie ? Le boulanger pourra à nouveau accéder à son compte.",
    archiveSuccess: "Boulangerie archivée avec succès",
    restoreSuccess: "Boulangerie restaurée avec succès",
    archiveError: "Échec de l'archivage de la boulangerie",
    restoreError: "Échec de la restauration de la boulangerie",
    hasActiveOrders: "Impossible d'archiver une boulangerie avec des commandes actives",
    // Grandfathering admin
    grandfatheringStatus: "Statut Accès à Vie",
    lifetimeAccess: "Accès à Vie",
    grandfatheredBadge: "Accès à Vie",
    notGrandfathered: "Non Grandfathered",
    grantGrandfathering: "Accorder l'Accès à Vie",
    revokeGrandfathering: "Révoquer l'Accès à Vie",
    grantGrandfatheringConfirmTitle: "Accorder l'Accès à Vie ?",
    grantGrandfatheringConfirmMessage: "Cela donnera à la boulangerie un accès gratuit permanent à Digi-Bakery. Elle n'aura jamais besoin de payer un abonnement.",
    revokeGrandfatheringConfirmTitle: "Révoquer l'Accès à Vie ?",
    revokeGrandfatheringConfirmMessage: "Cela supprimera l'accès gratuit à vie de la boulangerie. Elle devra s'abonner pour continuer à utiliser Digi-Bakery.",
    grantGrandfatheringSuccess: "Accès à vie accordé avec succès",
    revokeGrandfatheringSuccess: "Accès à vie révoqué avec succès",
    grantGrandfatheringError: "Échec de l'octroi de l'accès à vie",
    revokeGrandfatheringError: "Échec de la révocation de l'accès à vie",
    grandfatheringDescription: "Les boulangeries grandfathered ont un accès gratuit permanent à Digi-Bakery et n'ont jamais besoin de s'abonner.",
    backToBakeries: "Retour aux Boulangeries",

    // Admin Audit Log
    actionType: "Action",
    actionTarget: "Cible",
    actionTimestamp: "Horodatage",
    performedBy: "Effectué par",
    viewBakery: "Boulangerie Consultée",
    archiveBakeryAction: "Boulangerie Archivée",
    restoreBakeryAction: "Boulangerie Restaurée",

    // Admin Orders View
    orderManagement: "Gestion des Commandes",
    orderManagementDescription: "Voir et gérer toutes les commandes de toutes les boulangeries",
    searchOrders: "Rechercher des commandes...",
    adminOrderId: "ID Commande",
    bakery: "Boulangerie",
    adminCustomer: "Client",
    adminPickupDate: "Date de Retrait",
    adminTotal: "Total",
    filters: "Filtres",
    adminStartDate: "Date de Début",
    adminEndDate: "Date de Fin",
    adminExportCSV: "Exporter en CSV",
    showingResults: "Affichage",
    clearFilters: "Effacer les Filtres",
    noOrdersFound: "Aucune commande trouvée",
    tryAdjustingFilters: "Essayez d'ajuster vos filtres ou critères de recherche",

    // Home Page
    welcomeTitle: "Bienvenue chez",
    welcomeSubtitle: "Pain frais fait main avec passion et tradition.",
    ourStory: "Notre histoire",
    storyContent: "Après des années à perfectionner mon métier, j'ai décidé d'ouvrir cette micro-boulangerie pour partager la joie du vrai levain à fermentation lente. Chaque pain est cuit frais, en utilisant uniquement du levain naturel et des céréales locales.",
    commitmentText: "Mon engagement est simple : la qualité plutôt que la quantité. Cela garantit que chaque baguette, croissant et pain spécial répond aux normes les plus élevées de saveur et de texture.",
    seeAvailability: "Voir la Disponibilité Aujourd'hui",
    goToShop: "Aller à la Boutique",
    loginToGetStarted: "Connexion pour Commencer",

    // Home Page Editor
    homePageEditor: "Éditeur de Page d'Accueil",
    editHomePageContent: "Modifier le Contenu de la Page d'Accueil",
    uploadImage: "Télécharger une Image",
    enterYourStory: "Entrez votre histoire de boulangerie et biographie ici...",
    homePageEditorNote: "Ce contenu remplacera la section d'histoire par défaut sur votre page d'accueil. Vous pouvez inclure du texte, des images et une mise en forme basique.",
    homePageCustomization: "Personnalisation de la Page d'Accueil",
    customizeHomePageDescription: "Personnalisez la section histoire et biographie de votre boulangerie sur la page d'accueil avec du texte riche et des images.",
    editHomePage: "Modifier la Page d'Accueil",
    imageUploaded: "Image téléchargée avec succès ! L'URL de l'image a été ajoutée à votre contenu.",
    businessSubtitle:"Slogan de votre Boulangerie",
    bakerySubtitlePlaceholder: "par ex., Frais Cuit Tous les Jours",

    // Auth Screen
    welcomeBack: "Bon retour !",
    createAccount: "Créer votre compte",
    cartSaved: "Votre panier est sauvegardé !",
    cartSavedMsg: "Connectez-vous ou créez un compte pour finaliser votre commande.",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    iAmA: "Je suis un :",
    customer: "Client",
    baker: "Boulanger",
    countryRegion: "Pays / Région",
    minCharacters: "Minimum 6 caractères",
    loginButton: "Connexion",
    signUpButton: "S'inscrire",
    dontHaveAccount: "Pas de compte ? S'inscrire",
    alreadyHaveAccount: "Déjà un compte ? ",
    currency: "Devise",
    pleaseWait: "Veuillez patienter...",
    chooseAccountType: "Choisir le Type de Compte",
    customerAccount: "Compte Client",
    customerAccountDesc: "Commander auprès des boulangeries locales",
    bakeryAccount: "Compte Boulangerie",
    bakeryAccountDesc: "Créer et gérer votre boulangerie",
    createBakeryAccount: "Créer un Compte Boulangerie",
    yourName: "Votre Nom",
    bakeryName: "Nom de la Boulangerie",
    bakeryNamePlaceholder: "Nom de votre Boulangerie",
    bakeryNameHelp: "Ceci sera le nom public de votre boulangerie",
    justWantToOrder: "Vous voulez juste commander ?",
    registerAsCustomer: "S'inscrire en tant que Client",
    registerAsBaker: "S'inscrire en tant que Boulanger",
    wantToCreateBakery: "Vous voulez créer une boulangerie ?",
    createBakery: "Créer une Boulangerie",
    resetPassword: "Réinitialiser le Mot de Passe",
    sendResetEmail: "Envoyer l'Email de Réinitialisation",
    backToLogin: "Retour à la Connexion",
    fullName: "Nom Complet",
    privacyPolicyRequired: "Politique de Confidentialité Requise",
    acceptPrivacyPolicy: "J'accepte la",
    privacyPolicy: "Politique de Confidentialité",
    privacyPolicyAgreement: "En créant un compte, vous acceptez notre Politique de Confidentialité qui explique comment nous collectons, utilisons et protégeons vos renseignements personnels.",
    tosRequired: "Acceptation des Conditions d'utilisation requise",
    termsOfService: "Conditions Générales d'Utilisation",
    tosAgreement: "J'accepte les",
    loginSuccess: "Connexion réussie !",

    // Shop View
    welcomeToOurBakery: "Bienvenue dans notre boulangerie !",
    ourFreshBreads: "Nos Pains Frais",
    cart: "Panier",
    selectPickupDate: "Sélectionnez la Date de Collecte pour Voir la Disponibilité :",
    selectPickupDateDesc: "Choisissez quand vous souhaitez récupérer votre commande",
    choosePickupDate: "Choisir une date de collecte...",
    selectDatePrompt: "Veuillez sélectionner une date de collecte pour voir ce qui est disponible et commencer à commander",
    selectDateToSee: "Sélectionnez une date de collecte ci-dessus pour voir les produits disponibles",
    differentProducts: "Différents produits peuvent être disponibles à différentes dates",
    noProductsForDate: "Aucun produit disponible pour cette date",
    tryDifferentDate: "Veuillez essayer de sélectionner une autre date de collecte",
    soldOut: "ÉPUISÉ",
    onlyLeft: "Seulement",
    available: "disponible",
    addToCart: "Ajouter au Panier",
    allCategories: "Tous les Produits",
    showMore: "Voir Plus",
    showLess: "Voir Moins",
    newProduct: "Nouveau",
    // Ingredients & Allergens
    ingredients: "Ingrédients",
    viewIngredients: "Voir les ingrédients",
    potentialAllergen: "Allergène potentiel",
    manageAllergens: "Gérer les allergènes",
    showIngredientsInShop: "Afficher les ingrédients en boutique",
    ingredientsPreview: "Aperçu des ingrédients",
    ingredientsDisplayList: "Ingrédients affichés en boutique",
    ingredientsDisplayListHelp: "Optionnel : modifiez la liste affichée aux clients (séparée par des virgules). Ajoutez * après un ingrédient pour le marquer comme allergène.",
    allergenNameOptional: "Nom de l’allergène (optionnel)",
    allergenLegend: "Gras = allergène potentiel",
    allergenDisclaimer: "Les informations sur les allergènes sont fournies à titre indicatif et ne couvrent pas les risques de contamination croisée.",
    editIngredient: "Modifier l'ingrédient",
    ingredientNameEn: "Nom (anglais)",
    ingredientNameFr: "Nom (français)",
    manageIngredients: "Gérer les ingrédients",
    ingredientManager: "Gestionnaire d'ingrédients",
    systemIngredient: "Système",
    customIngredientBadge: "Personnalisé",
    usedInRecipes: "Utilisé dans des recettes",
    ingredientNotUsed: "Non utilisé",
    hasStockRecords: "Achats enregistrés",
    confirmDeleteIngredients: "Supprimer {n} ingrédient(s) ? Cette action est irréversible.",
    ingredientDeletedSuccess: "Ingrédient supprimé",
    ingredientsDeletedSuccess: "{n} ingrédients supprimés",
    cannotDeleteInRecipe: "Impossible : utilisé dans une recette",
    cannotDeleteHasStock: "Impossible : des achats sont enregistrés",
    searchIngredients: "Rechercher des ingrédients…",
    ingredientSaved: "Ingrédient enregistré",
    deletedIngredient: "Ingrédient supprimé",
    ingredientsDisplayMode: "Mode d'affichage des ingrédients",
    ingredientsModeAutomatic: "Automatique (Recommandé)",
    ingredientsModeAutomaticDesc: "La liste des ingrédients est générée automatiquement à partir de la recette et des variations. Se met à jour automatiquement lorsque vous modifiez les variations.",
    ingredientsModeCustom: "Personnalisé",
    ingredientsModeCustomDesc: "Vous gérez la liste des ingrédients manuellement. Vous êtes responsable de la maintenir à jour lorsque les variations changent.",
    autoGeneratedListPreview: "Liste auto-générée (Aperçu)",
    autoGeneratedUpdatesNote: "Cette liste se met à jour automatiquement lorsque vous modifiez la recette ou les variations.",
    customIngredientsList: "Liste d'ingrédients personnalisée",
    copyFromAutoGenerated: "Copier depuis auto-générée",
    customIngredientsPlaceholder: "Saisir les ingrédients (séparés par des virgules). Ajouter * pour les allergènes (ex: Lait*)",
    customIngredientsFormat: "Format: Farine, Lait*, Œufs* (utiliser * pour les allergènes)",
    currentAutoGeneratedList: "Liste actuelle auto-générée (pour référence):",

    // UX Redesign - Customer-Centric Keys (FR)
    ingredientsShownToCustomers: "Ingrédients affichés à vos clients",
    ingredientsShownDesc: "Aidez vos clients à comprendre ce qu'il y a dans vos produits et à identifier les allergènes.",
    howManageIngredients: "Comment voulez-vous gérer votre liste d'ingrédients ?",
    howManageIngredientsDesc: "Choisissez la meilleure approche pour votre boulangerie",
    recommendedBadge: "Recommandé",
    smartAutoMode: "Auto Intelligent",
    smartAutoModeDesc: "Digi-Bakery génère automatiquement les ingrédients à partir de votre recette et de vos variations. Toujours à jour. Aucun entretien nécessaire.",
    fullControlMode: "Je veux le contrôle total",
    fullControlModeDesc: "Modifiez manuellement ce que les clients verront. Idéal si vous souhaitez un libellé simplifié ou un formatage réglementaire.",
    customModeWarning: "Votre liste d'ingrédients ne se mettra PAS à jour automatiquement si la recette ou les variations changent.",
    ingredientsVisibleToCustomers: "Ingrédients visibles par les clients",
    copyAutoList: "Copier la liste auto-générée",
    ingredientsPlaceholder: "Eau, Farine de blé*, Farine de seigle, Levure fraîche, Sel",
    allergenFormatHelp: "Utilisez * pour marquer les allergènes (exemple : Farine de blé*). L'aperçu ci-dessous montre exactement ce que les clients verront.",
    customerPreview: "Ce que vos clients verront",
    customerPreviewDesc: "Voici comment les ingrédients apparaîtront sur vos pages de produits",
    allergenHighlightNote: "Les allergènes sont mis en évidence en gras",
    allergenDisclaimerShort: "Ces informations sont fournies à titre indicatif et ne couvrent pas les risques de contamination croisée.",
    noIngredientsToShow: "Aucun ingrédient à afficher",
    noIngredientsYet: "Sélectionnez une recette pour voir les ingrédients",
    switchToAutoTitle: "Passer en mode Auto Intelligent ?",
    switchToAutoMessage: "Le passage en mode Auto Intelligent remplacera votre liste d'ingrédients personnalisée par une liste générée automatiquement. Vous pourrez toujours revenir au contrôle manuel plus tard.",

    yourCart: "Votre Panier",
    cartEmpty: "Votre panier est vide",
    emptyCart: "Panier Vide",
    addItems: "Ajouter des Articles",
    pickupDate: "Date de Collecte",
    selectDate: "Sélectionner une date",
    selectedDateShop: "Date Sélectionnée",
    bassinage: "Bassinage",
    bassinageHint: "Eau réservée, ajoutée en fin de pétrissage",
    sectionSubtotal: "Sous-total",
    batchTotal: "Total fournée",
    total: "Total",
    placeOrder: "Passer Commande",
    loginToCheckout: "Connexion pour Commander",
    registerOrder: "Enregistrer Commande",
    selectProductsForCustomer: "Sélectionner les produits et les attribuer à un client",
    selectCustomer: "Sélectionner Client",
    searchCustomers: "Rechercher clients...",
    addNewCustomer: "Ajouter Nouveau Client",
    selectedCustomer: "Client Sélectionné",
    selectCustomerFirst: "Sélectionner Client D'abord",
    orderNotes: "Notes de Commande",
    specialRequests: "Demandes spéciales",
    specialInstructions: "Instructions spéciales...",
    name: "Nom",
    phone: "Téléphone",
    create: "Créer",
    adjustQuantities: "⚠️ Veuillez ajuster les quantités pour correspondre à la disponibilité",
    noPickupDateSelected: "Aucune date de collecte sélectionnée",
    
    // Shop - Recipe Based Availability
    basedOnBaseRecipe: "Basé sur la disponibilité de la recette de base",
    sharedRecipeLimit: "Partage la limite de pâte avec d'autres produits",

    // Order Confirmation
    orderConfirmed: "Commande Confirmée",
    thankYouForOrder: "Merci pour votre commande !",
    confirmationEmailSent: "Email de confirmation envoyé",
    checkEmailForDetails: "Vérifiez votre Email pour les détails de la commande et les informations de suivi.",
    orderSummary: "Résumé de la Commande",
    orderedItems: "Articles Commandés",
    continueShopping: "Continuer les Achats",
    backToHome: "Retour à l'Accueil",

    // Orders View
    orderSuccess: "✓ Commande passée avec succès !",
    orderPlacedSuccessfully: 'Commande Enregistrée',
    sendingEmail: "Envoi de l'email de confirmation...",
    checkEmail: "Vérifiez votre Email pour la confirmation et suivez-la dans",
    noOrdersYet: "Aucune commande encore",
    noOrdersForDate: "Aucune commande pour cette date",
    noOrdersYetDash: "Aucune commande encore - quand les clients passent des commandes, elles apparaîtront ici",
    ordersWillAppearHere: "Les commandes des clients apparaîtront ici. Partagez le lien de votre boutique pour commencer à recevoir des commandes !",
    startShopping: "Commencez à magasiner pour passer votre première commande !",
    orderNumber: "Commande #",
    placed: "Passée",
    pickup: "Collecte",
    items: "Articles",
    orderReceived: "Commande Reçue",
    beingPrepared: "En Préparation",
    readyForPickup: "Prête pour Collecte",
    completed: "Terminé",
    orderReady: "✓ Votre commande est prête pour la collecte !",
    loadingOrders: "Chargement des commandes...",

    // Order Cancellation
    cancelOrder: "Annuler la commande",
    cannotModifyOrder: "Impossible de modifier après l'heure limite",
    cannotModifyOrderCompleted: "Production en cours - cette commande ne peut pas être modifiée ou annulée",
    cannotModifyOrderPastDate: "Date de collecte passée - cette commande ne peut pas être modifiée ou annulée",
    cancelOrderTitle: "Annuler la commande",
    cancelOrderConfirmation: "Êtes-vous sûr de vouloir annuler cette commande? Cette action est irréversible.",
    cancelOrderRefundInfo: "Cette commande a été payée en ligne et sera remboursée sur votre méthode de paiement originale.",
    cancelOrderProcessing: "Traitement de l'annulation...",
    cancellationReason: "Raison de l'annulation",
    cancellationReasonPlaceholder: "Optionnel: Dites-nous pourquoi vous annulez...",
    confirmCancellation: "Confirmer l'annulation",
    orderCancelledSuccess: "Commande annulée avec succès",
    refundProcessed: "Remboursement Traité",
    orderCancelled: "Commande annulée",
    cancelledOn: "Annulée le",
    customerRequest: "Demande du client",
    bakerCancelledOrder: "Annulé par le boulanger",
    optional: "Optionnel",
    goBack: "Retour",
    showCancelledOrders: "Afficher les commandes annulées",
    cancelled: "Annulée",
    last2Months: "2 derniers mois",
    last6Months: "6 derniers mois",
    allOrders: "Toutes les commandes",

    // Profile View
    myProfile: "Mon Profil",
    profileUpdated: "Profil mis à jour avec succès !",
    emailCannotChange: "L'Email ne peut pas être modifié",
    phoneNumber: "Numéro de Téléphone",
    deliveryAddress: "Adresse de Livraison/Collecte",
    formatExample: "Exemple de format :",
    requiredInfo: "Le numéro de téléphone et le pays sont requis pour passer des commandes. Ces informations seront partagées avec le boulanger pour l'exécution de la commande.",
    saveProfile: "Sauvegarder le Profil",
    includeAddress: "Inclure l'adresse, la ville et le code postal",
    
    // Product Management
    productManagement: "Gestion des Produits",
    dragToReorder: "Faites glisser les produits pour les réorganiser",
    addNewProduct: "Ajouter un Nouveau Produit",
    noProductsYet: "Aucun produit pour le moment",
    startBuildingCatalog: "Commencez à construire votre catalogue en ajoutant votre premier produit",
    addYourFirstProduct: "Ajouter Votre Premier Produit",
    editProduct: "Modifier le Produit",
    productImage: "Image du Produit",
    clickToUpload: "Cliquer pour télécharger l'image (max 5 Mo)",
    recommended: "Recommandé : Images carrées, au moins 400x400px",
    productName: "Nom du Produit",
    emoji: "Emoji (par défaut)",
    description: "Description",
    price: "Prix",
    recipe: "Recette",
    noRecipe: "Aucune recette (optionnel)",
    linkRecipe: "Lier ce produit à une recette pour la planification de production",
    doughWeight: "Poids de Pâte",
    weightPerUnit: "Poids de pâte par unité (avant cuisson)",
    productionNote: "Les quantités de production sont définies dans la page 'Jours de Production', pas ici. Définissez la recette et le poids de pâte ici, puis spécifiez combien vous ferez par lot de production.",
    addProduct: "Ajouter Produit",
    updateProduct: "Mettre à Jour Produit",
    uploading: "Téléchargement...",
    finalProductWeightNote: "Poids total du produit fini, comprenant la pâte de base et les ingrédients incorporés lors des variations. Exemple : pain aux noix 650 g = pâte de base + noix",

    
    // Baker Orders View
    ordersDashboard: "Tableau de Bord Commandes",
    filterByProduction: "Filtrer par Date de Production :",
    allDates: "Toutes les Dates",
    productionSummaryOrders: "Résumé de Production pour",
    pickupDates: "Dates de collecte",
    noOrdersForProduction: "Aucune commande pour cette production",
    address: "Adresse :",
    bakerCountry: "Pays :",
    ordered: "Commandée :",
    orderItems: "Articles de Commande :",
    pending: "En Attente",
    preparing: "En Préparation",
    ready: "Prête",
    bakerStatus: "Statut",
    
    // Smart Date Filter
    smartDateFilter: "Filtre de Date Intelligent",
    advancedFilters: "Filtres Avancés",
    searchSpecificDate: "Rechercher une Date Spécifique",
    find: "Trouver",
    recentProductionDays: "Jours de Production Récents (2 dernières semaines)",
    olderProductionDays: "Jours de Production Plus Anciens",
    days: "jours",
    selectedDate: "Date Sélectionnée",
    today: "Aujourd'hui",
    tomorrow: "Demain",
    filterOrders: "Filtre de date",
    
    // Production Days Management
    productionDaysManagement: "Planning Boutique",
    quickScheduleCalendar: "Planification Rapide avec Calendrier",
    quickTip: "💡 Astuce :",
    quickTipMsg: "Utilisez le bouton calendrier ci-dessus pour sélectionner plusieurs dates et appliquer un modèle à toutes à la fois !",
    orderCutoffDateTime: "Date et Heure de Fin de Commande",
    orderCutoff: "Fin de commande",
    orderCutoffTiming: "Date et Heure de Fin de Commande",
    twoDaysBefore: "2 jours avant la production",
    dayBefore: "1 jour avant la production",
    same: "Même jour que la production",
    cutoffTime: "Heure de Fin",
    scheduleMultipleDays: "Programmer Plusieurs Jours",
    quickSelect: "Sélection Rapide",
    allMondays: "Tous les Lundis",
    allTuesdays: "Tous les Mardis",
    allWednesdays: "Tous les Mercredis",
    allThursdays: "Tous les Jeudis",
    allFridays: "Tous les Vendredis",
    allSaturdays: "Tous les Samedis",
    allSundays: "Tous les Dimanches",
    clearAll: "Tout Effacer",
    datesSelected: "dates sélectionnées",
    selectTemplate: "Sélectionner le Modèle à Appliquer :",
    chooseTemplate: "Choisir un modèle...",
    customerPickupTiming: "Jour de retrait client",
    sameDayProduction: "Même jour que la production",
    dayAfterProduction: "Jour après la production",
    pickupTimingNote: "Quand les clients doivent-ils récupérer leurs commandes ?",
    applyTemplateToDates: "Appliquer le Modèle à",
    createNewProduction: "Ajouter un Nouveau Jour de Production",
    editProduction: "Modifier la Production",
    quickStartTemplate: "Démarrage Rapide à partir du Modèle",
    createFromScratch: "Créer à partir de zéro...",
    templateApplied: "Modèle appliqué",
    productionDate: "Date de Production",
    whenBake: "Quand vous cuirez ces produits",
    whenCustomersCollect: "quand les clients peuvent collecter",
    setPickupDate: "Définir quand ce lot de production sera disponible pour la collecte client",
    productionQuantities: "Quantités de Production",
    productionQuantitiesRequired: "(Requis pour la commande client)",
    addProductButton: "Ajouter Produit",
    noProductsAdded: "⚠️ Aucun produit ajouté encore.",
    noProductsAddedMsg: "Les clients ne pourront pas commander pour cette production jusqu'à ce que vous spécifiiez les quantités.",
    selectProduct: "Sélectionner le produit...",
    quantity: "Quantité",
    weight: "Poids",
    totalQuantityNote: "Quantité totale disponible pour TOUTES les dates de collecte pour cette production",
    howItWorks: "Comment ça marche :",
    howItWorksMsg: "Définissez la quantité totale que vous produirez à la date de production. Cette quantité sera partagée entre toutes les dates de collecte que vous spécifiez.",
    createProductionDay: "Créer un Jour de Vente",
    updateProductionDay: "Mettre à Jour le Jour de Production",
    productionDay: "Jour de Production",
    scheduledProductions: "Productions Programmées",
    noProductionsScheduled: "Aucune production programmée pour le moment",
    production: "Production",
    copyToOtherDates: "Copier vers d'autres Dates",
    saveAsTemplate: "Sauvegarder comme modèle",
    copyProduction: "Copier la Production",
    copyingFrom: "Copie depuis :",
    productsWillBeCopied: "produit(s) sera(ont) copié(s)",
    selectDatesToCopy: "Sélectionner les dates vers lesquelles copier",
    addDate: "Ajouter une Date",
    selected: "Sélectionné",
    hasProduction: "A une Production",
    todayProduction: "Aujourd'hui",
    template: "Modèle",
    templateName: "Nom du Modèle",
    filterByPeriod: "Filtrer par Période",
    lastMonth: "Le Mois Dernier",
    lastWeek: "Semaine Dernière",
    thisWeek: "Cette Semaine",
    nextWeek: "Semaine Prochaine",
    thisMonth: "Ce Mois",
    nextMonth: "Mois Prochain",
    all: "Tout",
    recipeBasedProduction: "Production Basée sur Recettes",
    selectBaseRecipe: "Sélectionner la Recette de Base",
    totalDoughLimit: "Limite de Pâte Totale",
    totalDoughLimitNote: "Pâte de base maximale (en grammes) que vous pouvez produire pour cette recette",
    enabledProducts: "Activer les Produits",
    selectProductsForRecipe: "Sélectionner les produits à activer pour cette recette",
    noProductsForRecipe: "Aucun produit n'utilise cette recette",
    recipeQuantities: "Quantités par Recette",
    addRecipeLimit: "Valider la Limite de Recette",
    baseDoughLimit: "Limite de Pâte de Base",
    productsEnabled: "Produits Activés",
    
    // Production Templates
    productionTemplates: "Modèles de Production",
    proTip: "💡 Astuce Pro :",
    proTipMsg: "Créez des modèles pour vos calendriers de production courants (jours de semaine, fins de semaine, jours fériés). Ensuite, appliquez-les rapidement lors de la création de jours de production !",
    createNewTemplate: "Créer un Nouveau Modèle",
    editTemplate: "Modifier le Modèle",
    type: "Type",
    weekday: "Jour de Semaine",
    weekend: "Fin de Semaine",
    specialEvent: "Événement Spécial",
    custom: "Personnalisé",
    addToTemplate: "Ajouter des produits à ce modèle",
    createTemplate: "Créer",
    updateTemplate: "Mettre à Jour",
    yourTemplates: "Vos Modèles",
    noTemplatesYet: "Aucun modèle créé encore",
    createFirstTemplate: "Créez votre premier modèle pour commencer !",
    howToUseTemplates: "Comment Utiliser les Modèles",
    step1Title: "Créer des Modèles",
    step1Desc: "Configurez vos calendriers de production courants avec des quantités de produits typiques",
    step2Title: "Appliquer aux Dates",
    step2Desc: "Allez à Jours de Production et utilisez 'Créer à partir du Modèle' pour planifier rapidement",
    step3Title: "Gagner du Temps",
    step3Desc: "Plus de saisie manuelle ! Ajustez les quantités si nécessaire pour des jours spécifiques",
    
    // Shopping List
    shoppingListTitle: "Liste de courses",
    stockNotConfigured: "La gestion du stock n'est pas configurée. Les quantités totales nécessaires sont affichées. Ajoutez des achats pour voir ce qui manque.",
    ingredientsTotal: "ingrédients",
    generateShoppingList: "Générer la liste",
    selectProductionDays: "Sélectionner les jours de production",
    ingredientNeeded: "Total nécessaire",
    ingredientInStock: "Stock disponible",
    ingredientToBuy: "Manquant",
    everythingInStock: "Tout est en stock — rien à acheter !",
    selectAllDays: "Tout sélectionner",
    deselectAllDays: "Tout désélectionner",
    noFutureDays: "Aucun jour de production à venir",
    noDaysSelected: "Sélectionnez un ou plusieurs jours de production pour générer votre liste.",
    noRecipeProducts: "Aucun produit avec recette trouvé pour ces jours.",
    shoppingListFor: "Liste de courses pour",
    printShoppingList: "Imprimer",
    exportCsv: "Exporter CSV",
    copyToClipboard: "Copier",
    ingredientsToBuy: "ingrédients à acheter",
    totalShortfall: "Manque total",
    generatedOn: "Généré le",

    // Production Planning
    productionPlanningTitle: "Planification de Production",
    planningExportCSV: "Exporter CSV",
    selectProduction: "Sélectionner Production :",
    selectProductionPlaceholder: "Sélectionner une production...",
    wasteFactor: "Facteur de Perte (%)",
    wasteFactorNote: "Ajouter de la pâte supplémentaire pour tenir compte des pertes/tests",
    selectToSeePlan: "Sélectionner une production pour voir le plan",
    productsToMake: "Produits à Faire :",
    customerOrders: "Commandes Clients",
    customerOrdersOnline: "Commandes Clients en Ligne",
    units: "unités",
    each: "chacun",
    totalDough: "pâte totale",
    ingredientsNeeded: "Ingrédients Nécessaires :",
    ingredient: "Ingrédient",
    baseRecipe: "Recette de Base",
    bakersPercent: "% Boulanger",
    scaledAmount: "Quantité Ajustée",
    batchPlanning: "Planification des Lots :",
    mixer: "Mélangeur",
    totalBatches: "Lots Totaux :",
    batch: "Lot",
    flour: "farine",
    totalDoughNeeded: "Pâte Totale Nécessaire :",
    withWaste: "Avec",
    waste: "de perte",
    scaleFactor: "Facteur d'Échelle :",
    baseRecipeScale: "Recette de base ×",
    noMixerNote: "Aucun mélangeur assigné à cette recette",
    loadingProductionData: "Chargement des données de production...",
    recipeSections: "Sections de Recette",
    recipeNotes: "Notes de Recette",
    baseDoughCalculation: "Calcul de Pâte de Base",
    totalBaseDoughNeeded: "Pâte de Base Totale Nécessaire",
    totalVariationIngredients: "Total des Ingrédients de Variation",
    calculating: "Calcul en cours",
    baseRecipeIngredients: "Ingrédients de la Recette de Base",
    variationIngredientsAddOns: "Ingrédients de Variation (Ajouts)",
    variationIngredientsMixedIn: "Ingrédients de Variation (Mélangés)",
    addAfterShaping: "Ajouter après façonnage",

    // Production Buffer
    productionBuffer: 'Marge de production',
    productionBufferHelper: 'Permet de prévoir une petite quantité supplémentaire pour couvrir les pertes liées au façonnage, à la cuisson ou aux imprévus.',
    recipeProductionBuffer: 'Marge de sécurité',
    totalToProduce: 'Total à produire',
    totalWithMargin: 'Total avec marge',
    dough: 'de pâte',
    baseDoughWeight: 'Poids de pâte de base',
    baseVariationWeight: 'Ingrédients de Variation de Base',
    totalDoughWithBuffer: 'Total pâte (avec marge)',
    mixedIntoDough: "Mélangé dans la pâte",
    forProduct: "Pour",
    baseDough: "Pâte de Base",
    neededForOrders: "Nécessaire pour les Commandes",
    finalWeight: "Poids Final",
    exceedsLimit: "DÉPASSE LA LIMITE",
    withinLimit: "Dans la Limite",
    remainingCapacity: "Capacité Restante",
    orderedStatus: "Commandée",
    orderedQuantity: 'Commandée',
    productionQuantity: 'Production',
    scaleRecipeProduction: 'Ajuster la quantité de production',
    scaleAllRecipes: 'Ajuster la quantité de toutes les recettes',
    resetToOrderQuantity: 'Réinitialiser à la quantité commandée',
    resetToRecipeLimit: 'Réinitialiser à la limite de production',
    noRecipeLimitsSet: 'Aucune limite de recette n\'est définie pour ce jour de production. Veuillez définir les limites dans la Gestion des Jours de Production d\'abord.',
    adjustedUp: 'Ajusté vers le haut',
    adjustedDown: 'Ajusté vers le bas',

    // Reports View
    salesReportsTitle: "Rapports et Analyses des Ventes",
    dateRange: "Période",
    allTime: "Tout le Temps",
    last7Days: "7 Derniers Jours",
    last30Days: "30 Derniers Jours",
    customRange: "Plage Personnalisée",
    reportsStartDate: "Date de début",
    reportsEndDate: "Date de fin",
    reportsTotalRevenue: "Revenu Total",
    reportsTotalOrders: "Commandes Totales",
    averageOrderValue: "Valeur Moyenne des Commandes",
    completedOrders: "Complétées",
    revenueOverTime: "Revenus au Fil du Temps",
    orderStatusDistribution: "Répartition des Statuts de Commande",
    revenue: "Revenus",
    noDataAvailable: "Aucune donnée disponible",
    productSalesPerformance: "Performance des Ventes par Produit",
    quantitySold: "Quantité Vendue",
    noProductSalesData: "Aucune donnée de vente de produit disponible",
    reportsOrderId: "ID de Commande",
    date: "Date",
    loadingReports: "Chargement des rapports...",
    errorLoadingReports: "Erreur lors du chargement des rapports",
    costsIncludeRealFixed: "Coûts incluent les Charges Fixes Réelles",
    costsIncludeEstimatedFixed: "Coûts incluent les Charges Fixes Estimées",
    ingredientCostsOnly: "Coûts des Ingrédients Seulement",
    revenuePartiallyEstimated: "Revenus partiellement estimés (certains jours non rapprochés)",
    monthsClosed: "mois clôturés",

    // Baker Settings
    bakerySettings: "Paramètres de la Boulangerie",
    settingsSaved: "Paramètres enregistrés avec succès !",
    homePageSaved: "Modifications enregistrées avec succès !",
    businessInformation: "Informations sur l'Entreprise",
    localizationSettings: "Paramètres de Localisation",
    appearanceSettings: "Paramètres d'Apparence",
    theme: "Thème",
    themeDescription: "Choisissez le thème de couleur pour votre interface de boulangerie",
    themePreview: "Aperçu du Thème",
    primaryButton: "Bouton Principal",
    secondaryButton: "Bouton Secondaire",
    currencySymbol: "Symbole de la Devise",
    currencyNote: "Les paramètres de devise s'appliqueront à tous les prix des produits et commandes clients. Les prix existants resteront inchangés mais s'afficheront avec le nouveau symbole de devise.",
    businessName: "Nom de l'Entreprise",
    businessAddress: "Adresse de l'Entreprise",
    businessPhone: "Téléphone de l'Entreprise",
    businessEmail: "Email de l'Entreprise",
    addressPlaceholder: "Numéro et rue, ex. 12 rue du Boulanger",
    saveSettings: "Enregistrer les Paramètres",
    loadingSettings: "Chargement des paramètres...",
    errorSavingSettings: "Erreur lors de l'enregistrement des paramètres",
    errorLoadingSettings: "Erreur lors du chargement des paramètres",
    note: "Remarque",
    
    // Equipment Manager
    equipmentManagement: "Gestion de l'Équipement",
    addNewEquipment: "Ajouter Nouvel Équipement",
    editEquipment: "Modifier l'Équipement",
    deleteEquipment: "Supprimer l'Équipement",
    equipmentName: "Nom de l'Équipement",
    equipmentType: "Type",
    maxFlourCapacity: "Capacité Max de Farine (kg)",
    addEquipment: "Ajouter Équipement",
    updateEquipment: "Mettre à Jour Équipement",
    equipmentList: "Liste d'Équipement",
    noEquipmentAdded: "Aucun équipement ajouté encore",
    maxFlour: "Farine Max (kg)",
    equipmentActions: "Actions",
    other: "Autre",
    
    // Recipe Manager
    recipeManagement: "Gestion des Recettes",
    createNewRecipe: "Créer une Nouvelle Recette",
    editRecipe: "Modifier la Recette",
    recipeName: "Nom de la Recette",
    baseFlourAmount: "Quantité de Farine de Base (g)",
    recipeScaleNote: "La recette sera mise à l'échelle en fonction de cette quantité",
    notes: "Notes",
    recipeSummary: "Résumé de la Recette",
    totalDoughYield: "Rendement Total de Pâte :",
    hydration: "Hydratation :",
    createRecipe: "Créer Recette",
    updateRecipe: "Mettre à Jour Recette",
    recipeIngredientsTitle: "Ingrédients",
    addIngredient: "Ajouter Ingrédient",
    selectIngredient: "Sélectionner un ingrédient",
    addCustomIngredient: "+ Ajouter Ingrédient Personnalisé",
    enterCustomIngredient: "Entrez le nom de l'ingrédient personnalisé",
    recipeIngredients: "Ingrédients de la Recette",
    noIngredientsAdded: "Aucun ingrédient ajouté encore",
    add: "Ajouter",
    yourRecipes: "Vos Recettes",
    duplicate: "Dupliquer",
    duplicateRecipe: "Dupliquer la recette",
    newRecipeName: "Nom de la nouvelle recette",
    recipeNameExists: "Une recette porte déjà ce nom",
    recipeDuplicated: "Recette dupliquée",
    noRecipesCreated: "Aucune recette créée encore",
    baseFlour: "Farine de Base :",
    totalYield: "Rendement Total :",
    ingredientCount: "Ingrédients :",
    mainDough: "Pâte Principale",
    addSection: "Ajouter une Section",
    sectionNotes: "Notes de section...",
    confirmHideRecipe: "Voulez-vous masquer cette recette ?",
    
    // Base Recipe & Variations
    baseRecipeSettings: "Paramètres de Recette de Base",
    variationIngredients: "Ingrédients de Variation",
    variationIngredientsOptional: "Ingrédients de Variation (Optionnel)",
    variationIngredientsNote: "Ajoutez les ingrédients qui rendent ce produit différent de la recette de base",
    addVariationIngredient: "Ajouter un Ingrédient de Variation",
    variationType: "Type de Variation",
    mixedIn: "Mélangé",
    mixedInNote: "Mélangé dans la pâte (réduit la pâte de base nécessaire)",
    addOn: "Ajouté",
    addOnNote: "Ajouté après façonnage (n'affecte pas la pâte de base)",
    quantityPerUnit: "Quantité par unité",
    percentOfFlour: "de Farine",
    percentOfFlourNote: "Pourcentage relatif à la farine dans la recette de base",
    removeVariation: "Retirer la Variation",
    noVariations: "Aucune variation ajoutée",
    
    // Database Cleaner
    databaseCleaner: "Nettoyeur de Base de Données",
    databaseCleanerInfo: "Cet outil supprime définitivement vos recettes, équipements ou ingrédients enregistrés. Utilisez-le avec prudence !",
    deleteAllRecipes: "Supprimer Toutes les Recettes",
    deleteAllEquipment: "Supprimer Tous les Équipements",
    deleteAllIngredients: "Supprimer Tous les Ingrédients",
    deleteAllData: "Supprimer Toutes les Données",
    recordsDeleted: "enregistrements supprimés avec succès",
    deleteConfirm: "Supprimer cet équipement ? Cela peut affecter les recettes associées.",
    deleteConfirmRecipe: "Supprimer cette recette ? Cette action est irréversible.",
    confirmDelete: "Voulez-vous supprimer ce jour de production ?",
    deleteProductionDay: "Supprimer le Jour de Production",
    confirmDeleteTemplate: "Voulez-vous supprimer ce modèle ? Cela n'affectera pas les jours de production déjà planifiés avec ce modèle",
    templateDeletedSuccess: "Modèle supprimé avec succès. Cela n'a pas affecté les jours de production déjà planifiés avec ce modèle.",
    deleting: "Suppression",
    linkedToThisProductionDay: "commande(s) liée(s) à ce jour de production",
    order: "commande",
    confirmDeleteProductionDay: "Êtes-vous sûr de vouloir supprimer ce jour de production ?",
    confirmDeleteProductionDayWithOrders: "Êtes-vous sûr de vouloir supprimer ce jour de production ? Cela affectera les commandes existantes.",
    keepOrders: "Conserver les Commandes",
    keepOrdersDescription: "Les commandes resteront dans le système et se rattacheront automatiquement si vous créez un nouveau jour de production à la même date.",
    deleteOrders: "Supprimer les Commandes",
    deleteOrdersDescription: "Supprimer définitivement toutes les commandes liées à ce jour de production.",
    deleteSelected: "Supprimer la sélection",
    bulkDeleteConfirm: "Vous êtes sur le point de supprimer définitivement {count} jour(s) de production.",
    bulkDeleteLinkedOrders: "{count} commande(s) liée(s) seront également affectées :",
    bulkDeleteAllDays: "Supprimer les {count} journées sélectionnées",
    bulkDeleteCleanOnly: "Supprimer uniquement les {count} journées sans commandes",
    bulkDeleteSkipped: "{count} journée(s) avec commandes sera ignorée",
    deleteConfirmData: "Êtes-vous sûr de vouloir supprimer définitivement ces données ?",
    loadDemoData: "Charger Données Démo",
    demoDataDescription: "Générer des données d'exemple de janvier 2025 à aujourd'hui avec ~2 jours de production par semaine et 3-8 commandes par jour de production",
    
    // Stock Management
    stockManagement: "Gestion du Stock",
    printStockLevels: "Imprimer",
    stockLevelsReportTitle: "Niveaux de Stock",
    printPurchaseQty: "Qté Achat",
    printConsumedQty: "Qté Consommée",
    printRemainingQty: "Qté Restante",
    printActualQty: "Qté Réelle",

    // Physical Inventory / Stock Adjustments
    physicalInventory: "Inventaire Physique",
    inventoryAdjustments: "Ajustement du stock",
    actualQuantity: "Quantité réelle",
    systemQuantity: "Quantité système",
    startCount: "Démarrer le Comptage",
    reviewCount: "Vérifier le Comptage",
    postCount: "Valider le Comptage",
    expectedQty: "Attendu",
    countedQty: "Compté",
    varianceValue: "Valeur de l'Écart",
    adjustmentReason: "Raison de l'ajustement",
    adjustmentReasonShrinkage: "Perte / Vol Suspecté",
    adjustmentReasonMeasurementError: "Erreur de Mesure",
    adjustmentReasonReceivingError: "Erreur de Réception",
    adjustmentReasonSpoilageNotLogged: "Perte Non Enregistrée",
    adjustmentReasonOther: "Autre",
    noVarianceLines: "Aucun changement à valider",
    driftDetected: "Le stock a changé depuis le début du comptage. Veuillez actualiser et recompter.",
    refreshCount: "Actualiser le Comptage",
    noteRequiredAboveThreshold: "Une remarque est requise pour un écart aussi important",
    reasonRequired: "Une raison est requise",
    countPosted: "Comptage d'inventaire validé avec succès",
    adjustedLines: "Lignes Ajustées",
    totalIncrease: "Total Augmentation",
    totalDecrease: "Total Diminution",
    netVariance: "Écart Net",
    countedBy: "Compté par",
    countSession: "Session de Comptage",
    reverseAdjustment: "Annuler l'Ajustement",
    reversalOf: "Annulation de",
    confirmReversal: "Ceci annulera exactement l'ajustement d'origine. Continuer ?",
    reversed: "Annulé",
    inventoryAdjustmentsTitle: "Rapport d'ajustement du stock",
    printInventoryAdjustments: "Imprimer",
    noAdjustmentData: "Aucune donnée d'ajustement disponible",
    adjustmentRecords: "Enregistrements d'Ajustement",
    ingredientPurchaseHistory: "Tous les achats de cet ingrédient",
    avgPurchasePrice: "Prix moyen",
    avgPurchasePriceHint: "Pondéré par la quantité, tous achats",
    lowestPrice: "Prix le plus bas",
    highestPrice: "Prix le plus élevé",
    lowestShort: "MIN",
    highestShort: "MAX",
    totalPurchased: "Total acheté",
    pricePerKg: "Prix",
    statusInStock: "En stock",
    statusUsedUp: "Épuisé",
    last12Months: "12 derniers mois",
    noPurchasesInPeriod: "Aucun achat de cet ingrédient sur cette période",
    adjustmentType: "Type",
    adjustmentTypeAll: "Tous les types",
    adjustmentTypeQuantity: "Comptage quantité",
    adjustmentTypePrice: "Correction de prix",
    adjustmentBefore: "Avant",
    adjustmentAfter: "Après",
    priceCorrections: "Corrections de prix",
    unlistedLotBadge: "Lot Non Répertorié",

    addPurchase: "Ajouter des Achats",
    editPurchase: "Modifier l'Achat",
    purchaseHistory: "Historique des Achats",
    currentStock: "Stock Actuel",
    noStock: "Aucun stock enregistré",
    noPurchases: "Aucun achat enregistré",
    purchaseItems: "Liste des Achats",
    addRow: "Ajouter une Ligne",
    totalCost: "Coût Total",
    lotBatchNumber: "Numéro Lot",
    avgRevenuePerDay: "Revenus Moyens/Jour de prod.",
    avgCostPerDay: "Coût Moyen/Jour de prod",
    avgMarginPerDay: "Marge Moyenne/Jour de prod",
    unitCost: "Coût Unitaire",
    remaining: "Restant",
    consumed: "consommé",
    value: "Valeur",
    avgCost: "Coût Moyen",
    purchases: "Achats",
    lowStock: "Stock faible",
    purchaseDate: "Date d'Achat",
    supplier: "Fournisseur",
    expiryDate: "Date d'Expiration",
    manualCost: "Coût Manuel",
    manualCostNote: "Pour les produits sans recette",
    cost: "Coût",
    estimatedCost: "Coût Estimé",
    estimatedRevenue: "Revenus Estimés",
    estimatedMargin: "Marge Estimée",
    costPerKg: "Coût par kg",
    insufficientStock: "Stock insuffisant pour les ingrédients suivants :",
    stockNotConsumed: "Le stock n'a pas été consommé.",
    need: "besoin",
    have: "disponible",
    shortfall: "déficit",
    productionCannotBeMarkedAsDone: "La production ne peut pas être marquée comme terminée",
    customIngredients: "Ingrédients Personnalisés",
    noCustomIngredients: "Aucun ingrédient personnalisé ajouté encore",
    ingredientExists: "L'ingrédient existe déjà",
    increaseFactor: "Facteur d'Augmentation (%)",
    withIncrease: "Avec Augmentation",
    saveProductionAdjustments: "Enregistrer les quantités de production",
    productionAdjustmentsSaved: "Quantités de production enregistrées avec succès.",
    savedAdjustmentsLoaded: "Quantités de production sauvegardées chargées",
    markProductionDone: "Marquer Production Terminée",
    productionCompleted: "Production Terminée",
    productionCompletedOn: "Ce jour de production a été marqué comme terminé le {date}.",
    productionLocked: "Les quantités de production et la mise à l'échelle des recettes sont verrouillées et ne peuvent pas être modifiées.",
    confirmMarkProductionDone: "Êtes-vous sûr de vouloir marquer cette production comme terminée ? Cela consommera les ingrédients du stock.",
    confirmMarkProductionDoneNoStock: "Êtes-vous sûr de vouloir marquer cette production comme terminée ?",
    confirmMarkProductionDoneZero: "Aucune quantité de production n'est définie. Êtes-vous sûr de vouloir marquer cela comme terminé ?",
    productionCompletedSuccessfully: "Production marquée comme terminée et stock mis à jour !",
    productionCompletedSuccessfullyNoStock: "Production marquée comme terminée !",
    confirm: "Confirmer",
    cancel: "Annuler",

    // Production Trace Confirmation (French)
    productionTraceConfirmation: "Confirmation de Traçabilité de Production",
    productionTraceConfirmationDesc: "Réviser l'utilisation des ingrédients et les données de traçabilité avant de marquer la production comme terminée",
    productionTraceWarning: "Ces informations seront enregistrées de manière permanente à des fins de traçabilité. Une fois confirmées, les niveaux de stock seront définitivement mis à jour.",
    ingredientTraceabilitySummary: "Résumé de Traçabilité des Ingrédients",
    ingredientTraceabilityDesc: "Ventilation détaillée des ingrédients utilisés, y compris les numéros de lot, les dates d'achat et les dates d'expiration pour une traçabilité complète",
    recipeTraceabilitySummary: "Résumé de Traçabilité des Recettes",
    recipeTraceabilityDesc: "Ventilation détaillée des ingrédients utilisés par recette, y compris les numéros de lot, les dates d'achat et les dates d'expiration pour une traçabilité complète",
    nonTraceable: "Non traçable (sans lot)",
    traceBatchNumber: "Lot",
    tracePurchaseDate: "Date d'Achat",
    traceExpiryDate: "Date d'Expiration",
    traceSupplier: "Fournisseur",
    traceQuantity: "Quantité",
    traceBatch: "lot",
    traceBatches: "lots",
    traceExpired: "Expiré",
    traceExpiredAtProductionApproved: "Expiré à la production — utilisé avec l'accord du boulanger",
    traceExpiringSoon: "Expire Bientôt",
    traceImportant: "Important",
    confirmAndMarkDone: "Confirmer et Marquer comme Terminé",
    traceProductionDate: "Date de Production",
    traceTotalCost: "Coût Total",
    traceCompletedAt: "Terminé À",
    traceType: "Type",
    traceBatchDetails: "Détails du Lot",
    traceProductionRecipes: "Recettes de Production",
    traceDoughNeeded: "Pâte Necesaire",
    traceScaleFactor: "Facteur d'Échelle",
    traceCost: "Coût",
    noIngredientData: "Aucune donnée de traçabilité d'ingrédient disponible",
    noTraceDataAvailable: "Aucune donnée de traçabilité disponible pour cette production",
    viewTrace: "Voir la Traçabilité",
    
    // Recipe Type Labels (French)
    traceBaseRecipe: "Recette de Base",
    traceAddon: "Supplément",
    traceMixedin: "Mélangé",
    productionDayCreated: "Jour de production créé avec succès !",
    productionDayAlreadyExists: "Un jour de production existe déjà pour cette date. Veuillez choisir une date différente.",
    productionDateAlreadyScheduled: "Un jour de production existe déjà à cette date",
    productionDatesSkipped: "Ignorées (déjà planifiées)",
    noFreeDatesToCreate: "Toutes les dates choisies ont déjà un jour de production",
    stockConsumptionFailed: "Certains ingrédients n'ont pas pu être consommés du stock. Veuillez vérifier votre inventaire.",
    selectSupplier: "Sélectionner Fournisseur",
    addNewSupplier: "+ Ajouter Nouveau Fournisseur",
    enterSupplierName: "Entrez le nom du fournisseur",
    supplierExists: "Le fournisseur existe déjà",
    dateFormat: "Format de Date",
    dateFormatMMDDYYYY: "MM/JJ/AAAA (US)",
    dateFormatDDMMYYYY: "JJ/MM/AAAA (Européen)",
    dateFormatYYYYMMDD: "AAAA-MM-JJ (ISO)",
    manageStock: "Gérer le Stock",
    manageStockDescription: "Lorsqu'elle est désactivée, le stock est considéré comme infini et la finalisation de la production ne vérifiera pas la disponibilité des ingrédients",
    showOnlyInStock: "Afficher seulement en stock",
    stockShortfallWarning: "Avertissement de Déficit de Stock",
    insufficientStockForProduction: "Stock Insuffisant pour la Production",
    purchaseMoreIngredients: "Veuillez acheter plus d'ingrédients ou ajuster les quantités de production avant de marquer la production comme terminée.",
    savePurchases:"Enregistrer les Achats",

    // Scan de Facture
    scanInvoice: "Scanner une Facture",
    uploadInvoice: "Télécharger la Facture",
    processingInvoice: "Traitement en cours...",
    reviewInvoice: "Vérifier les Articles",
    matchedIngredient: "Ingrédient Correspondant",
    confirmStockEntry: "Confirmer et Ajouter au Stock",
    noMatchFound: "Aucune correspondance",
    scanInvoiceSuccess: "Articles ajoutés au stock avec succès !",
    gramsPerUnit: "g par unité",
    gramsPerUnitRequired: "Requis pour pcs/unité",
    qtyPerUnit: "Qté par unité",
    packSize: "Contenu du paquet",
    packSizeContains: "contient",
    packSizePerPiece: "par pièce",
    packSizeGramsPerPcs: "g par pièce",
    conversionRequired: "Requis pour un achat par lot (sac/carton/plaque...)",
    lowConfidenceMatch: "Correspondance approximative — vérifiez",

    purchaseRecorded: "Purchase recorded successfully!",
    achatsEnregistres: "Achats enregistrés avec succès !",

    

    // French translations for waste/discard
    discardStock: "Jeter du Stock",
    deleteStock: "Supprimer le Stock",
    discard: "Jeter",
    discardAll: "Tout Jeter",
    discardPartial: "Jeter une Quantité Partielle",
    discardQuantity: "Quantité à Jeter (kg)",
    discardReason: "Raison du Rejet",
    discardReasonExpired: "Expiré",
    discardReasonDamaged: "Endommagé",
    discardReasonError: "Erreur",
    discardReasonOther: "Autre",
    discardReasonPlaceholder: "Entrez la raison...",
    selectReason: "Sélectionner la raison",
    wasteCost: "Coût des Déchets",
    correctPrice: "Corriger le prix",
    correctPriceTitle: "Corriger le prix d'achat",
    correctPriceExplanation: "Ce lot a déjà été utilisé : les quantités, le numéro de lot, les dates et le fournisseur restent verrouillés pour la traçabilité. Seul le prix peut être corrigé. Le nouveau prix s'applique au stock restant et aux productions futures. Les productions et pertes passées conservent le coût enregistré à l'époque. La correction est conservée dans le journal d'audit.",
    correctPriceNewTotal: "Prix total corrigé",
    correctPriceReason: "Motif de la correction",
    correctPriceReasonInvoiceError: "Erreur de saisie de facture",
    correctPriceRemainingValue: "Variation de la valeur du stock restant",
    priceCorrected: "Prix corrigé",
    priceCorrectedSuccess: "Prix corrigé avec succès",
    priceCorrectionConflict: "Le prix de ce lot a été modifié entre-temps. Veuillez rouvrir la correction et réessayer.",
    totalWasteCost: "Coût Total des Déchets",
    wasteRecorded: "Déchets enregistrés avec succès !",
    wasteRecordedFr: "Déchets enregistrés avec succès !",
    confirmDiscard: "Confirmer le Rejet",
    confirmDiscardMsg: "Êtes-vous sûr de vouloir jeter ce stock ? Cette action ne peut pas être annulée.",
    discardSuccess: "Stock jeté avec succès !",
    discardSuccessFr: "Stock jeté avec succès !",
    wasteReports: "Rapports de Déchets",
    wasteReportsTitle: "Rapports de Déchets et Rejets de Stock",
    wasteByIngredient: "Déchets par Ingrédient",
    wasteByReason: "Déchets par Raison",
    wasteOverTime: "Déchets dans le Temps",
    noWasteData: "Aucune donnée de déchets disponible",
    wasteDate: "Date des Déchets",
    wasteReason: "Raison",
    wasteAmount: "Quantité de Déchets (kg)",
    wasteValue: "Valeur des Déchets",

    // Charges Fixes (Fixed Costs)
    fixedCosts: "Charges Fixes",
    fixedCostsManagement: "Gestion des Charges Fixes",
    addFixedCost: "Ajouter une Charge",
    editFixedCost: "Modifier la Charge",
    fixedCostName: "Nom de la Charge",
    monthlyAmount: "Montant Mensuel",
    costCategory: "Catégorie",
    rent: "Loyer",
    utilities: "Services Publics",
    insurance: "Assurance",
    labor: "Main d'œuvre",
    subscriptions: "Abonnements",
    energy: "Énergie (Électricité, Gaz, Bois)",
    marketing: "Marketing et Publicité",
    maintenance: "Entretien d'Équipement",
    transportation: "Transport et Livraison",
    customCategory: "Personnalisé...",
    enterCustomCategory: "Entrez une catégorie personnalisée",
    totalMonthlyFixedCosts: "Total des Charges Mensuelles",
    planningMethod: "Méthode de Planification",
    calendarBased: "Basé sur le Calendrier (Production Mensuelle)",
    templateBased: "Basé sur un Modèle (Schéma Hebdomadaire)",
    selectMonth: "Sélectionner le Mois",
    selectTemplateShort: "Sélectionner un Modèle",
    productionDaysPerWeek: "Jours de Production par Semaine",
    fixedCostPerGram: "Charge Fixe par kg",
    plannedDoughProduction: "Production de Pâte Prévue",
    exampleLoafCost: "Exemple: charge fixe pour un pain de 700g",
    configureFixedCosts: "configurer les charges fixes",
    setFixedCosts: "Définir les Charges Fixes",
    ingredientCost: "Coût des Ingrédients",
    fixedCost: "Charge Fixe",
    noFixedCostsConfigured: "Aucune charge fixe configurée",
    fixedCostSavedSuccess: "Charge fixe enregistrée avec succès",
    fixedCostDeletedSuccess: "Charge fixe supprimée avec succès",
    fixedCostDeleteConfirm: "Supprimer cette charge fixe ?",
    activeItems: "Éléments Actifs",
    inactiveItems: "Éléments Inactifs",

    // Clôture Mensuelle (Month Close)
    monthClose: "Clôture Mensuelle",
    closeMonth: "Clôturer le Mois",
    closeProduction: "Clôturer la Production",
    closeSales: "Clôturer les Ventes",
    productionClosed: "Production Clôturée",
    salesClosed: "Ventes Clôturées",
    actualFixedCosts: "Charges Fixes Réelles",
    actualDoughGrams: "Grammes de Pâte Réels",
    fixedCostPerGramReal: "Charge Fixe/kg Réelle",
    fixedCostPerGramPlanned: "Charge Fixe/kg Prévue",
    reconciliationStatus: "État du Rapprochement",
    reconciliationPercent: "% de Rapprochement",
    plannedVsReal: "Prévu vs Réel",
    variance: "Écart",
    marginReal: "Marge Réelle",
    marginEstimated: "Marge Estimée",
    partiallyEstimated: "Partiellement Estimée",
    closeProductionFirst: "Clôturer d'abord la production",
    reconciliationWarning: "Rapprochement inférieur à 90%",
    productionClosedOn: "Production clôturée le",
    salesClosedOn: "Ventes clôturées le",
    totalDoughProduced: "Pâte Totale Produite",
    closeProductionConfirm: "Clôturer la production pour ce mois ? Cela figera le taux de charge fixe.",
    closeSalesConfirm: "Clôturer les ventes pour ce mois ? Cela calculera les marges réelles.",
    closeProductionTitle: "Clôturer la Production",
    closeSalesTitle: "Clôturer les Ventes",
    deleteFixedCostTitle: "Supprimer la Charge Fixe",
    daysReconciled: "jours rapprochés",
    monthCloseSuccess: "Mois clôturé avec succès",

    // Month Close Summary
    monthSummary: "Résumé du Mois",
    productionEfficiency: "Production",
    fixedCostAllocation: "Charge Fixe/g",
    costImpactPerLoaf: "Coût par Pain",
    monthResults: "Résultats",
    planned: "Prévu",
    actual: "Réel",
    differenceVsPlan: "vs Prévu",
    impact: "Impact",
    efficient: "Économies",
    overCost: "Dépassement",
    totalCosts: "Coûts Totaux",
    realMargin: "Marge",
    basedOnReconciledSales: "Basé sur les ventes rapprochées",
    fixedCostExplanation: "Les charges fixes restent les mêmes même quand vous produisez moins. Moins de kilos produits augmente le coût par pain.",

    // Common
    loading: "Chargement...",
    save: "Sauvegarder",
    close: "Fermer",
    edit: "Modifier",
    delete: "Supprimer",
    yes: "Oui",
    no: "Non",
    ok: "OK",
    required: "Requis",
    fillAllFields: "Veuillez remplir tous les champs requis",
    errorOccurred: "Une erreur est survenue. Veuillez réessayer.",
    success: "Succès",
    pleaseLogin: "Veuillez vous connecter pour accéder à cette page",
    onlyForBakers: "Cette page est accessible uniquement aux boulangers",
    cannotDeleteCompleted: "Impossible de supprimer les jours de production terminés",
    created: "Créé",
    copied: "Copié",
    to: "au",
    selectAll: "Tout Sélectionner",
    filter: "Filtrer",
    filterByReason: "Filtrer par Raison",
    
    // Points de Collecte
    collectionPoints: "Points de Collecte",
    addCollectionPoint: "Ajouter un Point de Collecte",
    selectCollectionPoint: "Sélectionner un Point de Collecte",
    selectCollectionPointFirst: "Veuillez d'abord sélectionner un point de collecte",
    selectCollectionPointRequired: "Veuillez sélectionner un point de collecte pour continuer",
    collectionPointLocation: "Lieu",
    collectionPointTime: "Heure",
    collectionPointStartTime: "Heure de Début",
    collectionPointEndTime: "Heure de Fin",
    noCollectionPoints: "Aucun point de collecte disponible",
    collectionPointRequired: "Sélection d'un point de collecte requise",
    editCollectionPoint: "Modifier le Point de Collecte",
    removeCollectionPoint: "Supprimer le Point de Collecte",
    collectionPoint: "Point de Collecte",
    print: "Imprimer",
    printRecipe: "Imprimer les Recettes",
    printRecipeTitle: "Recette pour",
    printOrdersReport: "Rapport des Commandes",
    printTraceabilityReport: "Rapport de Traçabilité de Production",
    // Production phase short codes (codes CAP boulanger)
    phaseCodeKneading: "P",
    phaseCodeBulkProofing: "Pt",
    phaseCodeDividing: "Ps",
    phaseCodeShaping: "F",
    phaseCodeFinalProofing: "App",
    phaseCodeBaking: "C",
    phaseCodeAutolyse: "A",
    phaseCodeStretchFold1: "Rb1",
    phaseCodeStretchFold2: "Rb2",
    phaseCodeStretchFold3: "Rb3",
    phaseCodeStretchFold4: "Rb4",
    phaseCodeColdRetard: "RF",
    phaseCodeButterIncorporation: "IB",
    phaseCodeDoughMixing: "P",
    phaseCodeRest1: "R1",
    phaseCodeRest2: "R2",
    phaseCodeRest3: "R3",
    phaseCodeTourDouble: "Td",
    phaseCodeTourSimple1: "Ts1",
    phaseCodeTourSimple2: "Ts2",
    phaseCodeDetaillage: "D",
    // Production phase names (used by templates)
    phaseNameKneading: "Pétrissage",
    phaseNameBulkProofing: "Pointage",
    phaseNameDividing: "Division",
    phaseNameShaping: "Façonnage",
    phaseNameFinalProofing: "Apprêt",
    phaseNameBaking: "Cuisson",
    phaseNameAutolyse: "Autolyse",
    phaseNameStretchFold1: "Rabat #1",
    phaseNameStretchFold2: "Rabat #2",
    phaseNameStretchFold3: "Rabat #3",
    phaseNameStretchFold4: "Rabat #4",
    phaseNameColdRetard: "Fermentation au froid",
    phaseNameButterIncorporation: "Incorporation du beurre",
    phaseNameDoughMixing: "Pétrissage",
    phaseNameRest: "Repos",
    phaseNameTourDouble: "Tour double",
    phaseNameTourSimple1: "Tour simple #1",
    phaseNameTourSimple2: "Tour simple #2",
    phaseNameDetaillage: "Détaillage",
    // Production Organigramme
    productionPhases: "Étapes de production",
    addPhase: "Ajouter une étape",
    phaseTemplates: "Modèles d'étapes",
    useTemplate: "Utiliser un modèle",
    phaseName: "Nom de l'étape",
    phaseShortCode: "Code court",
    phaseDurationMin: "Durée (min)",
    phaseTypeLabel: "Type d'étape",
    phaseResourceLabel: "Ressource",
    noProductionPhasesDefined: "Aucune étape de production définie",
    productionPhasesDescription: "Définissez les étapes nécessaires pour produire cette recette.",
    productionPhasesDescriptionSub: "Digi-Bakery utilisera ces étapes pour générer un organigramme de production imprimable.",
    phaseTypeActiveWork: "Travail actif",
    phaseTypeWaiting: "Attente / Pointage",
    phaseTypeOven: "Cuisson (Four)",
    phaseTypeFridge: "Réfrigérateur",
    phaseTypeFreezer: "Congélateur",
    phaseTypeProofer: "Chambre de fermentation",
    phaseTypeMixer: "Pétrin",
    phaseTypeCooling: "Refroidissement",
    phaseTypePackaging: "Conditionnement",
    phaseTypeCustom: "Personnalisé",
    resourceTypeNone: "Aucune",
    resourceTypeOven: "Four",
    resourceTypeMixer: "Pétrin",
    resourceTypeFridge: "Réfrigérateur",
    resourceTypeFreezer: "Congélateur",
    resourceTypeProofer: "Chambre de fermentation",
    resourceTypeBench: "Plan de travail",
    resourceTypeRack: "Grille",
    resourceTypeCustom: "Personnalisé",
    resourceName: "Nom de la ressource",
    resourceNameHint: "ex. Four 1, Four 2",
    resourceNameOverride: "Ou saisir un nom personnalisé",
    customResource: "Personnalisé / sans nom",
    phaseColor: "Couleur",
    phaseColorHint: "optionnel — remplace la couleur par défaut de cette étape",
    clearColor: "Défaut",
    productionOrganigramme: "Organigramme de production",
    productionOrganigrammeDescription: "Saisissez l'heure de sortie du four par recette pour générer un organigramme de production imprimable.",
    targetOutOfOvenTime: "Sortie du four",
    finalTargetOutOfOvenTime: "Sortie du four (dernier enfournement)",
    generateTimeline: "Générer l'organigramme",
    printOrganigramme: "Imprimer l'organigramme",
    ovenConflictWarning: "Conflit four détecté",
    ovenConflictBoth: "utilisent le même four entre",
    timelineNotGenerated: "Saisissez les heures cibles ci-dessus et cliquez sur \"Générer l'organigramme\" pour prévisualiser le planning de production.",
    targetTimeRequired: "Heure de sortie du four requise",
    phaseTemplateBread: "Pain courant",
    phaseTemplateSourdough: "Pain au levain",
    phaseTemplateBrioche: "Brioche",
    phaseTemplateCroissant: "Viennoiserie / PLF",
    confirmReplacePhases: "Remplacer les étapes existantes par ce modèle ?",
    myTemplates: "Mes modèles",
    builtInTemplates: "Intégrés",
    enterTemplateName: "Nom du modèle…",
    deleteTemplate: "Supprimer le modèle",
    deleteBatch: "Supprimer la fournée",
    delayBetweenBatches: "Délai entre fournées",
    calculateTiming: "Calculer les horaires",
    calculateTimingHint: "Calcule automatiquement les horaires à partir de la première heure saisie, espacées par la durée de cuisson + le délai",
    recipeModified: "Recette modifiée",
    recipeModifiedHint: "Une ou plusieurs recettes ont été mises à jour. Cliquez sur « Générer l'organigramme » pour actualiser.",
    batchCount: "Nombre de fournées",
    batchLabel: "Fournée",
    defaultOven: "Four par défaut",
    defaultOvenOption: "Four par défaut",
    autoSuggestTimes: "Suggérer les horaires",
    autoSuggestHint: "Espacer les fournées en reculant par la durée de cuisson",
    noPhasesOrganigrammeHint: "Définissez les étapes de production dans l'éditeur de recette pour inclure cette recette dans l'organigramme.",
    phases: "étapes",
    baking: "Cuisson",
    cell: "case",
    timesAreApproximate: "Heures arrondies à 15 min pour l'affichage",
    and: "et",
    oven: "Four",
    selectEquipment: "Équipement",
    compressionNote: "Colonnes grisées : 1 case = 1 h (phases passives compressées). Autres colonnes : 1 case = 15 min.",
    printGeneratedOn: "Généré le",
    printGenerated: "Dialogue d'impression ouvert",
    // Étiquettes produit
    printLabel: "Imprimer les étiquettes",
    labelPrintModal: "Imprimer les étiquettes produit",
    labelSize: "Format d'étiquette",
    labelSizeSmall: "Petit (62×38mm) — Pot / Prix",
    labelSizeMedium: "Moyen (100×50mm) — Étiquette alimentaire standard",
    labelSizeLarge: "Grand (100×150mm) — Étiquette produit complète",
    labelSizeA4: "Feuille A4 (6 étiquettes par page)",
    labelSizeMarket: "Étiquette marché (pleine page, A4 / Letter)",
    labelPaper: "Papier",
    labelPaperA4: "A4",
    labelPaperLetter: "US Letter",
    labelMarketOnePerProduct: "1 page par produit",
    labelSizeThermal3x2: "Thermique (3×2 pouces) — Rouleau (pain défaut)",
    labelSizeThermal4x2: "Thermique (4×2 pouces) — Rouleau (grand)",
    labelCopies: "Copies",
    labelOptions: "Options d'étiquette",
    labelShowWeight: "Afficher le poids",
    labelShowPrice: "Afficher le prix",
    labelShowBestBefore: "Afficher le champ date limite",
    labelShowStorage: "Afficher les conditions de conservation",
    labelShowDisclaimer: "Afficher l'avertissement allergènes",
    labelStoragePlaceholder: "ex. : Conserver au réfrigérateur en dessous de 4°C",
    labelWeight: "Poids",
    labelNetWeight: "Poids net",
    labelBestBefore: "À consommer de préférence avant",
    labelPreview: "Aperçu de l'étiquette",
    labelNoIngredients: "Aucun ingrédient configuré",
    labelNoIngredientsHint: "Associez une recette ou configurez une liste personnalisée pour afficher les ingrédients",
    labelPopupBlocked: "Si la fenêtre d'impression ne s'ouvre pas, autorisez les popups pour ce site.",
    labelPrint: "Imprimer",
    labelClose: "Fermer",
    labelDisclaimerText: "Informations allergènes à titre indicatif; ne couvre pas la contamination croisée.",
    labelDisclaimerPlaceholder: "Saisir le texte d'avertissement allergènes…",
    // Étiquettes de production
    labelProductionTitle: "Imprimer les étiquettes de production",
    labelProductionTotal: "étiquettes au total",
    labelProductionProducts: "Produits et quantités",
    labelProductionSkipped: "Les produits décochés seront ignorés",
    printPickupDate: "Date de Collecte:",
    printTotalOrders: "Total des Commandes:",
    printTotalValue: "Valeur Totale:",
    printOrderNumber: "Commande #",
    printCustomer: "Client:",
    printPhone: "Téléphone:",
    printTotal: "Total:",
    printProduct: "Produit",
    printQuantity: "Quantité",
    printPrice: "Prix",
    printAmount: "Montant",
    printOrderTotal: "Total de la Commande",
    sortOrders: "Trier les Commandes",
    sortByCollectionPoint: "Trier par Point de Collecte",
    sortByTime: "Trier par Heure",
    sortByCustomer: "Trier par Client",
    sortByTotal: "Trier par Total",
    sortByNewest: "Plus Récent D'abord",
    sortByCustomerName: "Nom du Client",
    collectionPointSummary: "Résumé par Point de Collecte",
    productionPerCollectionPoint: "Production par Point de Collecte",
    totalQuantity: "Quantité Totale",
    collectionPointProduction: "Production du Point de Collecte",
    smartDefault: "Intelligent par Défaut",
    sortDefaultDescription: "Intelligent: Point de collecte d'abord, puis nom client",
    smartSortActive: "Tri intelligent actif",
    smartSortDescription: "Point de collecte d'abord, puis nom client",
    summaryProducts: "Produits",
    summaryOrders: "Commandes",
    unifiedProductionSummary: "Résumé de Production par Point de Collecte",
    productionTotal: "Total",
    productionSummary: "Résumé de Production",
    productionSummarySimple: "Résumé de Production",
    totalValue: "Valeur Totale",
    grandTotal: "TOTAL GÉNÉRAL",
    productBreakdown: "Répartition des Produits par Point de Collecte",

    // Standalone Products (no recipe)
    standaloneProducts: "Produits Autonomes",
    standaloneProductsDescription: "Produits sans recette (confiture, sacs à pain, etc.) pouvant être vendus directement",
    noStandaloneProducts: "Aucun produit autonome disponible. Créez des produits sans recette dans la gestion des produits.",
    quantityLimit: "Limite",
    unlimited: "Illimité",
    standaloneProductsSection: "Produits Autonomes",

    // Errors & Warnings
    selectBaseRecipeFirst: "Veuillez d'abord sélectionner une recette de base",
    noRecipeSelected: "Aucune recette sélectionnée",
    invalidVariationQuantity: "Veuillez entrer une quantité valide pour les ingrédients de variation",
    insufficientBaseDough: "Pâte de base insuffisante pour cette recette",
    selectRecipe: "Sélectionner une recette...",
addRecipeButton: "Ajouter Recette",

// Abonnement et Facturation
subscriptionRequired: "Abonnement Requis",
subscriptionRequiredDescription: "Commencez votre aventure de boulangerie avec un essai gratuit de 30 jours",
freeTrialBadge: "🎉 Essai Gratuit de 30 Jours",
month: "mois",
afterTrialEnds: "Après la fin de l'essai",
unlimitedProducts: "Produits illimités",
unlimitedOrders: "Commandes illimitées",
customerManagement: "Gestion des clients",
customBranding: "Image de marque personnalisée",
emailSupport: "Support par e-mail",
startFreeTrial: "Commencer l'Essai Gratuit",
redirectingToCheckout: "Redirection vers le paiement...",
securePaymentByStripe: "Paiement sécurisé par Stripe",
howTrialWorks: "Comment fonctionne l'essai gratuit",
trialDetail1: "Accès complet à toutes les fonctionnalités pendant 30 jours",
trialDetail2: "Aucune carte de crédit requise pour commencer",
trialDetail3: "Annulez à tout moment pendant l'essai",
notReadyYet: "Pas encore prêt? Je déciderai plus tard",
grandfatheredTitle: "Accès à Vie",
grandfatheredMessage: "Vous avez un accès gratuit à vie à Digi-Bakery!",
grandfatheredThankYou: "Merci d'être un des premiers supporters.",
subscriptionStatus: "Statut de l'Abonnement",
trialActive: "Essai Gratuit Actif",
daysRemaining: "jours restants",
trialEndsToday: "L'essai se termine aujourd'hui",
gracePeriodActive: "Profitez de l'accès gratuit",
daysRemainingToSubscribe: "jours restants",
gracePeriodEndsToday: "Dernier jour d'accès gratuit",
gracePeriodMessage: "Vous pouvez continuer à utiliser Digi-Bakery gratuitement. Ajoutez votre moyen de paiement quand vous voulez pour démarrer votre essai gratuit de 30 jours.",
gracePeriodBullet1: "Aucun prélèvement aujourd'hui",
gracePeriodBullet2: "Annulable à tout moment",
subscribeNow: "Démarrer l'essai gratuit",
gracePeriodExpired: "Période de Grâce Expirée",
gracePeriodExpiredMessage: "Votre période de grâce de 7 jours a expiré. Veuillez vous abonner pour continuer à utiliser Digi-Bakery.",
plan: "Plan",
monthlySubscription: "Abonnement Mensuel",
nextBillingDate: "Prochaine Date de Facturation",
paymentMethod: "Méthode de Paiement",
subscriptionCanceled: "Abonnement Annulé",
subscriptionCanceledMessage: "Votre abonnement a été annulé.",
canceledOn: "Annulé le",
resubscribe: "Se Réabonner",
chargedImmediately: "Facturé immédiatement",
subscribe: "S'abonner",
  resubscriptionDescription: "Continuez votre aventure de boulangerie",
  statusActive: "Actif",
  statusCanceled: "Annulé",
  statusTrialing: "Essai",
  statusPastDue: "En Retard",
  statusIncomplete: "Incomplet",
  statusNone: "Aucun Abonnement",
accessUntil: "Vous aurez accès jusqu'au",
manageBilling: "Gérer la Facturation",
cancelSubscription: "Annuler l'Abonnement",
confirmCancelSubscription: "Êtes-vous sûr de vouloir annuler votre abonnement? Vous conserverez l'accès jusqu'à la fin de votre période de facturation actuelle.",
subscriptionCancelSuccess: "Abonnement annulé avec succès. Vous aurez accès jusqu'à la fin de votre période de facturation.",
paymentHistory: "Historique des Paiements",
paymentDate: "Date",
succeeded: "Réussi",
failed: "Échoué",
refunded: "Remboursé",
subscription: "Abonnement",
billing: "Facturation",
subscriptionAndBilling: "Abonnement et Facturation",
subscriptionInactive: "Abonnement Inactif",
subscriptionInactiveMessage: "Votre abonnement est actuellement inactif. Veuillez mettre à jour votre méthode de paiement ou vous réabonner pour continuer à utiliser Digi-Bakery.",
gracePeriodWarning: "Paiement Échoué - Période de Grâce",
paymentGracePeriodMessage: "Votre paiement a échoué. Il vous reste {days} jours pour mettre à jour votre méthode de paiement avant que votre accès ne soit restreint.",
updatePaymentMethod: "Mettre à Jour la Méthode de Paiement",
reactivateSubscription: "Réactiver l'Abonnement",

// Order Payment (Customer Payments to Baker)
completePayment: "Finaliser le Paiement",
securePaymentPoweredByStripe: "Paiement sécurisé alimenté par Stripe",
stripeLegalDisclaimer: "Paiement traité de manière sécurisée par Stripe. digi-bakery.com ne gère ni ne stocke vos informations de paiement.",
stripePaymentIssuesInfo: "Pour les problèmes de paiement, remboursements ou rétrofacturations, contactez Stripe directement.",
stripeSupportLink: "Support Stripe",
paymentSecurityTitle: "Sécurité des paiements et résolution des litiges",
stripeProcessesPayments: "Stripe traite tous les paiements clients de manière sécurisée. digi-bakery.com ne stocke jamais et n'a jamais accès aux informations de carte de paiement.",
contactStripeForIssues: "Pour les problèmes de paiement, remboursements ou rétrofacturations, contactez le support Stripe directement.",
cardInformation: "Informations de Carte",
paymentOptions: "Options de Paiement",
configurePaymentMethods: "Configurez comment les clients peuvent payer les commandes",
onlinePayments: "Paiements en Ligne",
acceptCreditCardsOnline: "Accepter les cartes de crédit et portefeuilles numériques en ligne",
stripeAccountRequired: "Compte Stripe requis pour recevoir les paiements",
connectStripeAccount: "Connecter Compte Stripe",
connectWithStripe: "Connecter avec Stripe",
receivePaymentsDirectly: "Recevez les paiements directement sur votre compte bancaire",
automaticPayouts: "Virements automatiques tous les 2 jours",
noPlatformFees: "Aucun frais de plateforme - gardez 100% (moins les frais Stripe)",
secureConnectionByStripe: "Connexion sécurisée par Stripe",
understandOnlinePayments: "Comprendre les paiements en ligne",
cashAtPickup: "Espèces à la Collecte",
acceptCashPayment: "Accepter les espèces lors de la collecte des commandes",
cardAtPickup: "Carte à la Collecte",
acceptCardAtLocation: "Accepter les paiements par carte sur place",
selectPaymentMethod: "Choisir le Mode de Paiement",
payOnline: "Payer en Ligne",
payAtPickup: "Payer à la Collecte",
payNow: "Payer Maintenant",
proceedToPayment: "Procéder au Paiement",
paymentRequired: "Paiement Requis",
paymentSuccessful: "Paiement Réussi !",
paymentFailed: "Paiement Échoué",
refundOrder: "Rembourser la Commande",
refundSuccessful: "Remboursement Réussi",
paymentStatus: "Statut du Paiement",
paidOnline: "Payé en Ligne",
unpaid: "Non Payé",
paymentPending: "En Attente",
paid: "Payé",
paymentRefunded: "Remboursé",
orderPaymentSettings: "Paramètres de Paiement des Commandes",
enableOnlinePayments: "Activer les Paiements en Ligne",
requireOnlinePayment: "Exiger le Paiement en Ligne",
requireOnlinePaymentDescription: "Les clients doivent payer en ligne avant de passer commande",
acceptedPaymentMethods: "Modes de Paiement Acceptés",
onlinePaymentEnabled: "Paiement en ligne activé",
onlinePaymentDisabled: "Paiement en ligne désactivé",
cashOnly: "Espèces Uniquement",
selectHowToPay: "Sélectionnez comment vous souhaitez payer",
securePayment: "Paiement sécurisé par Stripe",
processingPayment: "Traitement du paiement...",
paymentProcessing: "Traitement du Paiement",
redirectingToStripe: "Redirection vers le paiement Stripe...",
paymentProceedToPayment: "Procéder au Paiement",
paymentCanceled: "Paiement Annulé",
paymentCanceledMessage: "Votre paiement a été annulé. Aucun montant n'a été débité de votre carte.",
orderNotPlaced: "Votre commande n'a pas été passée. Vous pouvez réessayer ou payer au retrait.",
orderConfirmedPaid: "Commande Confirmée & Payée",
viewMyOrders: "Voir Mes Commandes",
autoRedirectIn: "Redirection automatique dans",
needHelp: "Besoin d'aide ?",
contactSupport: "Contacter le support",
paymentNotCompleted: "Le paiement n'a pas été complété",
returnToShop: "Retour à la Boutique",
viewReceipt: "Voir le Reçu",
viewBatchImage: "Voir la photo du lot",
attachBatchImage: "Ajouter photo du lot",
replaceBatchImage: "Remplacer photo du lot",
batchImage: "Photo du Lot",
downloadReceipt: "Télécharger le Reçu",
refundReason: "Raison du Remboursement",
refundAmount: "Montant du Remboursement",
processRefund: "Traiter le Remboursement",
refundConfirmation: "Êtes-vous sûr de vouloir rembourser cette commande ?",
stripeAccountConnectedSuccess: "Compte Stripe connecté avec succès !",
missingInformation: "Informations manquantes",
refreshingStatus: "Actualisation du statut du compte...",
paymentCountry: "Pays",
openDashboard: "Ouvrir le Tableau de Bord",
stripeConnected: "Stripe Connecté",
readyToAcceptPayments: "Prêt à Accepter les Paiements",
paymentStatusUnpaid: "Non Payé",
paymentStatusPending: "En Traitement",
paymentStatusPendingPaymentMethod: "En Attente de Carte",
paymentStatusPaymentMethodSaved: "Carte Enregistrée",
paymentStatusPendingAuthorization: "Autorisation en Cours",
paymentStatusAuthorized: "Autorisé",
paymentStatusRequiresCustomerAction: "Action Requise",
paymentStatusAuthorizationFailed: "Échec d'Autorisation",
paymentStatusAuthorizationExpired: "Autorisation Expirée",
paymentStatusVoided: "Annulé",
paymentStatusPaid: "Payé",
paymentStatusFailed: "Échoué",
paymentStatusRefunded: "Remboursé",

// Authorization/Capture Payment Statuses
authorizedOrders: "Commandes Autorisées",
paymentAuthorized: "Paiement Autorisé",
authorizationVoided: "Autorisation Annulée",
capturePayment: "Capturer le Paiement",
captureAll: "Tout Capturer",
declineOrder: "Refuser la Commande",
paymentCaptured: "Paiement Capturé avec Succès",
captureFailed: "Échec de la Capture du Paiement",
declineFailed: "Échec du Refus de la Commande",
authorizationExpired: "Autorisation Expirée",
willAutoCaptureAt: "Capture automatique à",
authExpiresIn: "L'autorisation expire dans",
cardSaved: "Paiement programmé",
awaitingAuthorization: "En Attente d'Autorisation",
actionRequired: "Action Requise",
authFailed: "Échec de l'Autorisation",
voidAuthorization: "Annuler l'Autorisation",
voidConfirmation: "Êtes-vous sûr de vouloir annuler cette autorisation? Cela annulera la commande.",
voidReason: "Raison de l'Annulation",
voidSuccessful: "Autorisation Annulée avec Succès",
batchCaptureConfirmation: "Êtes-vous sûr de vouloir capturer {count} paiements?",
batchCaptureSuccess: "{successful} paiements capturés avec succès, {failed} échoués",
authorizationDetails: "Détails de l'Autorisation",
authorizedAmount: "Montant Autorisé",
captureScheduledFor: "Capture Prévue Pour",
daysUntilExpiry: "{days} jours jusqu'à l'expiration",
hoursUntilCapture: "{hours} heures jusqu'à la capture",

cannotDeleteProduct: "Impossible de supprimer le produit - il est actuellement utilisé:",
productUsedInProduction: "Le produit est utilisé dans {count} jour(s) de production",
productUsedInOrders: "Le produit est référencé dans {count} commande(s) client(s)",
productUsedInTemplates: "Le produit est utilisé dans {count} modèle(s) de production",
includingFuturePlans: "(Y compris {count} jour(s) de production futur(s)/actif(s))",
includingRecentOrders: "(Y compris {count} commande(s) récente(s))",
toDeleteProduct: "Pour supprimer ce produit:",
removeFromProduction: "1. Retirez-le de tous les jours et modèles de production",
considerOrderHistory: "2. Considérez si la suppression affectera l'historique des commandes",
tryAgain: "3. Réessayez une fois qu'il n'est plus référencé",
deleteProductConfirm: "Supprimer \"{productName}\"? Cette action ne peut pas être annulée.",
dangerDeleteProduct: "DANGER: Vous êtes sur le point de supprimer un produit activement utilisé!",
willCauseErrors: "Cela causera:",
productionPlanningErrors: "• Erreurs de planification de production",
orderDisplayIssues: "• Problèmes d'affichage des commandes",
brokenReports: "• Rapports cassés",
typeForceDelete: "Tapez \"FORCE DELETE\" pour confirmer:",
forceDelete: "Suppression Forcée",
deletionCancelled: "Suppression annulée pour sécurité.",
productDeletedWarning: "Produit supprimé, mais cela peut causer des problèmes dans:",
checkForErrors: "Veuillez vérifier vos jours de production et commandes pour des erreurs.",
productDeletedSuccess: "Produit supprimé avec succès!",

// Order Deletion
cancelOrders: "Annuler les Commandes Sélectionnées",
cancelOrderConfirmTitle: "Confirmer l'Annulation de Commande",
cancelOrderConfirm: "Êtes-vous sûr de vouloir annuler la(les) commande(s) sélectionnée(s) ? Les commandes seront marquées comme annulées et resteront dans vos archives.",
ordersCancelled: "Commande(s) annulée(s) avec succès !",

// Announcements
announcements: "Annonces",
newAnnouncement: "Nouvelle Annonce",
editAnnouncement: "Modifier l'Annonce",
title: "Titre",
message: "Message",
announcementActive: "Actif",
inactive: "Inactif",
style: "Style",
info: "Info",
warning: "Avertissement",
error: "Erreur",
rotationInterval: "Intervalle de Rotation (secondes)",
rotationIntervalDescription: "Combien de temps afficher chaque annonce avant de tourner (3-60 secondes)",
announcementTitle: "Titre de l'Annonce",
announcementMessage: "Message de l'annonce...",
noAnnouncements: "Aucune annonce encore",
createFirstAnnouncement: "Créez votre première annonce",
confirmDeleteAnnouncement: "Êtes-vous sûr de vouloir supprimer cette annonce ?",
errorSavingAnnouncement: "Erreur lors de l'enregistrement de l'annonce",
errorDeletingAnnouncement: "Erreur lors de la suppression de l'annonce",
titleAndMessageRequired: "Le titre et le message sont requis",
dismiss: "Ignorer",
activate: "Activer",
deactivate: "Désactiver",
from: "Du",
startDate: "Date de début",
endDate: "Date de fin",

// Sales Reconciliation
salesReconciliation: "Rapprochement des Ventes",
completedProductionDays: "Jours de Production Terminés",
selectProductionDay: "Sélectionner un Jour de Production",
selectCompletedDayToReconcile: "Sélectionnez un jour de production terminé pour rapprocher les ventes",
noCompletedProductionDays: "Aucun jour de production terminé trouvé",
reconciled: "Rapproché",
saveReconciliation: "Sauvegarder le Rapprochement",
salesReconciliationSaved: "Rapprochement des ventes sauvegardé avec succès !",
// Météo du jour de vente
weatherOfTheDay: "Météo du jour",
weatherLoading: "Récupération de la météo…",
weatherPickCondition: "Choisissez la météo du jour",
weatherAutoWas: "auto :",
weatherRefresh: "Actualiser",
weatherUnavailable: "Météo indisponible pour le moment — vous pouvez quand même choisir le temps.",
weatherNoLocation: "Ajoutez votre code postal et votre ville dans les Paramètres pour enregistrer la météo automatiquement.",
postalCodeCityRequired: "Merci d'indiquer votre code postal et votre ville.",
locationReminderTitle: "Indiquez le code postal et la ville de votre fournil",
locationReminderText: "Obligatoire pour compléter le profil de votre fournil — utilisé par les fonctionnalités liées au lieu, comme le suivi météo.",
locationReminderButton: "Compléter",
weatherGoToSettings: "Aller aux Paramètres",
weatherSunny: "Ensoleillé",
weatherPartlyCloudy: "Éclaircies",
weatherCloudy: "Nuageux",
weatherFog: "Brouillard",
weatherDrizzle: "Bruine",
weatherRain: "Pluie",
weatherSnow: "Neige",
weatherStorm: "Orage",
seasonSpring: "Printemps",
seasonSummer: "Été",
seasonAutumn: "Automne",
seasonWinter: "Hiver",
postalCode: "Code postal",
countryAddressHint: "Définit aussi la devise utilisée dans l'application (voir Paramètres de l'application).",
addressProvince: "Province",
addressState: "État",
addressRegionChoose: "Choisir…",
city: "Ville",
postalCodeWeatherHint: "Obligatoire. Utilisé par les fonctionnalités liées au lieu, comme le suivi météo.",
postalCodeSuggestedHint: "Proposé à partir de votre adresse — vérifiez puis enregistrez pour confirmer.",
weatherLocationNotFound: "Lieu introuvable — vérifiez le code postal et la ville.",
weatherLocationNotFoundToast: "Paramètres enregistrés, mais le code postal / la ville n'a pas été trouvé. Merci de vérifier.",
weatherAnalysisMenu: "Ventes & météo",
weatherAnalysisTitle: "Ventes & météo",
weatherDaysWithWeather: "jours rapprochés ont la météo",
weatherDaysReconciled: "jours de production terminés sont rapprochés",
weatherDaysNotReconciled: "non rapprochés (exclus de l'analyse)",
weatherGoReconcile: "Rapprocher",
weatherBackfillButton: "Récupérer la météo de {count} jours passés",
weatherBackfilling: "Récupération de la météo…",
weatherBackfillDone: "Météo ajoutée à {count} jours",
weatherMetric: "Afficher",
weatherMetricRevenue: "Chiffre d'affaires moyen par jour",
weatherMetricSold: "Unités vendues en moyenne par jour",
weatherMetricSellThrough: "Écoulement (% de la production vendue)",
weatherSellThroughHint: "L'écoulement ne compte que les jours où les quantités produites ont été saisies à la fin de la production.",
weatherAllProducts: "Tous les produits",
weatherWeekday: "Jour de la semaine",
weatherAllDays: "Tous les jours",
weatherFrom: "Du",
weatherTo: "Au",
weatherNoData: "Aucun jour rapproché avec météo pour ces filtres.",
weatherByCondition: "Selon la météo",
weatherByTemperature: "Selon la température max",
weatherBySeason: "Selon la saison",
weatherProductIndexTitle: "Produits selon la météo",
weatherProductIndexHint: "Unités vendues en moyenne selon la météo, comparées à la moyenne du produit par jour de vente. Seuls les jours où le produit a été fabriqué ou vendu comptent. Les cases avec moins de {min} jours sont grisées.",
weatherAvgPerDay: "Moy. / jour de vente",
weatherDays: "jours",
weatherNotEnoughData: "pas assez de données",
applicationSettings: "Paramètres de l'application",
dateFormatDescription: "Choisissez comment les dates sont affichées dans toute l'application",
weatherTracking: "Suivi météo",
weatherTrackingDescription: "Enregistre la météo de chaque jour de vente au rapprochement, affiche la prévision lors de la planification de la production et ajoute le rapport « Ventes & météo ». Utilise votre code postal et votre ville.",
weatherTrackingOffMessage: "Le suivi météo est désactivé. Activez-le dans Paramètres → Paramètres de l'application pour enregistrer la météo de vos jours de vente et voir son effet sur vos ventes. La météo déjà enregistrée est conservée.",
forecastTitle: "Prévision pour le jour de vente",
forecastObservedTitle: "Météo du jour de vente",
forecastObserved: "observée (enregistrée au rapprochement)",
forecastObservedShort: "observée",
forecastTrendHint: "prévision à {days} jours — tendance, peut changer",
forecastIndicativeHint: "prévision à {days} jours — indicative seulement",
weatherFamily_dry: "ensoleillés",
weatherFamily_grey: "gris",
weatherFamily_wet: "pluvieux",
weatherFamily_snow: "enneigés",
insightExpected: "Prévision : {condition} le {day}",
insightSameWeekday: "Vos {weekday}s {family} passés ({n} jours), comparés à vos ventes habituelles ce jour-là :",
insightAnyDay: "Pas encore assez de {weekday}s comparables — sur tous vos jours {family} passés ({n} jours) :",
insightNotEnough: "Pas encore assez d'historique pour les {weekday}s {family} ({n} jours). Les tendances s'affineront au fil de vos rapprochements.",
insightProductTooltip: "{match} vendus en moyenne ces jours-là contre {all} d'habitude ({n} jours)",
insightShowAll: "Tout afficher ({n})",
insightShowLess: "Réduire",
insightFootnote: "D'après vos ventes rapprochées — à titre indicatif, les quantités ne sont pas modifiées. Les précommandes sont retirées quel que soit le temps.",
productsSold: "Produits Vendus",
reconciliationTotalOrdered: "Précommandes",
reconciliationTotalSold: "Total Vendu",
product: "Produit",
reconciliationOrdered: "Commandé",
reconciliationSold: "Vendu",
reconciliationProduced: "Qté produite",
reconciliationProducedTooltip: "Unités produites, enregistrées à la fin de la production",
reconciliationOversoldUnits: "Plus d'unités vendues que produites — vérifiez les quantités vendues",
productionDoughSummary: "Pâte produite vs ventes",
producedDough: "Pâte produite",
doughSold: "Pâte vendue",
remainingDough: "Pâte restante",
recipeBalance: "Pâte restante après ventes",
actualProduction: "Production réelle",
plannedProduction: "Production planifiée",
doughOversoldWarning: "⚠ Les ventes dépassent la pâte produite pour au moins une recette.",
doughWithinProduction: "✓ Les ventes sont dans la limite de la pâte produite.",
noProductionData: "Aucune donnée de production par recette pour ce jour.",
unknownRecipe: "Recette inconnue",
noRecipeGroup: "Autres produits",
reconciliationOtherRevenue: "Autres Revenus",
reconciliationTipsAndOtherSales: "Pourboires et Autres Ventes",
reconciliationOtherRevenueDescription: "Inclure les pourboires, ventes supplémentaires, ou tout autre revenu non capturé dans les ventes de produits",
preOrdersOnly: "Précommandes uniquement",
orderedPreOrdersTooltip: "Précommandes uniquement (informatif)",
doughOversoldInline: "⚠️ Vendu plus que produit ({amount})",
recipeDoughEquation: "{produced} produit − {sold} vendu = {remaining} restant",
needsReconciliation: "Nécessite un rapprochement",
clickOnHighlightedDay: "Cliquez sur un jour en surbrillance pour rapprocher les ventes. Le vert plus clair indique les jours déjà rapprochés.",
reconciliationOverview: "Aperçu du Rapprochement",
totalCompletedProductionDays: "Total des jours de production terminés",
itemsSold: "Articles vendus",
reconciliationSummary: "Résumé du Rapprochement",
totalRevenueForDay: "Revenu total pour",

// Admin Settings (Date/Time Preferences)
adminSettings: "Paramètres Admin",
personalInfo: "Informations Personnelles",
dateTimePreferences: "Préférences Date & Heure",
dateFormatPreference: "Format de Date",
timeFormat: "Format d'Heure",
timezonePreference: "Fuseau Horaire",
showTimezones: "Toujours afficher les fuseaux horaires",
preview: "Aperçu",
adminSettingsDescription: "Gérez votre profil et vos préférences de date/heure",
exchangeRatesTitle: "Taux de Change",
exchangeRatesDescription: "Configurez les taux de change pour la conversion des revenus en USD",
baseCurrency: "Devise de Base (USD)",
saveExchangeRates: "Enregistrer les Taux",
exchangeRatesSaved: "Taux de change enregistrés avec succès",
exchangeRatesSaveError: "Échec de l'enregistrement des taux de change",
formatUS: "Format US",
formatEuropean: "Format Européen",
formatISO: "Format ISO",
format12Hour: "12 heures",
format24Hour: "24 heures",

// Help Center
helpCenter: "Centre d'Aide",
helpCenterDescription: "Guides et tutoriels pour utiliser Digi-Bakery",
searchTutorials: "Rechercher des tutoriels...",
allChapters: "Tous les Chapitres",
allTutorials: "Tous les Tutoriels",
videosInChapter: "vidéos",
videoInChapter: "vidéo",
gettingStarted: "Pour Commencer",
duration: "Durée",
watchVideo: "Regarder la Vidéo",
previousVideo: "Précédent",
nextVideo: "Suivant",
relatedVideos: "Vidéos Associées",
noResults: "Aucun tutoriel trouvé",
noResultsDescription: "Essayez d'ajuster votre recherche ou parcourez par chapitre",
closeVideo: "Fermer",
otherVideosInChapter: "Autres vidéos de ce chapitre",
chapter: "Chapitre",
sortBy: "Trier par",
sortByChapter: "Par Chapitre",
searching: "Recherche de",
noResultsFor: "Aucun résultat pour",
trySearching: "Essayez de rechercher",
popularSearches: "Recherches populaires",
searchTip: "Astuce : Vous pouvez rechercher par sujet, chapitre ou titre de vidéo",
sortByDuration: "Par Durée",

// Chapter Titles
chapter1Title: "Configurer",
chapter2Title: "Créer",
    chapter3Title: "Planifier",
    chapter4Title: "Vendre",
    chapter5Title: "Analyser",
    chapter6Title: "Astuces & Conseils",

    // Help Center Contact
    contactHelpCenter: "Besoin d'aide supplémentaire ?",
    contactHelpCenterDescription: "Envoyez-nous un message et nous vous répondrons rapidement.",

    // Pickup Mode
    pickupModeNav: "Retrait",
    pickupMode: "Mode Retrait",
    filterOpen: "En attente",
    filterPicked: "Récupéré",
    sortByName: "Par nom",
    confirmPickup: "Confirmer le retrait",
    cancelPickup: "Annuler",
    orderPickedUp: "Récupéré",
    pendingSync: "sync en attente",
    syncNow: "Synchroniser",
    syncSuccess: "Tous les retraits synchronisés",
    syncError: "Échec de sync — appuyer pour réessayer",
    offlineStatus: "Hors ligne",
    onlineStatus: "En ligne",
    syncingStatus: "Synchronisation…",
    offlineBanner: "Mode hors ligne — les retraits seront synchronisés automatiquement.",
    pickupConfirmTitle: "Confirmer le retrait",
    alreadyPickedUpConflict: "Cette commande a déjà été récupérée sur un autre appareil.",
    collectionPointAll: "Tous les points",

    // Market Mode
    marketModeNav: "Marché",
    marketMode: "Mode Marché",
    marketModeTitle: "Mode Marché / Retrait",
    marketModeSubtitle: "Enregistrer les ventes sur votre stand",
    noCompletedProduction: "Aucune journée de production terminée. Complétez votre plan de production d'abord.",
    selectProductionDayForMarket: "Sélectionner une journée de production",
    marketAvailableStock: "Disponible",
    marketSoldCount: "Vendu",
    marketOverPlan: "Hors plan",
    marketSoldOut: "Épuisé",
    marketTotalRevenue: "Revenu de session",
    marketPendingSales: "sync en attente",
    marketSyncSuccess: "Toutes les ventes synchronisées",
    marketSyncError: "Échec de sync — appuyer pour réessayer",
    marketOfflineBanner: "Mode hors ligne — les ventes seront synchronisées automatiquement.",
    endMarketDay: "Terminer la session marché",
    marketSessionSummary: "Résumé de session",
    marketSoldThisSession: "Vendu cette session",
    marketGoToReconciliation: "Aller à la réconciliation des ventes",
    marketContinueSelling: "Continuer à vendre",
    marketNoProducts: "Aucun produit trouvé pour cette journée de production.",
    marketStockFromProduction: "Stock du plan de production",
    marketPreOrdersDeducted: "Pré-commandes déduites",
    marketHybridNote: "Mode hybride : les pré-commandes sont suivies séparément. Stock disponible = produit − pré-commandes.",
    marketSellOne: "Vendre 1",
    marketUndoLast: "Annuler",
    marketQtyPicker: "Vendre en quantité",
    marketSales: "Ventes marché / sur place",
    onsiteSales: "Ventes enregistrées via le Mode Marché",

    // Tarification professionnelle
    customerManagementNav: "Gestion clients",
    professionalCustomers: "Clients professionnels",
    inviteProfessional: "Inviter un client professionnel",
    professionalPrice: "Prix professionnel",
    professionalBadge: "PRO",
    inviteSent: "Invitation envoyée",
    pendingInvite: "En attente",
    activeCustomer: "Actif",
    expiredInvite: "Expirée",
    cancelledInvite: "Annulée",
    cancelInvite: "Annuler l'invitation",
    resendInvite: "Renvoyer",
    acceptInvite: "Activer l'accès professionnel",
    inviteAccepted: "Accès activé",
    inviteExpired: "Cette invitation a expiré. Veuillez contacter la boulangerie.",
    inviteInvalid: "Lien d'invitation invalide.",
    inviteAlreadyAccepted: "Cette invitation a déjà été utilisée.",
    inviteEmailMismatch: "Cette invitation a été envoyée à une autre adresse e-mail. Connectez-vous avec le bon compte.",
    companyName: "Nom de l'entreprise",
    professionalLabel: "Type",
    allCustomers: "Tous les clients",
    invitations: "Invitations",
    noCustomersYet: "Aucun client pour l'instant",
    noInvitationsYet: "Aucune invitation pour l'instant",
    customerType: "Type",
    onlineCustomer: "En ligne",
    offlineCustomer: "Hors ligne",
    editCustomerRelationship: "Modifier",
    saveRelationship: "Enregistrer",
    deleteRelationship: "Supprimer",
    relationshipNotes: "Notes",
    professionalPriceLabel: "Prix pro",
    activatingAccess: "Activation de votre accès professionnel…",
    signInToAcceptInvite: "Connectez-vous pour activer votre accès professionnel",

    // Shop QR Code
    shopQRCodeTitle: "QR Code de la boutique",
    shopQRCodeDescription: "Imprimez ce QR code sur votre stand de marché, vos cartes de visite, flyers ou emballages pour que vos clients accèdent instantanément à votre boutique en ligne.",
    shopQRCodePublishFirst: "Publiez votre boutique en ligne avant de générer un QR code.",
    shopQRCodeError: "Nous n'avons pas pu générer votre QR code. Veuillez rafraîchir la page et réessayer.",
    downloadPNG: "Télécharger PNG",
    downloadSVG: "Télécharger SVG",

  }  // End of fr (French translations)
};

// Helper function to get translation
export const t = (key, language = 'en', params = {}) => {
  let text = translations[language]?.[key] || translations['en'][key] || key;
  
  // Replace parameters like {count}, {percent}, etc.
  Object.keys(params).forEach(param => {
    text = text.replace(`{${param}}`, params[param]);
  });
  
return text;
};
